import React, {
  useContext,
  useEffect,
  useRef,
  useState,
} from 'react';
import {
  faCheck,
  faCircle,
  faInfoCircle,
  faTimesCircle,
  faSearch,
  faSpinner,
  faExclamationCircle
} from '@fortawesome/free-solid-svg-icons';
import { faCircle as faCircleRegular } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import IconIdle from '../../../../common/icon-search-idle';
import {
  QuantaFormik,
  QuantaForm,
  useQuantaFormikContext,
  useResponsiveParams,
  MixedGridGroup,
  SearchResultsModal,
  QuantaRadioGroup,
  QuantaInput,
  Text,
  Label,
  Grid,
  GridItem,
  Button
} from 'quanta-ui';
import {
  faSave,
  faCalculator
} from '@fortawesome/free-solid-svg-icons';
// import Parse from '../../../../../lib/intl/CurrencyFormater';
import { CurrencyFormater } from 'quanta-flows';
import { useQuery } from '@apollo/client';
// import { Error, Loading } from '../../../../../lib/layout';
import { Error,Loading } from 'quanta-flows/modules/layout';
import {
  CUSTOMER_DROPDOWN_DETAIL,
  FINANCER_DROPDOWN_DETAILS,
  GET_CUSTOMER_TYPE_DOMAIN,
  GET_DATE_TIME,
  GET_FIELDUSER_LIST,
  GET_INTERMEDIARY_LIST,
  GET_VIEW_RENEW_MOTOR_POLICY_VAR_DETAILS,
  LOAD_USER_PROFILE,
  MOBILE_NUMBER_STARTING_WITH,
  FINANCIER_NAME_LIST,
  PINCODE_LOOKUP,
  PROPOSAL_PAYMENT_TYPE_LIST,
  SUBMIT_RENEWAL_TW,
  PROPOSER_DROPDOWN_DETAIL,
  CALCULATE_PREMIUM_FOR_PROPOSAL_TW
} from '../queries';
// import useFetchQuery from '../../../../../lib/graphql/useFetchQuery';
import { useFetchQuery } from 'quanta-flows';
// import useMutationQuery from '../../../../../lib/graphql/useMutationQuery';
import { useMutationQuery } from 'quanta-flows';
// import { ConfigContext } from '../../../../../lib/config/ConfigProvider';
import { QuantaConfigContext } from 'quanta-flows';
// import { updateViewRenewMotorPolicyVar } from '../_graphql/state';
import { updateViewRenewMotorPolicyVar } from 'quanta-flows/modules/policy/renewal/motor/state';
// import {
//   updateAllIntermediaryFields,
//   updateBusinessLocation,
//   updateFieldUser,
//   updateIntermediary,
// } from '../../../../common/intermediary-select/_graphql/state';
import {  updateAllIntermediaryFields,
  updateBusinessLocation,
  updateFieldUser,
  updateIntermediary, } from 'quanta-flows/modules/common/intermediary/state';
// import ProposerCustomerEditable from '../../../../common/proposer-customer/proposer-customer-editable';
import { ProposerCustomerEditable } from 'quanta-flows/modules/common/proposer/edit';
import moment from 'moment'

export default function ReviewAndConfirmDetails({
  setParentAlerts,
  setLoadingStep,
  setCustomLoadingMessage,
  planName,
  planCode,
  renewalMode,
  expandedCard,
  renderExpandedCards,
  lobCode,
  lobName,
  productCode,
  productName,
  productType,
  setEnableRenew,
  UWCompleted,
  modify,
  ...props
}) {
  const fetchQuery = useFetchQuery();
  const mutateQuery = useMutationQuery();
  const { branding } = useContext(QuantaConfigContext);
  const initLoadRef = useRef([]);

  const {
    loading: loadingMobileNumberLength,
    error: errorMobileNumberLength,
    data: dataMobileNumberLength,
  } = useQuery(MOBILE_NUMBER_STARTING_WITH, {
    fetchPolicy: 'cache-first',
    onCompleted: (_) => {
      initLoadRef.current = [...initLoadRef?.current, 9];
    },
  });

  const {
    loading: loadingMyIntermediaries,
    error: errorMyIntermediaries,
    data: dataMyIntermediaries,
  } = useQuery(GET_INTERMEDIARY_LIST, {
    fetchPolicy: 'cache-first',
    onCompleted: (data) => {
      const { myIntermediaries } = data;
      const defaultIntermediary = myIntermediaries?.find(
        (imd) => imd.isSelected,
      );
      const defaultBusinessLocation = myIntermediaries?.find(
        (imd) => imd.isSelected,
      )?.businessLocations[0];
      updateIntermediary(
        defaultIntermediary?.intermediaryCode,
        defaultIntermediary?.intermediaryName,
      );
      updateBusinessLocation(
        defaultBusinessLocation?.code,
        defaultBusinessLocation?.name,
      );
      initLoadRef.current = [...initLoadRef?.current, 8];
    },
  });

  const {
    loading: loadingProfileData,
    error: errorProfileData,
    data: profileData,
  } = useQuery(LOAD_USER_PROFILE, {
    fetchPolicy: 'cache-first',
    onCompleted: (data) => {
      const { checkAuth, userMyDetail } = data;
      const { associatedCoreEntity } = checkAuth.organisation;
      const { userType } = userMyDetail;
      if (userType?.typeName.toLowerCase() === 'field user') {
        updateFieldUser(
          associatedCoreEntity.type,
          associatedCoreEntity.value,
        );
      } else {
        updateFieldUser('', '');
      }
      initLoadRef.current = [...initLoadRef?.current, 7];
    },
  });

  const {
    loading: loadingFinancerDropDownDetails,
    error: errorFinancerDropdownDetails,
    data: dataFinancerDropdownDetails,
  } = useQuery(FINANCER_DROPDOWN_DETAILS, {
    fetchPolicy: 'cache-first',
    variables: {
      productCode,
    },
    onCompleted: (_) => {
      initLoadRef.current = [...initLoadRef?.current, 6];
    },
  });

  const {
    loading: loadingPaymentType,
    error: errorPaymentType,
    data: dataPaymentType,
  } = useQuery(PROPOSAL_PAYMENT_TYPE_LIST, {
    fetchPolicy: 'cache-first',
    onCompleted: (_) => {
      initLoadRef.current = [...initLoadRef?.current, 5];
    },
  });

  const {
    loading: dateTimeLoading,
    error: errorTimeLoading,
    data: dateTimeData,
  } = useQuery(GET_DATE_TIME, {
    fetchPolicy: 'cache-first',
    onCompleted: (_) => {
      initLoadRef.current = [...initLoadRef?.current, 4];
    },
  });

  const {
    loading: loadingCustTypeDomain,
    error: errorCustTypeDomain,
    data: dataCustTypeDomain,
  } = useQuery(GET_CUSTOMER_TYPE_DOMAIN, {
    fetchPolicy: 'cache-first',
    onCompleted: (_) => {
      initLoadRef.current = [...initLoadRef?.current, 3];
    },
  });

  const {
    loading: loadingDropDownDetails,
    error: errorDropDownDetails,
    data: dataDropDownDetails,
  } = useQuery(CUSTOMER_DROPDOWN_DETAIL, {
    fetchPolicy: 'cache-first',
    onCompleted: (_) => {
      initLoadRef.current = [...initLoadRef?.current, 2];
    },
  });
  const { loading: loadingdrop, data: dropDownDetails } = useQuery(
    PROPOSER_DROPDOWN_DETAIL,
    {
      fetchPolicy: 'cache-first',
      onCompleted: (_) => {
        initLoadRef.current = [...initLoadRef?.current, 2];
      },
      variables: {
        productCode
          : "3191",
      },
    },
  );
  const { loading, error, data, previousData } = useQuery(
    GET_VIEW_RENEW_MOTOR_POLICY_VAR_DETAILS,
    {
      fetchPolicy: 'cache-first',
      //skip: new Set(initLoadRef?.current)?.size >= 9,
      onCompleted: async (data) => {
        if (
          data?.viewRenewMotorPolicy?.proposalNumber &&
          data?.selectedIntermediary?.intermediaryCode
        ) {
          initLoadRef.current = [...initLoadRef?.current, 1];
          if (
            !data?.viewRenewMotorPolicy?.vehicleTabDetails
              ?.vehicleRegistrationDetails?.registrationNumber ||
            data?.viewRenewMotorPolicy?.vehicleTabDetails?.vehicleRegistrationDetails?.registrationNumber?.toLowerCase() ===
              'new'
          ) {
            renderExpandedCards.current = [
              ...renderExpandedCards?.current?.slice(0, 2),
              true,
              ...renderExpandedCards?.current?.slice(3),
            ];
            expandedCard.current = [
              ...expandedCard.current.filter(
                (exp) =>
                  exp?.cardName !== 'vehicleAndRegistrationDetails',
              ),
              {
                ...expandedCard.current.find(
                  (exp) =>
                    exp?.cardName === 'vehicleAndRegistrationDetails',
                ),
                cardFlag: true,
                subSections: [
                  ...expandedCard.current.find(
                    (exp) =>
                      exp?.cardName ===
                      'vehicleAndRegistrationDetails',
                  )?.subSections,
                  'vehicleRegistrationDetails',
                ],
              },
            ];
            updateViewRenewMotorPolicyVar({
              isProposalReadyForRenewal: false,
            });
          }
        }
      },
    },
  );
  const repeatForDesktop = 3,
    repeatForMobile = 1;

  const repeat = useResponsiveParams({
    for_mobile: repeatForMobile,
    for_desktop: repeatForDesktop,
  });

  const repeatFormsReadOnly = useResponsiveParams({
    for_mobile: 2,
    for_desktop: 3,
  });

  const repeatFormsonEdit = useResponsiveParams({
    for_mobile: 1,
    for_desktop: 3,
  });

  const changeInputType = useResponsiveParams({
    for_mobile: 'input-lookup',
    for_desktop: 'text',
  });
  const colSpanParams = useResponsiveParams({
    for_mobile: { searchString: 8, button: 2 },
    for_desktop: { searchString: 4, button: 1 },
  });
  const modalSizeExternal = useResponsiveParams({
    for_desktop: 'large',
    for_mobile: 'small',
    for_iPad: 'large',
  });
  const validate = (values) => {
    let errors = {};
    errors.proposerDetails = {};
    errors.vehicleTabDetails = {};
    errors.intermediaryData = {};
    errors.additionalTabDetails= {};
    let errorCount = 0;
    if (values?.countEditsOpen !== 0) {
      errors.countEditsOpen =
        '* Data should be saved before proceeding';
      errorCount += 1;
    }
    if (!values?.intermediaryData?.intermediary) {
      errors.intermediaryData.intermediary = '* Required';
    }
    if (!values?.intermediaryData?.businessLocation) {
      errors.intermediaryData.businessLocation = '* Required';
    }
    /* Proposer Form Start*/
    if (viewRenewMotorPolicy?.coverData?.addOnCovers?.[`Owner Driver`]?.selected==true&&
    viewRenewMotorPolicy?.proposerDetails?.customerType=='Individual'){
   
    if(!values?.additionalTabDetails?.nomineeDetails?.nomineeDob){
      errors.additionalTabDetails.nomineeDetails = {};
      errors.additionalTabDetails.nomineeDetails.nomineeDob ='* Required'
    }
    if(!values?.additionalTabDetails.nomineeDetails.nomineeName){
      errors.additionalTabDetails.nomineeDetails = {};
      errors.additionalTabDetails.nomineeDetails.nomineeName ='* Required'
    }
    let MINOR_THRESHOLD_AGEE= 18;

    if (
      values?.additionalTabDetails.nomineeDetails?.nomineeDob &&
      moment(new Date(), 'DD/MM/YYYY').diff(
        moment(values?.additionalTabDetails.nomineeDetails.nomineeDob, 'DD/MM/YYYY'),
        'years',
      ) < MINOR_THRESHOLD_AGEE
    ) {
    if(!values?.additionalTabDetails.nomineeDetails.relationshipWithAppointee){
      errors.additionalTabDetails.nomineeDetails = {};
      errors.additionalTabDetails.nomineeDetails.relationshipWithAppointee ='* Required'
    }
    if(!values?.additionalTabDetails?.nomineeDetails?.nameOfAppointee){
      errors.additionalTabDetails.nomineeDetails = {};
      errors.additionalTabDetails.nomineeDetails.nameOfAppointee ='* Required'
    }
  }
    if(!values?.additionalTabDetails.nomineeDetails.relationshipWithNominee){
      errors.additionalTabDetails.nomineeDetails = {};
      errors.additionalTabDetails.nomineeDetails.relationshipWithNominee ='* Required'
    }
  }
    /*SADivya :  CR P2_498 - PAN Mandatory */
    // if (!values.proposerDetails.panNumber) {
    //   errors.proposerDetails.panNumber = '* Required';
    // }
    if (values.proposerDetails.panNumber) {
      if (values.proposerDetails.panNumber.length !== 10) {
        errors.proposerDetails.panNumber =
          '* PAN number must be of 10 digits';
      } else if (
        !/^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/.test(
          values.proposerDetails.panNumber,
        )
      ) {
        errors.proposerDetails.panNumber =
          '* Please enter valid PAN number';
      }
      //P2_632
      else if (values?.proposerDetails?.panNumber?.substring(3, 4)?.toString()?.toLowerCase() !== 'p' &&
        values?.proposerDetails?.customerType?.toString()?.toLowerCase() === 'individual') {
 
        errors.proposerDetails.panNumber = '* 4th Letter should be P';
      }
      //P2_632
    }
    /*EADivya : CR P2_498 - PAN Mandatory */
    if (!values.proposerDetails.permAddressLine1) {
      errors.proposerDetails.permAddressLine1 = '* Required';
    }
    if (!values.proposerDetails.permPincode) {
      errors.proposerDetails.permPincode = '* Required';
    } else if (
      values.proposerDetails.permPincode &&
      (values.proposerDetails.permPincode.length !== 6 ||
        !values.proposerDetails.permPincode.match(/^[0-9]+$/))
    ) {
      errors.proposerDetails.permPincode =
        '* Pincode must be of 6 digits';
    } else if (
      values.proposerDetails.permPincode &&
      values.proposerDetails.permPincode.length === 6 &&
      (!values.proposerDetails.permCityTownVillage ||
        !values.proposerDetails.permState ||
        !values.proposerDetails.permDistrict)
    ) {
      errors.proposerDetails.permPincode =
        '*Click the search icon to fetch city, district and state';
    }
    if (!values.proposerDetails.permCommAddressYN) {
      if (!values.proposerDetails.commAddressLine1) {
        errors.proposerDetails.commAddressLine1 = '* Required';
      }
      if (!values.proposerDetails.commPincode) {
        errors.proposerDetails.commPincode = '* Required';
      } else if (
        values.proposerDetails.commPincode &&
        (values.proposerDetails.commPincode.length !== 6 ||
          !values.proposerDetails.commPincode.match(/^[0-9]+$/))
      ) {
        errors.proposerDetails.commPincode =
          '* Pincode must be of 6 digits';
      } else if (
        values.proposerDetails.commPincode &&
        (!values.proposerDetails.commCityTownVillage ||
          !values.proposerDetails.commState ||
          !values.proposerDetails.commDistrict)
      ) {
        errors.proposerDetails.commPincode =
          '*Click the search icon to fetch city, district and state';
      }
    }
    if (!values.proposerDetails.mobileNo) {
      errors.proposerDetails.mobileNo = '* Required';
    }
    if (
      values?.proposerDetails?.mobileNo &&
      parseInt(values?.proposerDetails?.mobileNo[0]) <
        parseInt(mobileNumberStartingWith?.value)
    ) {
      errors.proposerDetails.mobileNo = `* Mobile number must start with digit ${mobileNumberStartingWith?.value} - 9`;
    }
    if (
      values.proposerDetails.mobileNo &&
      (values.proposerDetails.mobileNo.length !== 10 ||
        !values.proposerDetails.mobileNo.match(/^[0-9]+$/))
    ) {
      errors.proposerDetails.mobileNo =
        '* Mobile number must be of 10 digits';
    }
    if (!values.proposerDetails.emailID) {
      errors.proposerDetails.emailID = '* Required';
    }
    if (values.proposerDetails.emailID) {
      let email_check = new RegExp(
        /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i,
      );
      if (!email_check.test(values.proposerDetails.emailID)) {
        errors.proposerDetails.emailID =
          '* Please enter valid email address';
      }
    }
    if (
      values?.proposerDetails?.customerType ===
      getDomainData(customerTypeList, 'Organisation', 'value', 'code')
    ) {
      if (values.proposerDetails.faxNo) {
        if (
          values.proposerDetails.faxNo.toString().length !== 10 ||
          !values.proposerDetails.faxNo.toString().match(/^[0-9]+$/)
        ) {
          errors.proposerDetails.faxNo =
            '* Fax Number must be of 10 digits';
        }
      }
      if (values.proposerDetails.altPhoneNo) {
        if (
          values.proposerDetails.altPhoneNo.toString().length !==
            10 ||
          !values.proposerDetails.altPhoneNo
            .toString()
            .match(/^[0-9]+$/)
        ) {
          errors.proposerDetails.altPhoneNo =
            '* Telephone number must be of 10 digits';
        }
      }
      if (values.proposerDetails.phoneNo) {
        if (
          values.proposerDetails.phoneNo.toString().length !== 10 ||
          !values.proposerDetails.phoneNo.toString().match(/^[0-9]+$/)
        ) {
          errors.proposerDetails.phoneNo =
            '* Telephone number must be of 10 digits';
        }
      }
      if (
        values?.proposerDetails?.altMobileNo &&
        parseInt(values?.proposerDetails?.altMobileNo[0]) <
          parseInt(mobileNumberStartingWith?.value)
      ) {
        errors.proposerDetails.altMobileNo = `* Mobile number must start with digit ${mobileNumberStartingWith?.value} - 9`;
      }
      if (values.proposerDetails.altMobileNo) {
        if (
          values.proposerDetails.altMobileNo.toString().length !==
            10 ||
          !values.proposerDetails.altMobileNo
            .toString()
            .match(/^[0-9]+$/)
        ) {
          errors.proposerDetails.altMobileNo =
            '* Mobile number must be of 10 digits';
        }
      }
    }
    /* Proposer Form End */
    if (
      !values?.vehicleTabDetails?.vehicleRegistrationDetails
        ?.registrationNumberParts?.part1 ||
      !values?.vehicleTabDetails?.vehicleRegistrationDetails
        ?.registrationNumberParts?.part2 ||
      !values?.vehicleTabDetails?.vehicleRegistrationDetails
        ?.registrationNumberParts?.part3 ||
      !values?.vehicleTabDetails?.vehicleRegistrationDetails
        ?.registrationNumberParts?.part4
    ) {
      if (
        errors.vehicleTabDetails.vehicleRegistrationDetails ===
        undefined
      ) {
        errors.vehicleTabDetails.vehicleRegistrationDetails = {};
      }
      errors.vehicleTabDetails.vehicleRegistrationDetails.registrationNumber =
        '* Required';
      errorCount += 1;
    }
    if (
      values?.vehicleTabDetails?.vehicleRegistrationDetails
        ?.registrationNumberParts?.part1 ||
      values?.vehicleTabDetails?.vehicleRegistrationDetails
        ?.registrationNumberParts?.part2 ||
      values?.vehicleTabDetails?.vehicleRegistrationDetails
        ?.registrationNumberParts?.part3 ||
      values?.vehicleTabDetails?.vehicleRegistrationDetails
        ?.registrationNumberParts?.part4
    ) {
      let stateCode = /^([a-zA-Z]){2}?$/;
      let distCode = /^([a-zA-Z0-9]){2}?$/;
      // let uniqueCode = /^([a-zA-Z]){2}?$/;
      let uniqueCode = /^[A-Za-z\s]*$/
      let uniqueNumber = /^([0-9]){4}?$/;
      if (
        !values?.vehicleTabDetails?.vehicleRegistrationDetails
          ?.registrationNumberParts?.part1 &&
        values?.vehicleTabDetails?.vehicleRegistrationDetails
          ?.registrationNumberParts?.part2 &&
        values?.vehicleTabDetails?.vehicleRegistrationDetails
          ?.registrationNumberParts?.part3 &&
        values?.vehicleTabDetails?.vehicleRegistrationDetails
          ?.registrationNumberParts?.part4
      ) {
        if (
          errors.vehicleTabDetails.vehicleRegistrationDetails ===
          undefined
        ) {
          errors.vehicleTabDetails.vehicleRegistrationDetails = {};
        }
        errors.vehicleTabDetails.vehicleRegistrationDetails.registrationNumber =
          '* State Code is Required';
        errorCount += 1;
      }
      if (
        values?.vehicleTabDetails?.vehicleRegistrationDetails
          ?.registrationNumberParts?.part1 &&
        !stateCode.test(
          values?.vehicleTabDetails?.vehicleRegistrationDetails
            ?.registrationNumberParts?.part1,
        )
      ) {
        if (
          errors.vehicleTabDetails.vehicleRegistrationDetails ===
          undefined
        ) {
          errors.vehicleTabDetails.vehicleRegistrationDetails = {};
        }
        errors.vehicleTabDetails.vehicleRegistrationDetails.registrationNumber =
          '* Enter valid State or Union Territory Code';
        errorCount += 1;
      }
      if (
        !values?.vehicleTabDetails?.vehicleRegistrationDetails
          ?.registrationNumberParts?.part2 &&
        values?.vehicleTabDetails?.vehicleRegistrationDetails
          ?.registrationNumberParts?.part1 &&
        values?.vehicleTabDetails?.vehicleRegistrationDetails
          ?.registrationNumberParts?.part3 &&
        values?.vehicleTabDetails?.vehicleRegistrationDetails
          ?.registrationNumberParts?.part4
      ) {
        if (
          errors.vehicleTabDetails.vehicleRegistrationDetails ===
          undefined
        ) {
          errors.vehicleTabDetails.vehicleRegistrationDetails = {};
        }
        errors.vehicleTabDetails.vehicleRegistrationDetails.registrationNumber =
          '* District Sequential Number is Required';
        errorCount += 1;
      }
      if (
        values?.vehicleTabDetails?.vehicleRegistrationDetails
          ?.registrationNumberParts?.part2
      ) {
        if (
          !distCode.test(
            values?.vehicleTabDetails?.vehicleRegistrationDetails
              ?.registrationNumberParts?.part2,
          )
        ) {
          if (
            errors.vehicleTabDetails.vehicleRegistrationDetails ===
            undefined
          ) {
            errors.vehicleTabDetails.vehicleRegistrationDetails = {};
          }
          errors.vehicleTabDetails.vehicleRegistrationDetails.registrationNumber =
            '* Enter valid District Sequential Number';
          errorCount += 1;
        }
      }
      // if (
      //   !values?.vehicleTabDetails?.vehicleRegistrationDetails
      //     ?.registrationNumberParts?.part3 &&
      //   values?.vehicleTabDetails?.vehicleRegistrationDetails
      //     ?.registrationNumberParts?.part1 &&
      //   values?.vehicleTabDetails?.vehicleRegistrationDetails
      //     ?.registrationNumberParts?.part2 &&
      //   values?.vehicleTabDetails?.vehicleRegistrationDetails
      //     ?.registrationNumberParts?.part4
      // ) {
      //   if (
      //     errors.vehicleTabDetails.vehicleRegistrationDetails ===
      //     undefined
      //   ) {
      //     errors.vehicleTabDetails.vehicleRegistrationDetails = {};
      //   }
      //   errors.vehicleTabDetails.vehicleRegistrationDetails.registrationNumber =
      //     '* Unique Code is Required';
      //   errorCount += 1;
      // }
      if (
        values?.vehicleTabDetails?.vehicleRegistrationDetails
          ?.registrationNumberParts?.part3
      ) {
        if (
          // !uniqueCode.test(
            !values?.vehicleTabDetails?.vehicleRegistrationDetails
              ?.registrationNumberParts?.part3?.match(/^[a-zA-Z]/)
          
        ) {
          if (
            errors.vehicleTabDetails.vehicleRegistrationDetails ===
            undefined
          ) {
            errors.vehicleTabDetails.vehicleRegistrationDetails = {};
          }
          errors.vehicleTabDetails.vehicleRegistrationDetails.registrationNumber =
            '* Unique Code cannot be alphanumeric';
          errorCount += 1;
        }
      }
      if (
        !values?.vehicleTabDetails?.vehicleRegistrationDetails
          ?.registrationNumberParts?.part4 &&
        values?.vehicleTabDetails?.vehicleRegistrationDetails
          ?.registrationNumberParts?.part1 &&
        values?.vehicleTabDetails?.vehicleRegistrationDetails
          ?.registrationNumberParts?.part2 &&
        values?.vehicleTabDetails?.vehicleRegistrationDetails
          ?.registrationNumberParts?.part3
      ) {
        if (
          errors.vehicleTabDetails.vehicleRegistrationDetails ===
          undefined
        ) {
          errors.vehicleTabDetails.vehicleRegistrationDetails = {};
        }
        errors.vehicleTabDetails.vehicleRegistrationDetails.registrationNumber =
          '* Unique Number is Required';
        errorCount += 1;
      }
      if (
        values?.vehicleTabDetails?.vehicleRegistrationDetails
          ?.registrationNumberParts?.part4
      ) {
        if (
          !uniqueNumber.test(
            values?.vehicleTabDetails?.vehicleRegistrationDetails
              ?.registrationNumberParts?.part4,
          )
        ) {
          if (
            errors.vehicleTabDetails.vehicleRegistrationDetails ===
            undefined
          ) {
            errors.vehicleTabDetails.vehicleRegistrationDetails = {};
          }
          errors.vehicleTabDetails.vehicleRegistrationDetails.registrationNumber =
            '* Unique Number can be only Digits';
          errorCount += 1;
        }
      }
    }

    if(values?.vehicleTabDetails?.otherDiscounts?.creditScore=='Yes')
    {
    if (
      values?.vehicleTabDetails?.otherDiscounts
        ?.idproof === '' ||
      values?.vehicleTabDetails?.otherDiscounts
      ?.idproof=== null ||
      values?.vehicleTabDetails?.otherDiscounts
      ?.idproof === undefined
    ) {
      if (
        errors.vehicleTabDetails.otherDiscounts === undefined
      ) {
        errors.vehicleTabDetails.otherDiscounts = {};
      }
      errors.vehicleTabDetails.otherDiscounts.idproof =
        '* Required';
        errorCount += 1;
    }
    if (
      values?.vehicleTabDetails?.otherDiscounts
        ?.idproofNo === '' ||
      values?.vehicleTabDetails?.otherDiscounts
      ?.idproofNo=== null ||
      values?.vehicleTabDetails?.otherDiscounts
      ?.idproofNo === undefined
    ) {
      if (
        errors.vehicleTabDetails.otherDiscounts === undefined
      ) {
        errors.vehicleTabDetails.otherDiscounts = {};
      }
      errors.vehicleTabDetails.otherDiscounts.idproofNo =
        '* Required';
      errorCount += 1;
    }
    // if (values.vehicleTabDetails.otherDiscounts.idproofNo) {
    //   let regPassport = /^([a-zA-Z]){1}([0-9]){7}?$/;
    //   if (
    //     values.vehicleTabDetails.otherDiscounts.idproofNo ===
    //     getDomainData(
    //       PRD_IDProofTypeForCreditScoreList,
    //       'Passport',
    //       'value',
    //       'code',
    //     )
    //   ) {
    //     if (values.vehicleTabDetails.otherDiscounts.idproofNo.length !== 8) {
    //       values.vehicleTabDetails.otherDiscounts =
    //         '* Passport number must be of 8 digits';
    //         errorCount+=1;
    //       } else if (!regPassport.test(values.vehicleTabDetails.otherDiscounts.idproofNo)) {
    //         errors.vehicleTabDetails.otherDiscounts.idproofNo = '* Enter valid passport number';
    //       errorCount+=1;
    //     }
    //   }
    //   if (
    //     values.vehicleTabDetails.otherDiscounts.idproofNo ===
    //     getDomainData(
    //       PRD_IDProofTypeForCreditScoreList,
    //       'PAN Card',
    //       'value',
    //       'code',
    //     )
    //   ) {
    //     if (values.vehicleTabDetails.otherDiscounts.idproofNo.length !== 10) {
    //       errors.vehicleTabDetails.otherDiscounts.idproofNo = '* PAN number must be of 10 digits';
    //       errorCount+=1;
    //     } else if (
    //       !/^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/.test(
    //         values.vehicleTabDetails.otherDiscounts.idproofNo,
    //       )
    //     ) {
    //       errors.vehicleTabDetails.otherDiscounts.idproofNo = '* Please enter valid PAN number';
    //       errorCount+=1;
    //     }
    //   }
    //   //end-------------------------------------------------------
    // }
  }
    /* Insured Declared Value */
    if(viewRenewMotorPolicy?.productType?.toLowerCase()?.search('liability')===-1){
    if (
      values?.vehicleTabDetails?.insuredDeclaredDetails
        ?.vehicleIDV === '' ||
      values?.vehicleTabDetails?.insuredDeclaredDetails
        ?.vehicleIDV === null ||
      values?.vehicleTabDetails?.insuredDeclaredDetails
        ?.vehicleIDV === undefined
    ) {
      if (
        errors.vehicleTabDetails.insuredDeclaredDetails === undefined
      ) {
        errors.vehicleTabDetails.insuredDeclaredDetails = {};
      }
      errors.vehicleTabDetails.insuredDeclaredDetails.vehicleIDV =
        '* Required';
      errorCount += 1;
    }
    if (
      values?.vehicleTabDetails?.insuredDeclaredDetails?.vehicleIDV
    ) {
      if (
        parseFloat(
          values?.vehicleTabDetails?.insuredDeclaredDetails
            ?.vehicleIDV,
        ) <
        viewRenewMotorPolicy?.vehicleTabDetails
          ?.insuredDeclaredDetails?.minChangedIDV
      ) {
        if (
          errors.vehicleTabDetails.insuredDeclaredDetails ===
          undefined
        ) {
          errors.vehicleTabDetails.insuredDeclaredDetails = {};
        }
        errors.vehicleTabDetails.insuredDeclaredDetails.vehicleIDV = `* Changed IDV can't be less than - 10% of suggested IDV`;
        errorCount += 1;
      }
      if (
        parseFloat(
          values?.vehicleTabDetails?.insuredDeclaredDetails
            ?.vehicleIDV,
        ) >
        viewRenewMotorPolicy?.vehicleTabDetails
          ?.insuredDeclaredDetails?.maxChangedIDV
      ) {
        if (
          errors.vehicleTabDetails.insuredDeclaredDetails ===
          undefined
        ) {
          errors.vehicleTabDetails.insuredDeclaredDetails = {};
        }
        errors.vehicleTabDetails.insuredDeclaredDetails.vehicleIDV = `* Changed IDV can't be greater than 10% of suggested IDV`;
        errorCount += 1;
      }
    }
    if (
      values?.vehicleTabDetails?.insuredDeclaredDetails
        ?.irfAdjustmentPercent === '' ||
      values?.vehicleTabDetails?.insuredDeclaredDetails
        ?.irfAdjustmentPercent === null ||
      values?.vehicleTabDetails?.insuredDeclaredDetails
        ?.irfAdjustmentPercent === undefined
    ) {
      if (
        errors.vehicleTabDetails.insuredDeclaredDetails === undefined
      ) {
        errors.vehicleTabDetails.insuredDeclaredDetails = {};
      }
      errors.vehicleTabDetails.insuredDeclaredDetails.irfAdjustmentPercent =
        '* Required';
      errorCount += 1;
    }
    // if (
    //   values?.vehicleTabDetails?.insuredDeclaredDetails
    //     ?.irfAdjustmentPercent &&
    //   parseFloat(
    //     values?.vehicleTabDetails?.insuredDeclaredDetails
    //       ?.irfAdjustmentPercent,
    //   ) <
    //     viewRenewMotorPolicy?.vehicleTabDetails
    //       ?.insuredDeclaredDetails?.irfAdjustmentPercent
    // ) {
    //   if (
    //     errors.vehicleTabDetails.insuredDeclaredDetails === undefined
    //   ) {
    //     errors.vehicleTabDetails.insuredDeclaredDetails = {};
    //   }
    //   errors.vehicleTabDetails.insuredDeclaredDetails.irfAdjustmentPercent = `* IRF can't be less than ${viewRenewMotorPolicy?.vehicleTabDetails?.insuredDeclaredDetails?.irfAdjustmentPercent}%`;
    //   errorCount += 1;
    // }
    if (
      values?.vehicleTabDetails?.insuredDeclaredDetails
        ?.irfAdjustmentPercent &&
      parseFloat(
        values?.vehicleTabDetails?.insuredDeclaredDetails
          ?.irfAdjustmentPercent,
      ) >
        viewRenewMotorPolicy?.vehicleTabDetails
          ?.insuredDeclaredDetails?.irfPct
    ) {
      if (
        errors.vehicleTabDetails.insuredDeclaredDetails === undefined
      ) {
        errors.vehicleTabDetails.insuredDeclaredDetails = {};
      }
      errors.vehicleTabDetails.insuredDeclaredDetails.irfAdjustmentPercent = `* IRF can't be more than ${viewRenewMotorPolicy?.vehicleTabDetails?.insuredDeclaredDetails?.irfPct}%`;
      errorCount += 1;
    }
    }
    /* IDB end value */

    if (Object.keys(errors.proposerDetails).length > 0) {
      errorCount += 1;
    }
    if (Object.keys(errors.intermediaryData).length > 0) {
      errorCount += 1;
    }
    if (Object.keys(errors.additionalTabDetails).length > 0) {
      errorCount += 1;
    }
    if (errorCount === 0) {
      return {};
    }

    return errors;
  };

  const getDomainData = (
    domainArr,
    searchText,
    searchType,
    returnType,
  ) => {
    return domainArr.find(
      (d) =>
        d[`${searchType}`]?.toLowerCase() ===
        searchText?.toLowerCase(),
    )
      ? domainArr.find(
          (d) =>
            d[`${searchType}`]?.toLowerCase() ===
            searchText?.toLowerCase(),
        )[`${returnType}`]
      : '';
  };

  const getRenewalInput = (values, premiumBreakupValues) => {
     let prevInsurancedtls=[];
     viewRenewMotorPolicy?.quoteData?.prevInsuranceDetailsGCV?.forEach((_, idx) => {
      prevInsurancedtls.push({
        coverType: viewRenewMotorPolicy?.quoteData?.prevInsuranceDetailsGCV[idx].coverType,
        policyTenure:viewRenewMotorPolicy?.quoteData?.prevInsuranceDetailsGCV[idx].policyTenure,
        insurerName:viewRenewMotorPolicy?.quoteData?.prevInsuranceDetailsGCV[idx].insurerName,
        policyNumber: viewRenewMotorPolicy?.quoteData?.prevInsuranceDetailsGCV[idx].policyNumber,
        startDate: viewRenewMotorPolicy?.quoteData?.prevInsuranceDetailsGCV[idx].startDate,
        expiryDate: viewRenewMotorPolicy?.quoteData?.prevInsuranceDetailsGCV[idx].expiryDate,
        });
      });
      let claimdtls=[];
      viewRenewMotorPolicy?.quoteData?.previousClaimsArray?.forEach((_, idx) => {
        claimdtls.push({
        totalClaimCount:viewRenewMotorPolicy?.quoteData?.previousClaimsArray[idx].totalClaimCount,
        claimsInYear1:viewRenewMotorPolicy?.quoteData?.previousClaimsArray[idx].noOfClaimsYear1,
        claimsInYear2:viewRenewMotorPolicy?.quoteData?.previousClaimsArray[idx].noOfClaimsYear2,
        claimsInYear3:viewRenewMotorPolicy?.quoteData?.previousClaimsArray[idx].noOfClaimsYear3,
        prevNCBSlab:viewRenewMotorPolicy?.quoteData?.previousClaimsArray[idx].prevNCBSlab,
        totalClaimAmount:viewRenewMotorPolicy?.quoteData?.previousClaimsArray[idx].totalClaimAmount
       ? parseFloat(
          viewRenewMotorPolicy?.quoteData?.previousClaimsArray[idx].totalClaimAmount
        ):null,
        claimFreeYear: viewRenewMotorPolicy?.quoteData?.previousClaimsArray[idx].claimFreeYear
        });
      });
    let riskInput = [];
    viewRenewMotorPolicy?.coverData?.rawRiskData?.forEach((r) => {
      let covers = [];
      Object.keys(viewRenewMotorPolicy?.coverData?.addOnCovers)
        ?.filter(
          (coverName) =>
            viewRenewMotorPolicy?.coverData?.addOnCovers[
              `${coverName}`
            ]?.riskName
              ?.toString()
              ?.toLowerCase() ===
              r?.riskType?.toString()?.toLowerCase() &&
            !r?.covers?.find(
              (cov) =>
                cov?.name?.toString()?.toLowerCase() ===
                coverName?.toString()?.toLowerCase(),
            ),
        )
        ?.forEach((coverName) => {
          covers?.push({
            name: coverName,
            index: viewRenewMotorPolicy?.coverData?.addOnCovers[
              `${coverName}`
            ]?.index
              ? `${
                  viewRenewMotorPolicy?.coverData?.addOnCovers[
                    `${coverName}`
                  ]?.index
                }`
              : '',
            attributes: [],
          });
        });
      r.covers
        .filter(
          (c) =>
            premiumBreakupValues[`addOnCovers`][c?.name]?.selected,
        )
        .forEach((c) => {
          const { selected, attributes, ...rest } = c;
          let attributesArr = [];
          c?.attributes?.forEach((attribute) => {
            attributesArr.push({
              ...attribute,
              value: attribute?.showOnScreen
                ? `${
                    premiumBreakupValues[`addOnCovers`][`${c?.name}`][
                      `attributes`
                    ][`${attribute?.name}`]
                  }`
                : `${attribute?.defaultValue}`,
            });
          });
          covers.push({
            ...rest,
            attributes: [...attributesArr],
          });
        });
      if (covers?.length !== 0) {
        riskInput.push({
          riskType: r?.riskType,
          covers,
        });
      }
    });
    return {
      input: {
        renewalMode,
        productCode,
        productType,
        coverforlamps:viewRenewMotorPolicy?.IMT23?.toLowerCase()=='true'
        ?true:false,
        coverforprivateandcommercial:viewRenewMotorPolicy?.IMT34?.toLowerCase()=='true'
        ?true:false,
        customerType: values?.proposerDetails?.customerType,
        gender: values?.proposerDetails?.gender,
        businessType: viewRenewMotorPolicy?.businessType,
        intermediary: {
          intermediaryCode: values?.intermediaryData?.intermediary,
          locationCode: values?.intermediaryData?.businessLocation,
          fieldUserCode: values?.intermediaryData?.fieldUser,
        },
        tenure:
          viewRenewMotorPolicy?.quoteData?.tenure ||
          viewRenewMotorPolicy?.quoteData?.premiumData?.tenure ||
          viewRenewMotorPolicy?.premiumData?.tenure,
        rto: {
          rtoAuthCode: viewRenewMotorPolicy?.vehicleTabDetails
            ?.vehicleDetails?.rtoDetails?.rtoAuthorityCode
            ? `${viewRenewMotorPolicy?.vehicleTabDetails?.vehicleDetails?.rtoDetails?.rtoAuthorityCode}`
            : '',
          rtoLocCode: viewRenewMotorPolicy?.vehicleTabDetails
            ?.vehicleDetails?.rtoDetails?.rtoLocationCode
            ? `${viewRenewMotorPolicy?.vehicleTabDetails?.vehicleDetails?.rtoDetails?.rtoLocationCode}`
            : '',
          rtoLocDesc: viewRenewMotorPolicy?.vehicleTabDetails
            ?.vehicleDetails?.rtoDetails?.rtoLocationDesc
            ? `${viewRenewMotorPolicy?.vehicleTabDetails?.vehicleDetails?.rtoDetails?.rtoLocationDesc}`
            : '',
        },
        vehicle: {
          make: viewRenewMotorPolicy?.vehicleTabDetails
            ?.vehicleDetails?.make?.code
            ? `${viewRenewMotorPolicy?.vehicleTabDetails?.vehicleDetails?.make?.code}`
            : '',
          model: viewRenewMotorPolicy?.vehicleTabDetails
            ?.vehicleDetails?.model?.code
            ? `${viewRenewMotorPolicy?.vehicleTabDetails?.vehicleDetails?.model?.code}`
            : '',
          variant: viewRenewMotorPolicy?.vehicleTabDetails
            ?.vehicleDetails?.variant?.code
            ? `${viewRenewMotorPolicy?.vehicleTabDetails?.vehicleDetails?.variant?.code}`
            : '',
          engineNumber: values?.vehicleTabDetails
            ?.vehicleRegistrationDetails?.engineNumber
            ? `${values?.vehicleTabDetails?.vehicleRegistrationDetails?.engineNumber}`
            : '',
          chasisNumber: values?.vehicleTabDetails
            ?.vehicleRegistrationDetails?.chasisNumber
            ? `${values?.vehicleTabDetails?.vehicleRegistrationDetails?.chasisNumber}`
            : '',
          registrationNumber: values?.vehicleTabDetails
            ?.vehicleRegistrationDetails?.registrationNumber
            ? `${values?.vehicleTabDetails?.vehicleRegistrationDetails?.registrationNumber}`
            : '',
          manufactureYear: viewRenewMotorPolicy?.vehicleTabDetails
            ?.vehicleDetails?.yearOfManufacture
            ? `${viewRenewMotorPolicy?.vehicleTabDetails?.vehicleDetails?.yearOfManufacture}`
            : '',
          regPurchaseDate: viewRenewMotorPolicy?.vehicleTabDetails
            ?.vehicleDetails?.dateOfRegistration
            ? `${viewRenewMotorPolicy?.vehicleTabDetails?.vehicleDetails?.dateOfRegistration}`
            : '',
          fuelType: viewRenewMotorPolicy?.vehicleTabDetails
            ?.vehicleDetails?.fuelType
            ? `${viewRenewMotorPolicy?.vehicleTabDetails?.vehicleDetails?.fuelType}`
            : '',
          seatingCapacity: viewRenewMotorPolicy?.vehicleTabDetails
            ?.vehicleDetails?.seatingCapacity
            ? `${viewRenewMotorPolicy?.vehicleTabDetails?.vehicleDetails?.seatingCapacity}`
            : '',
          cubicCapacity: viewRenewMotorPolicy?.vehicleTabDetails
            ?.vehicleDetails?.cubeCapacity
            ? `${viewRenewMotorPolicy?.vehicleTabDetails?.vehicleDetails?.cubeCapacity}`
            : '',
            carryingCapacity: viewRenewMotorPolicy?.quoteData
            ?.carryingCapacity
            ? `${viewRenewMotorPolicy?.quoteData
              ?.carryingCapacity}`
            : '',
          gvw: viewRenewMotorPolicy?.quoteData
          ?.GVW
            ? `${viewRenewMotorPolicy?.quoteData
              ?.GVW}`
            : '',
          carriageType:viewRenewMotorPolicy?.quoteData
          ?.carriageType
            ? `${viewRenewMotorPolicy?.quoteData
              ?.carriageType}`
            : '',
          permitType:viewRenewMotorPolicy?.quoteData
          ?.permitType
            ? `${viewRenewMotorPolicy?.quoteData
              ?.permitType}`
            : '',
          vehicleuse : viewRenewMotorPolicy?.quoteData
          ?.vehicleUse
            ? `${viewRenewMotorPolicy?.quoteData
              ?.vehicleUse}`
            : '',
          vehicleSegment: viewRenewMotorPolicy?.vehicleTabDetails
            ?.vehicleDetails?.vehicleSegment
            ? `${viewRenewMotorPolicy?.vehicleTabDetails?.vehicleDetails?.vehicleSegment}`
            : '',
          preInspectionNumber: viewRenewMotorPolicy?.vehicleTabDetails
            ?.vehicleDetails?.preInspectionNumber
            ? `${viewRenewMotorPolicy?.vehicleTabDetails?.vehicleDetails?.preInspectionNumber}`
            : '',
        },
        sideCarValue:
          values?.vehicleTabDetails?.insuredDeclaredDetails
            ?.sideCarValue !== null &&
          values?.vehicleTabDetails?.insuredDeclaredDetails
            ?.sideCarValue !== undefined &&
          values?.vehicleTabDetails?.insuredDeclaredDetails
            ?.sideCarValue !== ''
            ? `${values?.vehicleTabDetails?.insuredDeclaredDetails?.sideCarValue}`
            : '',
        firstYearIDV:
          values?.vehicleTabDetails?.insuredDeclaredDetails
            ?.vehicleIDV !== undefined &&
          values?.vehicleTabDetails?.insuredDeclaredDetails
            ?.vehicleIDV !== null &&
          values?.vehicleTabDetails?.insuredDeclaredDetails
            ?.vehicleIDV !== ''
            ? `${values?.vehicleTabDetails?.insuredDeclaredDetails?.vehicleIDV}`
            : '',
            bodyIDV:values?.vehicleTabDetails.vehicleRegistrationDetails.bodyIDV,
        irf1:
          values?.vehicleTabDetails?.insuredDeclaredDetails
            ?.irfAdjustmentPercent !== undefined &&
          values?.vehicleTabDetails?.insuredDeclaredDetails
            ?.irfAdjustmentPercent !== null &&
          values?.vehicleTabDetails?.insuredDeclaredDetails
            ?.irfAdjustmentPercent !== ''
            ? `${values?.vehicleTabDetails?.insuredDeclaredDetails?.irfAdjustmentPercent}`
            : '',
        prevInsurance: {
          coverType: viewRenewMotorPolicy?.additionalTabDetails
            ?.previousInsuranceAndClaims?.previousPolicyDetails
            ?.policyCoverType
            ? `${viewRenewMotorPolicy?.additionalTabDetails?.previousInsuranceAndClaims?.previousPolicyDetails?.policyCoverType}`
            : '',
          policyTenure: viewRenewMotorPolicy?.additionalTabDetails
            ?.previousInsuranceAndClaims?.previousPolicyDetails
            ?.policyTenure
            ? `${viewRenewMotorPolicy?.additionalTabDetails?.previousInsuranceAndClaims?.previousPolicyDetails?.policyTenure}`
            : '',
          insurerName: viewRenewMotorPolicy?.additionalTabDetails
            ?.previousInsuranceAndClaims?.previousPolicyDetails
            ?.previousInsurerName
            ? `${viewRenewMotorPolicy?.additionalTabDetails?.previousInsuranceAndClaims?.previousPolicyDetails?.previousInsurerName}`
            : '',
          policyNumber: viewRenewMotorPolicy?.additionalTabDetails
            ?.previousInsuranceAndClaims?.previousPolicyDetails
            ?.expiringPolicyNumber
            ? `${viewRenewMotorPolicy?.additionalTabDetails?.previousInsuranceAndClaims?.previousPolicyDetails?.expiringPolicyNumber}`
            : '',
          startDate: viewRenewMotorPolicy?.additionalTabDetails
            ?.previousInsuranceAndClaims?.previousPolicyDetails
            ?.policyStartDate
            ? `${viewRenewMotorPolicy?.additionalTabDetails?.previousInsuranceAndClaims?.previousPolicyDetails?.policyStartDate}`
            : '',
          expiryDate: viewRenewMotorPolicy?.additionalTabDetails
            ?.previousInsuranceAndClaims?.previousPolicyDetails
            ?.policyExpiryDate
            ? `${viewRenewMotorPolicy?.additionalTabDetails?.previousInsuranceAndClaims?.previousPolicyDetails?.policyExpiryDate}`
            : '',
        },
        prevInsuranceGCV:prevInsurancedtls,
        claimdetails:claimdtls,
        prevClaims: {
          totalClaimCount: viewRenewMotorPolicy?.additionalTabDetails
            ?.previousInsuranceAndClaims?.previousClaims
            ?.totalClaimCount
            ? `${viewRenewMotorPolicy?.additionalTabDetails?.previousInsuranceAndClaims?.previousClaims?.totalClaimCount}`
            : '',
          claimsInYear1: viewRenewMotorPolicy?.additionalTabDetails
            ?.previousInsuranceAndClaims?.previousClaims
            ?.noOfClaimsYear1
            ? `${viewRenewMotorPolicy?.additionalTabDetails?.previousInsuranceAndClaims?.previousClaims?.noOfClaimsYear1}`
            : '',
          claimsInYear2: viewRenewMotorPolicy?.additionalTabDetails
            ?.previousInsuranceAndClaims?.previousClaims
            ?.noOfClaimsYear2
            ? `${viewRenewMotorPolicy?.additionalTabDetails?.previousInsuranceAndClaims?.previousClaims?.noOfClaimsYear2}`
            : '',
          claimsInYear3: viewRenewMotorPolicy?.additionalTabDetails
            ?.previousInsuranceAndClaims?.previousClaims
            ?.noOfClaimsYear3
            ? `${viewRenewMotorPolicy?.additionalTabDetails?.previousInsuranceAndClaims?.previousClaims?.noOfClaimsYear3}`
            : '',
          prevNCBSlab: viewRenewMotorPolicy?.additionalTabDetails
            ?.previousInsuranceAndClaims?.previousClaims
            ?.previousYearNCBSlab
            ? `${viewRenewMotorPolicy?.additionalTabDetails?.previousInsuranceAndClaims?.previousClaims?.previousYearNCBSlab}`
            : '',
          totalClaimAmount: viewRenewMotorPolicy?.additionalTabDetails
            ?.previousInsuranceAndClaims?.previousClaims
            ?.totalClaimAmount
            ? parseFloat(
                viewRenewMotorPolicy?.additionalTabDetails
                  ?.previousInsuranceAndClaims?.previousClaims
                  ?.totalClaimAmount,
              )
            : null,
          claimFreeYear: viewRenewMotorPolicy?.premiumData
            ?.claimFreeYear
            ? `${viewRenewMotorPolicy?.premiumData?.claimFreeYear}`
            : '',
        },
        nomineeDetails:{
          name: values?.additionalTabDetails?.nomineeDetails?.nomineeName
          ? `${values?.additionalTabDetails?.nomineeDetails?.nomineeName}`
          : '',
          dob: values?.additionalTabDetails?.nomineeDetails?.nomineeDob
          ? `${values?.additionalTabDetails?.nomineeDetails?.nomineeDob}`
          : '',
          relationshipWithInsured:values?.additionalTabDetails?.nomineeDetails?.relationshipWithInsured
          ? `${values?.additionalTabDetails?.nomineeDetails?.relationshipWithInsured}`
          : '',
          insuredRelationship: values?.additionalTabDetails?.nomineeDetails?.relationshipWithNominee
          ? `${values?.additionalTabDetails?.nomineeDetails?.relationshipWithNominee}`
          : '',
          nameOfAppointee:values?.additionalTabDetails?.nomineeDetails?.nameOfAppointee
          ? `${values?.additionalTabDetails?.nomineeDetails?.nameOfAppointee}`
          : '',
          relationshipWithAppointee:values?.additionalTabDetails?.nomineeDetails?.relationshipWithAppointee
          ? `${values?.additionalTabDetails?.nomineeDetails?.relationshipWithAppointee}`
          : '',
        },
        financerDetails: {
          financerName:
            getDomainData(
              PRD_IsYourVehicle,
              values?.additionalTabDetails?.financeDetails
                ?.vehicleOwned,
              'code',
              'value',
            )
              ?.toString()
              ?.toLowerCase() === 'financed'
              ? values?.additionalTabDetails?.financeDetails
                  ?.financerDetails?.financerName
              : '',
          financerAddress: values?.additionalTabDetails
            ?.financeDetails?.financerDetails?.financerAddress
            ? `${values?.additionalTabDetails?.financeDetails?.financerDetails?.financerAddress}`
            : '',
          financerAgreementType: values?.additionalTabDetails
            ?.financeDetails?.financerDetails?.financerAgreementType
            ? `${values?.additionalTabDetails?.financeDetails?.financerDetails?.financerAgreementType}`
            : '',
          loanAccountNumber: values?.additionalTabDetails
            ?.financeDetails?.financerDetails?.loanAccountNumber
            ? `${values?.additionalTabDetails?.financeDetails?.financerDetails?.loanAccountNumber}`
            : '',
          fileNumber: values?.additionalTabDetails?.financeDetails
            ?.financerDetails?.fileNumber
            ? `${values?.additionalTabDetails?.financeDetails?.financerDetails?.fileNumber}`
            : '',
        },
        riskCovers: riskInput,
        creditScore: {
          discountOpted:
            viewRenewMotorPolicy?.quoteData?.getAdditionalCreditScore
              ?.toString()
              ?.toLowerCase() === 'yes'
              ? true
              : false,
          idProofType: viewRenewMotorPolicy?.quoteData?.idProofType
            ? `${viewRenewMotorPolicy?.quoteData?.idProofType}`
            : '',
          idProofNumber: viewRenewMotorPolicy?.quoteData
            ?.idProofNumber
            ? `${viewRenewMotorPolicy?.quoteData?.idProofNumber}`
            : '',
          creditScore:
            viewRenewMotorPolicy?.premiumData?.creditScore !== null &&
            viewRenewMotorPolicy?.premiumData?.creditScore !==
              undefined &&
            viewRenewMotorPolicy?.premiumData?.creditScore !== ''
              ? parseFloat(
                  viewRenewMotorPolicy?.premiumData?.creditScore,
                )
              : null,
        },
        proposerPincode:
          viewRenewMotorPolicy?.proposerDetails?.commPincode ||
          viewRenewMotorPolicy?.proposerDetails?.permPincode
            ? viewRenewMotorPolicy?.proposerDetails?.commPincode ||
              viewRenewMotorPolicy?.proposerDetails?.permPincode
            : '',
        voluntaryDeductibleAmt:
          viewRenewMotorPolicy?.quoteData
            ?.voluntaryDeductibleAmount !== null &&
          viewRenewMotorPolicy?.quoteData
            ?.voluntaryDeductibleAmount !== undefined &&
          viewRenewMotorPolicy?.quoteData
            ?.voluntaryDeductibleAmount !== ''
            ? parseFloat(
                viewRenewMotorPolicy?.quoteData
                  ?.voluntaryDeductibleAmount,
              )
            : null,
        customer: {
          id: values?.proposerDetails?.id
            ? `${values?.proposerDetails?.id}`
            : '',
          customerType: values?.proposerDetails?.customerType
            ? `${values?.proposerDetails?.customerType}`
            : '',
          isThinCustomer: false,
          title: values?.proposerDetails?.title
            ? `${values?.proposerDetails?.title}`
            : '',
          gender: values?.proposerDetails?.gender
            ? `${values?.proposerDetails?.gender}`
            : '',
          firstName: values?.proposerDetails?.firstName
            ? `${values?.proposerDetails?.firstName}`
            : '',
          middleName: values?.proposerDetails?.middleName
            ? `${values?.proposerDetails?.middleName}`
            : '',
          lastName: values?.proposerDetails?.lastName
            ? `${values?.proposerDetails?.lastName}`
            : '',
          fullName: values?.proposerDetails?.fullName
            ? `${values?.proposerDetails?.fullName}`
            : '',
          proposerDOB: values?.proposerDetails?.proposerDOB
            ? `${values?.proposerDetails?.proposerDOB}`
            : '',
          maritalStatus: values?.proposerDetails?.maritalStatus
            ? `${values?.proposerDetails?.maritalStatus}`
            : '',
          occupation: values?.proposerDetails?.occupation
            ? `${values?.proposerDetails?.occupation}`
            : '',
          nationality: values?.proposerDetails?.nationality
            ? `${values?.proposerDetails?.nationality}`
            : '',
          idProofType: values?.proposerDetails?.idProofType
            ? `${values?.proposerDetails?.idProofType}`
            : '',
          idProofNumber: values?.proposerDetails?.idProofNumber
            ? `${values?.proposerDetails?.idProofNumber}`
            : '',
          panNumber: values?.proposerDetails?.panNumber
            ? `${values?.proposerDetails?.panNumber}`
            : '',
          orgName: values?.proposerDetails?.orgName
            ? `${values?.proposerDetails?.orgName}`
            : '',
          orgType: values?.proposerDetails?.orgType
            ? `${values?.proposerDetails?.orgType}`
            : '',
          contactName: values?.proposerDetails?.contactName
            ? `${values?.proposerDetails?.contactName}`
            : '',
          regNumber: values?.proposerDetails?.regNumber
            ? `${values?.proposerDetails?.regNumber}`
            : '',
          tanNumber: values?.proposerDetails?.tanNumber
            ? `${values?.proposerDetails?.tanNumber}`
            : '',
          gstNumber: values?.proposerDetails?.gstNumber
            ? `${values?.proposerDetails?.gstNumber}`
            : '',
          permAddressLine1: values?.proposerDetails?.permAddressLine1
            ? `${values?.proposerDetails?.permAddressLine1}`
            : '',
          permAddressLine2: values?.proposerDetails?.permAddressLine2
            ? `${values?.proposerDetails?.permAddressLine2}`
            : '',
          permAddressLine3: values?.proposerDetails?.permAddressLine3
            ? `${values?.proposerDetails?.permAddressLine3}`
            : '',
          permLandmark: values?.proposerDetails?.permLandmark
            ? `${values?.proposerDetails?.permLandmark}`
            : '',
          permPincode: values?.proposerDetails?.permPincode
            ? `${values?.proposerDetails?.permPincode}`
            : '',
          permCityTownVillage: values?.proposerDetails
            ?.permCityTownVillage
            ? `${values?.proposerDetails?.permCityTownVillage}`
            : '',
          permDistrict: values?.proposerDetails?.permDistrict
            ? `${values?.proposerDetails?.permDistrict}`
            : '',
          permState: values?.proposerDetails?.permState
            ? `${values?.proposerDetails?.permState}`
            : '',
          permCommAddressYN: values?.proposerDetails
            ?.permCommAddressYN
            ? true
            : false,
          commAddressLine1: values?.proposerDetails?.commAddressLine1
            ? `${values?.proposerDetails?.commAddressLine1}`
            : '',
          commAddressLine2: values?.proposerDetails?.commAddressLine2
            ? `${values?.proposerDetails?.commAddressLine2}`
            : '',
          commAddressLine3: values?.proposerDetails?.commAddressLine3
            ? `${values?.proposerDetails?.commAddressLine3}`
            : '',
          commLandmark: values?.proposerDetails?.commLandmark
            ? `${values?.proposerDetails?.commLandmark}`
            : '',
          commPincode: values?.proposerDetails?.commPincode
            ? `${values?.proposerDetails?.commPincode}`
            : '',
          commCityTownVillage: values?.proposerDetails
            ?.commCityTownVillage
            ? `${values?.proposerDetails?.commCityTownVillage}`
            : '',
          commDistrict: values?.proposerDetails?.commDistrict
            ? `${values?.proposerDetails?.commDistrict}`
            : '',
          commState: values?.proposerDetails?.commState
            ? `${values?.proposerDetails?.commState}`
            : '',
          phoneNo: values?.proposerDetails?.phoneNo
            ? `${values?.proposerDetails?.phoneNo}`
            : '',
          mobileNo: values?.proposerDetails?.mobileNo
            ? `${values?.proposerDetails?.mobileNo}`
            : '',
          emailID: values?.proposerDetails?.emailID
            ? `${values?.proposerDetails?.emailID}`
            : '',
          faxNo: values?.proposerDetails?.faxNo
            ? `${values?.proposerDetails?.faxNo}`
            : '',
          altPhoneNo: values?.proposerDetails?.altPhoneNo
            ? `${values?.proposerDetails?.altPhoneNo}`
            : '',
          altMobileNo: values?.proposerDetails?.altMobileNo
            ? `${values?.proposerDetails?.altMobileNo}`
            : '',
          ifscCode: viewRenewMotorPolicy?.proposerDetailsMeta
            ?.ifscCode
            ? `${values?.proposerDetailsMeta?.ifscCode}`
            : '',
          bankName: viewRenewMotorPolicy?.proposerDetailsMeta
            ?.bankName
            ? `${viewRenewMotorPolicy?.proposerDetailsMeta?.bankName}`
            : '',
          branchName: viewRenewMotorPolicy?.proposerDetails
            ?.branchName
            ? `${viewRenewMotorPolicy?.proposerDetails?.branchName}`
            : '',
          bankAcno: viewRenewMotorPolicy?.proposerDetailsMeta
            ?.bankAcno
            ? `${viewRenewMotorPolicy?.proposerDetailsMeta?.bankAcno}`
            : '',
          accountHolderName: viewRenewMotorPolicy?.proposerDetailsMeta
            ?.accountHolderName
            ? `${viewRenewMotorPolicy?.proposerDetailsMeta?.accountHolderName}`
            : '',
          micrCode: viewRenewMotorPolicy?.proposerDetailsMeta
            ?.micrCode
            ? `${viewRenewMotorPolicy?.proposerDetailsMeta?.micrCode}`
            : '',
          employeeNumber: values?.proposerDetails?.employeeNumber
            ? `${values?.proposerDetails?.employeeNumber}`
            : '',
            /*SADivya : CR P2_233 : KYC */
          motherMaidenName: values?.proposerDetails?.motherMaidenName
          ? `${values?.proposerDetails?.motherMaidenName}`
          : '',
          ckycIdNumber: values?.proposerDetails?.ckycIdNumber
          ? `${values?.proposerDetails?.ckycIdNumber}`
          : '',
          eiaRequired:values?.proposerDetails?.eiaRequired
          ? `${values?.proposerDetails?.eiaRequired}`
          : '',
          eiaNumber:values?.proposerDetails?.eiaNumber
          ? `${values?.proposerDetails?.eiaNumber}`
          : '',
          certificateOfInCorporation:values?.proposerDetails?.certificateOfInCorporation
          ? `${values?.proposerDetails?.certificateOfInCorporation}`
          : '',
          udyogAadhaarNumber: values?.proposerDetails?.udyogAadhaarNumber
          ? `${values?.proposerDetails?.udyogAadhaarNumber}`
          : '',
         /*EADivya : CR P2_233 :KYC */
        },
        quoteNumber: viewRenewMotorPolicy?.quoteNumber
          ? `${viewRenewMotorPolicy?.quoteNumber}`
          : '',
        proposalNumber: viewRenewMotorPolicy?.proposalNumber
          ? `${viewRenewMotorPolicy?.proposalNumber}`
          : '',
        policyNumber: viewRenewMotorPolicy?.policyNumber
          ? `${viewRenewMotorPolicy?.policyNumber}`
          : '',
        leadGenerator: viewRenewMotorPolicy
          ?.reviewAndConfirmTabDetails?.leadGenerator
          ? `${viewRenewMotorPolicy?.reviewAndConfirmTabDetails?.leadGenerator}`
          : '',
        proposalPaymentType: values?.reviewAndConfirmTabDetails
          ?.proposalPaymentType
          ? `${values?.reviewAndConfirmTabDetails?.proposalPaymentType}`
          : '',
        premiumBreakup: {
          idvYear1:
            premiumBreakupValues?.premiumData?.idv1 !== null &&
            premiumBreakupValues?.premiumData?.idv1 !== undefined &&
            premiumBreakupValues?.premiumData?.idv1 !== ''
              ? parseFloat(premiumBreakupValues?.premiumData?.idv1)
              : null,
          idvYear2:
            premiumBreakupValues?.premiumData?.idv2 !== null &&
            premiumBreakupValues?.premiumData?.idv2 !== undefined &&
            premiumBreakupValues?.premiumData?.idv2 !== ''
              ? parseFloat(premiumBreakupValues?.premiumData?.idv2)
              : null,
          idvYear3:
            premiumBreakupValues?.premiumData?.idv3 !== null &&
            premiumBreakupValues?.premiumData?.idv3 !== undefined &&
            premiumBreakupValues?.premiumData?.idv3 !== ''
              ? parseFloat(premiumBreakupValues?.premiumData?.idv3)
              : null,
          netODPremium:
            premiumBreakupValues?.premiumData?.netODPremium !==
              null &&
            premiumBreakupValues?.premiumData?.netODPremium !==
              undefined &&
            premiumBreakupValues?.premiumData?.netODPremium !== ''
              ? parseFloat(
                  premiumBreakupValues?.premiumData?.netODPremium,
                )
              : null,
          netTPPremium:
            premiumBreakupValues?.premiumData?.netTPPremium !==
              null &&
            premiumBreakupValues?.premiumData?.netTPPremium !==
              undefined &&
            premiumBreakupValues?.premiumData?.netTPPremium !== ''
              ? parseFloat(
                  premiumBreakupValues?.premiumData?.netTPPremium,
                )
              : null,
          loadingDiscount:
            premiumBreakupValues?.premiumData?.loadingDiscount !==
              null &&
            premiumBreakupValues?.premiumData?.loadingDiscount !==
              undefined &&
            premiumBreakupValues?.premiumData?.loadingDiscount !== ''
              ? parseFloat(
                  premiumBreakupValues?.premiumData?.loadingDiscount,
                )
              : null,
          netPremium:
            premiumBreakupValues?.premiumData?.netPremium !== null &&
            premiumBreakupValues?.premiumData?.netPremium !==
              undefined &&
            premiumBreakupValues?.premiumData?.netPremium !== ''
              ? parseFloat(
                  premiumBreakupValues?.premiumData?.netPremium,
                )
              : null,
          gst:
            premiumBreakupValues?.premiumData?.gst !== null &&
            premiumBreakupValues?.premiumData?.gst !== undefined &&
            premiumBreakupValues?.premiumData?.gst !== ''
              ? parseFloat(premiumBreakupValues?.premiumData?.gst)
              : null,
          stampDuty:
            premiumBreakupValues?.premiumData?.stampDuty !== null &&
            premiumBreakupValues?.premiumData?.stampDuty !==
              undefined &&
            premiumBreakupValues?.premiumData?.stampDuty !== ''
              ? parseFloat(
                  premiumBreakupValues?.premiumData?.stampDuty,
                )
              : null,
          totalPremium:
            premiumBreakupValues?.premiumData?.totalPremium !==
              null &&
            premiumBreakupValues?.premiumData?.totalPremium !==
              undefined &&
            premiumBreakupValues?.premiumData?.totalPremium !== ''
              ? parseFloat(
                  premiumBreakupValues?.premiumData?.totalPremium,
                )
              : null,
          loading:
            premiumBreakupValues?.premiumData?.loading &&
            premiumBreakupValues?.premiumData?.loading?.length > 0
              ? premiumBreakupValues?.premiumData?.loading
              : [],
          discount:
            premiumBreakupValues?.premiumData?.discount &&
            premiumBreakupValues?.premiumData?.discount?.length > 0
              ? premiumBreakupValues?.premiumData?.discount
              : [],
        },
        startDate: viewRenewMotorPolicy?.policy?.startDate,
        endDate: viewRenewMotorPolicy?.policy?.endDate,
      },
    };
  };
  const getCalculatePremiumForProposalVariables = (values,premiumBreakupValues) => {
    let riskInput = [];
    let prevInsurancedtls=[];
     viewRenewMotorPolicy?.quoteData?.prevInsuranceDetailsGCV?.forEach((_, idx) => {
      prevInsurancedtls.push({
        coverType: viewRenewMotorPolicy?.quoteData?.prevInsuranceDetailsGCV[idx].coverType,
        policyTenure:viewRenewMotorPolicy?.quoteData?.prevInsuranceDetailsGCV[idx].policyTenure,
        insurerName:viewRenewMotorPolicy?.quoteData?.prevInsuranceDetailsGCV[idx].insurerName,
        policyNumber: viewRenewMotorPolicy?.quoteData?.prevInsuranceDetailsGCV[idx].policyNumber,
        startDate: viewRenewMotorPolicy?.quoteData?.prevInsuranceDetailsGCV[idx].startDate,
        expiryDate: viewRenewMotorPolicy?.quoteData?.prevInsuranceDetailsGCV[idx].expiryDate,
        });
      });
    viewRenewMotorPolicy?.coverData?.rawRiskData?.forEach((r) => {
      let covers = [];
      r.covers
        .filter((c) => premiumBreakupValues[`addOnCovers`][c?.name]?.selected)
        .forEach((c) => {
          const { selected, attributes, ...rest } = c;
          let attributesArr = [];
          c?.attributes?.forEach((attribute) => {
            attributesArr.push({
              ...attribute,
              value: attribute?.showOnScreen
                ? `${
                  premiumBreakupValues[`addOnCovers`][`${c?.name}`][`attributes`][
                      `${attribute?.name}`
                    ]
                  }`
                : `${attribute?.defaultValue}`,
            });
          });
          covers.push({
            ...rest,
            attributes: [...attributesArr],
          });
        });
      if (covers?.length !== 0) {
        riskInput.push({
          riskType: r?.riskType,
          covers,
        });
      }
    });
    return {
      input: {
        productCode,
        coverforlamps:viewRenewMotorPolicy?.IMT23?.toLowerCase()=='true'
        ?true:false,
        coverforprivateandcommercial:viewRenewMotorPolicy?.IMT34?.toLowerCase()=='true'
        ?true:false,
        productType: viewRenewMotorPolicy?.quoteData?.productType
          ? `${viewRenewMotorPolicy?.quoteData?.productType}`
          : '',
        customerType: viewRenewMotorPolicy?.proposerDetails
          ?.customerType
          ? `${viewRenewMotorPolicy?.proposerDetails?.customerType}`
          : '',
        gender: viewRenewMotorPolicy?.proposerDetails?.gender
          ? `${viewRenewMotorPolicy?.proposerDetails?.gender}`
          : '',
        businessType: viewRenewMotorPolicy?.quoteData?.businessType
          ? `${viewRenewMotorPolicy?.quoteData?.businessType}`
          : '',
        intermediary: {
          intermediaryCode: values?.intermediaryData
            ?.intermediary
            ? `${values?.intermediaryData?.intermediary}`
            : '',
          locationCode: values?.intermediaryData
            ?.businessLocation
            ? `${values?.intermediaryData?.businessLocation}`
            : '',
          fieldUserCode: values?.intermediaryData?.fieldUser
            ? `${values?.intermediaryData?.fieldUser}`
            : '',
        },
        tenure:
          viewRenewMotorPolicy?.quoteData?.tenure ||
          viewRenewMotorPolicy?.quoteData?.premiumData?.tenure
            ? `${
                viewRenewMotorPolicy?.quoteData?.tenure ||
                viewRenewMotorPolicy?.quoteData?.premiumData?.tenure
              }`
            : '',
        rto: {
          rtoAuthCode: viewRenewMotorPolicy?.vehicleTabDetails
            ?.vehicleDetails?.rtoDetails?.rtoAuthorityCode
            ? `${viewRenewMotorPolicy?.vehicleTabDetails?.vehicleDetails?.rtoDetails?.rtoAuthorityCode}`
            : '',
          rtoLocCode: viewRenewMotorPolicy?.vehicleTabDetails
            ?.vehicleDetails?.rtoDetails?.rtoLocationCode
            ? `${viewRenewMotorPolicy?.vehicleTabDetails?.vehicleDetails?.rtoDetails?.rtoLocationCode}`
            : '',
          rtoLocDesc: viewRenewMotorPolicy?.vehicleTabDetails
            ?.vehicleDetails?.rtoDetails?.rtoLocationDesc
            ? `${viewRenewMotorPolicy?.vehicleTabDetails?.vehicleDetails?.rtoDetails?.rtoLocationDesc}`
            : '',
        },
        vehicle: {
          make: viewRenewMotorPolicy?.vehicleTabDetails
            ?.vehicleDetails?.make?.code
            ? `${viewRenewMotorPolicy?.vehicleTabDetails?.vehicleDetails?.make?.code}`
            : '',
          model: viewRenewMotorPolicy?.vehicleTabDetails
            ?.vehicleDetails?.model?.code
            ? `${viewRenewMotorPolicy?.vehicleTabDetails?.vehicleDetails?.model?.code}`
            : '',
          variant: viewRenewMotorPolicy?.vehicleTabDetails
            ?.vehicleDetails?.variant?.code
            ? `${viewRenewMotorPolicy?.vehicleTabDetails?.vehicleDetails?.variant?.code}`
            : '',
          engineNumber: values?.vehicleTabDetails
            ?.vehicleRegistrationDetails?.engineNumber
            ? `${values?.vehicleTabDetails?.vehicleRegistrationDetails?.engineNumber}`
            : '',
          chasisNumber: values?.vehicleTabDetails
            ?.vehicleRegistrationDetails?.chasisNumber
            ? `${values?.vehicleTabDetails?.vehicleRegistrationDetails?.chasisNumber}`
            : '',
          registrationNumber: values?.vehicleTabDetails
            ?.vehicleRegistrationDetails?.registrationNumber
            ? `${values?.vehicleTabDetails?.vehicleRegistrationDetails?.registrationNumber}`
            : '',
          manufactureYear: viewRenewMotorPolicy?.vehicleTabDetails
            ?.vehicleDetails?.yearOfManufacture
            ? `${viewRenewMotorPolicy?.vehicleTabDetails?.vehicleDetails?.yearOfManufacture}`
            : '',
          regPurchaseDate: viewRenewMotorPolicy?.vehicleTabDetails
            ?.vehicleDetails?.dateOfRegistration
            ? `${viewRenewMotorPolicy?.vehicleTabDetails?.vehicleDetails?.dateOfRegistration}`
            : '',
          fuelType: viewRenewMotorPolicy?.vehicleTabDetails
            ?.vehicleDetails?.fuelType
            ? `${viewRenewMotorPolicy?.vehicleTabDetails?.vehicleDetails?.fuelType}`
            : '',
          seatingCapacity: viewRenewMotorPolicy?.vehicleTabDetails
            ?.vehicleDetails?.seatingCapacity
            ? `${viewRenewMotorPolicy?.vehicleTabDetails?.vehicleDetails?.seatingCapacity}`
            : '',
          cubicCapacity: viewRenewMotorPolicy?.vehicleTabDetails
            ?.vehicleDetails?.cubeCapacity
            ? `${viewRenewMotorPolicy?.vehicleTabDetails?.vehicleDetails?.cubeCapacity}`
            : '',
          carryingCapacity: viewRenewMotorPolicy?.quoteData
            ?.carryingCapacity
            ? `${viewRenewMotorPolicy?.quoteData
              ?.carryingCapacity}`
            : '',
          gvw: viewRenewMotorPolicy?.quoteData
          ?.GVW
            ? `${viewRenewMotorPolicy?.quoteData
              ?.GVW}`
            : '',
          carriageType:viewRenewMotorPolicy?.quoteData
          ?.carriageType
            ? `${viewRenewMotorPolicy?.quoteData
              ?.carriageType}`
            : '',
          permitType:viewRenewMotorPolicy?.quoteData
          ?.permitType
            ? `${viewRenewMotorPolicy?.quoteData
              ?.permitType}`
            : '',
          vehicleuse : viewRenewMotorPolicy?.quoteData
          ?.vehicleUse
            ? `${viewRenewMotorPolicy?.quoteData
              ?.vehicleUse}`
            : '',
          vehicleSegment: viewRenewMotorPolicy?.vehicleTabDetails
            ?.vehicleDetails?.vehicleSegment
            ? `${viewRenewMotorPolicy?.vehicleTabDetails?.vehicleDetails?.vehicleSegment}`
            : '',
          sideCarValue:
            values?.vehicleTabDetails?.insuredDeclaredDetails
              ?.sideCarValue !== null &&
            values?.vehicleTabDetails?.insuredDeclaredDetails
              ?.sideCarValue !== undefined &&
            values?.vehicleTabDetails?.insuredDeclaredDetails
              ?.sideCarValue !== ''
              ? `${values?.vehicleTabDetails?.insuredDeclaredDetails?.sideCarValue}`
              : '',
          preInspectionNumber: viewRenewMotorPolicy?.vehicleTabDetails
            ?.vehicleDetails?.preInspectionNumber
            ? `${viewRenewMotorPolicy?.vehicleTabDetails?.vehicleDetails?.preInspectionNumber}`
            : '',
        },
        firstYearIDV:
          values?.vehicleTabDetails?.insuredDeclaredDetails
            ?.vehicleIDV !== null &&
          values?.vehicleTabDetails?.insuredDeclaredDetails
            ?.vehicleIDV !== undefined
            ? `${values?.vehicleTabDetails?.insuredDeclaredDetails?.vehicleIDV}`
            : ``,
        bodyIDV:values?.vehicleTabDetails?.vehicleRegistrationDetails
            ?.bodyIDV !== null &&
          values?.vehicleTabDetails?.vehicleRegistrationDetails
            ?.bodyIDV !== undefined
            ? `${values?.vehicleTabDetails?.vehicleRegistrationDetails?.bodyIDV}`
            : ``,
        irf1: values?.vehicleTabDetails
          ?.insuredDeclaredDetails?.irfAdjustmentPercent
          ? `${values?.vehicleTabDetails?.insuredDeclaredDetails?.irfAdjustmentPercent}`
          : '',
        prevInsurance: {
          coverType: viewRenewMotorPolicy?.additionalTabDetails
            ?.previousInsuranceAndClaims?.previousPolicyDetails
            ?.policyCoverType
            ? `${viewRenewMotorPolicy?.additionalTabDetails?.previousInsuranceAndClaims?.previousPolicyDetails?.policyCoverType}`
            : '',
          policyTenure: viewRenewMotorPolicy?.additionalTabDetails
            ?.previousInsuranceAndClaims?.previousPolicyDetails
            ?.policyTenure
            ? `${viewRenewMotorPolicy?.additionalTabDetails?.previousInsuranceAndClaims?.previousPolicyDetails?.policyTenure}`
            : '',
          insurerName: viewRenewMotorPolicy?.additionalTabDetails
            ?.previousInsuranceAndClaims?.previousPolicyDetails
            ?.previousInsurerName
            ? `${viewRenewMotorPolicy?.additionalTabDetails?.previousInsuranceAndClaims?.previousPolicyDetails?.previousInsurerName}`
            : '',
          policyNumber: viewRenewMotorPolicy?.additionalTabDetails
            ?.previousInsuranceAndClaims?.previousPolicyDetails
            ?.expiringPolicyNumber
            ? `${viewRenewMotorPolicy?.additionalTabDetails?.previousInsuranceAndClaims?.previousPolicyDetails?.expiringPolicyNumber}`
            : '',
          startDate: viewRenewMotorPolicy?.additionalTabDetails
            ?.previousInsuranceAndClaims?.previousPolicyDetails
            ?.policyStartDate
            ? `${viewRenewMotorPolicy?.additionalTabDetails?.previousInsuranceAndClaims?.previousPolicyDetails?.policyStartDate}`
            : '',
          expiryDate: viewRenewMotorPolicy?.additionalTabDetails
            ?.previousInsuranceAndClaims?.previousPolicyDetails
            ?.policyExpiryDate
            ? `${viewRenewMotorPolicy?.additionalTabDetails?.previousInsuranceAndClaims?.previousPolicyDetails?.policyExpiryDate}`
            : '',
        },
        prevClaims: {
          totalClaimCount:
            viewRenewMotorPolicy?.additionalTabDetails?.previousInsuranceAndClaims?.previousPolicyDetails?.policyTenureValue?.toLowerCase() ===
            'annual'
              ? `${viewRenewMotorPolicy?.additionalTabDetails?.previousInsuranceAndClaims?.previousClaims?.totalClaimCount}`
              : '',
          claimsInYear1:
            viewRenewMotorPolicy?.additionalTabDetails?.previousInsuranceAndClaims?.previousPolicyDetails?.policyTenureValue?.toLowerCase() ===
            'long term'
              ? `${viewRenewMotorPolicy?.additionalTabDetails?.previousInsuranceAndClaims?.previousClaims?.noOfClaimsYear1}`
              : '',
          claimsInYear2:
            viewRenewMotorPolicy?.additionalTabDetails?.previousInsuranceAndClaims?.previousPolicyDetails?.policyTenureValue?.toLowerCase() ===
            'long term'
              ? `${viewRenewMotorPolicy?.additionalTabDetails?.previousInsuranceAndClaims?.previousClaims?.noOfClaimsYear2}`
              : '',
          claimsInYear3:
            viewRenewMotorPolicy?.additionalTabDetails?.previousInsuranceAndClaims?.previousPolicyDetails?.policyTenureValue?.toLowerCase() ===
            'long term'
              ? `${viewRenewMotorPolicy?.additionalTabDetails?.previousInsuranceAndClaims?.previousClaims?.noOfClaimsYear3}`
              : '',
          prevNCBSlab: viewRenewMotorPolicy?.additionalTabDetails
            ?.previousInsuranceAndClaims?.previousClaims
            ?.previousYearNCBSlab
            ? `${viewRenewMotorPolicy?.additionalTabDetails?.previousInsuranceAndClaims?.previousClaims?.previousYearNCBSlab}`
            : '',
          claimFreeYear:
            viewRenewMotorPolicy?.quoteData?.premiumData
              ?.claimFreeYear ||
            viewRenewMotorPolicy?.premiumData?.claimFreeYear,
          totalClaimAmount:
            viewRenewMotorPolicy?.additionalTabDetails
              ?.previousInsuranceAndClaims?.previousClaims
              ?.totalClaimAmount !== undefined &&
            viewRenewMotorPolicy?.additionalTabDetails
              ?.previousInsuranceAndClaims?.previousClaims
              ?.totalClaimAmount !== null
              ? parseFloat(
                  viewRenewMotorPolicy?.additionalTabDetails
                    ?.previousInsuranceAndClaims?.previousClaims
                    ?.totalClaimAmount,
                )
              : null,
        },
        prevInsuranceGCV:prevInsurancedtls,
        financerDetails: {
          financerName:
            values?.additionalTabDetails?.financeDetails?.vehicleOwned?.toLowerCase() ===
            'financed'
              ? values?.additionalTabDetails?.financeDetails
                  ?.financerDetails?.financerName
              : '',
          financerAddress:
            values?.additionalTabDetails?.financeDetails?.vehicleOwned?.toLowerCase() ===
            'financed'
              ? values?.additionalTabDetails?.financeDetails
                  ?.financerDetails?.financerAddress
              : '',
          financerAgreementType:
            values?.additionalTabDetails?.financeDetails?.vehicleOwned?.toLowerCase() ===
            'financed'
              ? values?.additionalTabDetails?.financeDetails
                  ?.financerDetails?.financerAgreementType
              : '',
          loanAccountNumber:
            values?.additionalTabDetails?.financeDetails?.vehicleOwned?.toLowerCase() ===
            'financed'
              ? values?.additionalTabDetails?.financeDetails
                  ?.financerDetails?.loanAccountNumber
              : '',
          fileNumber:
            values?.additionalTabDetails?.financeDetails?.vehicleOwned?.toLowerCase() ===
            'financed'
              ? values?.additionalTabDetails?.financeDetails
                  ?.financerDetails?.fileNumber
              : '',
        },
        nomineeDetails:{
          name: values?.additionalTabDetails?.nomineeDetails?.nomineeName
          ? `${values?.additionalTabDetails?.nomineeDetails?.nomineeName}`
          : '',
          dob: values?.additionalTabDetails?.nomineeDetails?.nomineeDob
          ? `${values?.additionalTabDetails?.nomineeDetails?.nomineeDob}`
          : '',
          relationshipWithInsured:values?.additionalTabDetails?.nomineeDetails?.relationshipWithInsured
          ? `${values?.additionalTabDetails?.nomineeDetails?.relationshipWithInsured}`
          : '',
          insuredRelationship: values?.additionalTabDetails?.nomineeDetails?.relationshipWithNominee
          ? `${values?.additionalTabDetails?.nomineeDetails?.relationshipWithNominee}`
          : '',
          nameOfAppointee:values?.additionalTabDetails?.nomineeDetails?.nameOfAppointee
          ? `${values?.additionalTabDetails?.nomineeDetails?.nameOfAppointee}`
          : '',
          relationshipWithAppointee:values?.additionalTabDetails?.nomineeDetails?.relationshipWithAppointee
          ? `${values?.additionalTabDetails?.nomineeDetails?.relationshipWithAppointee}`
          : '',
        },
        riskCovers: riskInput,
        creditScore: {
          discountOpted:
            viewRenewMotorPolicy?.quoteData
              ?.getAdditionalCreditScore === 'Yes',
          idProofType: viewRenewMotorPolicy?.quoteData?.idProofType,
          idProofNumber:
            viewRenewMotorPolicy?.quoteData?.idProofNumber,
          creditScore:
            viewRenewMotorPolicy?.quoteData?.premiumData
              ?.creditScore !== null &&
            viewRenewMotorPolicy?.quoteData?.premiumData
              ?.creditScore !== undefined
              ? parseFloat(
                  viewRenewMotorPolicy?.quoteData?.premiumData
                    ?.creditScore,
                )
              : null,
        },
        proposerPincode: viewRenewMotorPolicy?.quoteData?.pincode,
        voluntaryDeductibleAmt:
          viewRenewMotorPolicy?.quoteData
            ?.voluntaryDeductibleAmount !== null &&
          viewRenewMotorPolicy?.quoteData
            ?.voluntaryDeductibleAmount !== undefined
            ? parseFloat(
                viewRenewMotorPolicy?.quoteData
                  ?.voluntaryDeductibleAmount,
              )
            : null,
        quoteNumber: viewRenewMotorPolicy?.quoteNumber,
        customer: {
          id: viewRenewMotorPolicy?.proposerDetails?.id,
          customerType:
            viewRenewMotorPolicy?.proposerDetails?.customerType,
          isThinCustomer: false,
          title: viewRenewMotorPolicy?.proposerDetails?.title,
          gender: viewRenewMotorPolicy?.proposerDetails?.gender,
          firstName: viewRenewMotorPolicy?.proposerDetails?.firstName,
          middleName:
            viewRenewMotorPolicy?.proposerDetails?.middleName,
          lastName: viewRenewMotorPolicy?.proposerDetails?.lastName,
          fullName: viewRenewMotorPolicy?.proposerDetails?.fullName,
          proposerDOB:
            viewRenewMotorPolicy?.proposerDetails?.proposerDOB,
          maritalStatus:
            viewRenewMotorPolicy?.proposerDetails?.maritalStatus,
          occupation:
            viewRenewMotorPolicy?.proposerDetails?.occupation,
          nationality:
            viewRenewMotorPolicy?.proposerDetails?.nationality,
          idProofType:
            viewRenewMotorPolicy?.proposerDetails?.idProofType,
          idProofNumber:
            viewRenewMotorPolicy?.proposerDetails?.idProofNumber,
          panNumber: viewRenewMotorPolicy?.proposerDetails?.panNumber,
          orgName: viewRenewMotorPolicy?.proposerDetails?.orgName,
          orgType: viewRenewMotorPolicy?.proposerDetails?.orgType,
          contactName:
            viewRenewMotorPolicy?.proposerDetails?.contactName,
          regNumber: viewRenewMotorPolicy?.proposerDetails?.regNumber,
          tanNumber: viewRenewMotorPolicy?.proposerDetails?.tanNumber,
          gstNumber: viewRenewMotorPolicy?.proposerDetails?.gstNumber,
          permAddressLine1:
            values?.proposerDetails?.permAddressLine1,
          permAddressLine2:
            values?.proposerDetails?.permAddressLine2,
          permAddressLine3:
            values?.proposerDetails?.permAddressLine3,
          permLandmark:
            values?.proposerDetails?.permLandmark,
          permPincode: values?.proposerDetails?.permPincode,
          permCityTownVillage:
            values?.proposerDetails?.permCityTownVillage,
          permDistrict:
            values?.proposerDetails?.permDistrict,
          permState: values?.proposerDetails?.permState,
          permCommAddressYN: values?.proposerDetails
            ?.permCommAddressYN
            ? true
            : false,
          commAddressLine1:
            values?.proposerDetails?.commAddressLine1,
          commAddressLine2:
            values?.proposerDetails?.commAddressLine2,
          commAddressLine3:
            values?.proposerDetails?.commAddressLine3,
          commLandmark:
            values?.proposerDetails?.commLandmark,
          commPincode: values?.proposerDetails?.commPincode,
          commCityTownVillage:
            values?.proposerDetails?.commCityTownVillage,
          commDistrict:
            values?.proposerDetails?.commDistrict,
          commState: values?.proposerDetails?.commState,
          phoneNo: viewRenewMotorPolicy?.proposerDetails?.phoneNo,
          mobileNo: values?.proposerDetails?.mobileNo,
          emailID: values?.proposerDetails?.emailID,
          faxNo: viewRenewMotorPolicy?.proposerDetails?.faxNo,
          altPhoneNo:
            viewRenewMotorPolicy?.proposerDetails?.altPhoneNo,
          altMobileNo:
            viewRenewMotorPolicy?.proposerDetails?.altMobileNo,
          ifscCode:
            viewRenewMotorPolicy?.proposerDetailsMeta?.ifscCode,
          bankName:
            viewRenewMotorPolicy?.proposerDetailsMeta?.bankName,
          branchName:
            viewRenewMotorPolicy?.proposerDetailsMeta?.branchName,
          bankAcno:
            viewRenewMotorPolicy?.proposerDetailsMeta?.bankAcno,
          accountHolderName:
            viewRenewMotorPolicy?.proposerDetailsMeta
              ?.accountHolderName,
          micrCode:
            viewRenewMotorPolicy?.proposerDetailsMeta?.micrCode,
          employeeNumber:
            viewRenewMotorPolicy?.proposerDetails?.employeeNumber,
        },
        proposalNumber: viewRenewMotorPolicy?.proposalNumber,
        policyNumber: '',
        //policyNumber: viewRenewMotorPolicy?.policyNumber,
        leadGenerator: viewRenewMotorPolicy
          ?.reviewAndConfirmTabDetails?.leadGenerator
          ? `${viewRenewMotorPolicy?.reviewAndConfirmTabDetails?.leadGenerator}`
          : '',
        proposalPaymentType:
          values?.reviewAndConfirmTabDetails
            ?.proposalPaymentType,
        modeOfOperation: renewalMode,
        startDate: viewRenewMotorPolicy?.policy?.startDate
          ? `${viewRenewMotorPolicy?.policy?.startDate}`
          : '',
        endDate: viewRenewMotorPolicy?.policy?.endDate
          ? `${viewRenewMotorPolicy?.policy?.endDate}`
          : '',
      },
    };
  };
  const onSubmit = async (values) => {
    if (!viewRenewMotorPolicy?.isProposalRenewed) {
      if(UWCompleted&&viewRenewMotorPolicy?.proposalStatus==='RCCN'&&modify=='false'){
        setParentAlerts([]);
        window.scrollTo({ top: 0, behavior: 'smooth' });
        return true;
    }
    else {
      try {
        setParentAlerts([]);
        const submitRenewalMutationQuery = mutateQuery({
          mutation: SUBMIT_RENEWAL_TW,
          variables: getRenewalInput(
            values,
            props?.forwardedPremiumFormRef?.current?.values,
          ),
        });
        setLoadingStep(true);
        window.scrollTo({ top: 0, behavior: 'smooth' });
        updateViewRenewMotorPolicyVar({ isProposalRenewing: true });
        setCustomLoadingMessage('Renewing Proposal');
        const { data: submitRenewalData } =
          await submitRenewalMutationQuery;
        setLoadingStep(false);
        setCustomLoadingMessage(null);
        if (submitRenewalData?.submitPCVRenewal?.VehicleInspectionNeeded){
          // setFieldValue('preinspectionDetails.isVehicleInspectionNeeded',true)
          updateViewRenewMotorPolicyVar({
            preinspectionDetails:{isVehicleInspectionNeeded: true},
          });
        }
        if (submitRenewalData?.submitPCVRenewal?.warningMsg) {
          setParentAlerts([
            {
              header: 'Proposal Renewed Successfully',
              content: (
                <div className="flex flex-col w-full h-full">
                  <Text type="normal">
                    <FontAwesomeIcon
                      icon={faCheck}
                      className="text-success"
                    />{' '}
                    Proposal Number:{' '}
                    {
                      submitRenewalData?.submitPCVRenewal
                        ?.proposalNumber
                    }
                  </Text>
                </div>
              ),
              type: 'success',
              timeout: null,
              disableClose: false,
            },
            {
              content: (
                <Text type="normal">
                  {submitRenewalData?.submitPCVRenewal?.warningMsg}
                </Text>
              ),
              type: 'warning',
              timeout: null,
              disableClose: false,
            },
          ]);
        } else {
          setParentAlerts([
            {
              header: 'Proposal Renewed Successfully',
              id: Date.now(),
              content: (
                <div className="flex flex-col w-full h-full">
                  <Text type="normal">
                    <FontAwesomeIcon
                      icon={faCheck}
                      className="text-success"
                    />{' '}
                    Proposal Number:{' '}
                    {
                      submitRenewalData?.submitPCVRenewal
                        ?.proposalNumber
                    }
                  </Text>
                </div>
              ),
              type: 'success',
              timeout: null,
              disableClose: false,
            },
          ]);
        }
        updateViewRenewMotorPolicyVar({
          isProposalRenewing: false,
          proposalNumber:
            submitRenewalData?.submitPCVRenewal?.proposalNumber,
          proposalStatus:
            submitRenewalData?.submitPCVRenewal?.proposalStatus,
          isProposalApplicableForPayment:
            submitRenewalData?.submitPCVRenewal
              ?.isApplicableForPayment,
          isProposalRenewed: true,
          vehicleTabDetails: values?.vehicleTabDetails,
          additionalTabDetails: values?.additionalTabDetails,
          reviewAndConfirmTabDetails: {
            proposalPaymentType: values?.reviewAndConfirmTabDetails
              ?.proposalPaymentType
              ? `${values?.reviewAndConfirmTabDetails?.proposalPaymentType}`
              : '',
            leadGenerator: values?.reviewAndConfirmTabDetails
              ?.leadGenerator
              ? `${values?.reviewAndConfirmTabDetails?.leadGenerator}`
              : '',
            isProposalCreated: true,
          },
          proposerDetails: {
            ...proposerDetails,
            permAddressLine1:
              values?.proposerDetails?.permAddressLine1,
            permAddressLine2:
              values?.proposerDetails?.permAddressLine2,
            permAddressLine3:
              values?.proposerDetails?.permAddressLine3,
            permLandmark: values?.proposerDetails?.permLandmark,
            permPincode: values?.proposerDetails?.permPincode,
            permCityTownVillage:
              values?.proposerDetails?.permCityTownVillage,
            permDistrict: values?.proposerDetails?.permDistrict,
            permState: values?.proposerDetails?.permState,
            commAddressLine1:
              values?.proposerDetails?.commAddressLine1,
            commAddressLine2:
              values?.proposerDetails?.commAddressLine2,
            commAddressLine3:
              values?.proposerDetails?.commAddressLine3,
            commLandmark: values?.proposerDetails?.commLandmark,
            commPincode: values?.proposerDetails?.commPincode,
            commCityTownVillage:
              values?.proposerDetails?.commCityTownVillage,
            commDistrict: values?.proposerDetails?.commDistrict,
            commState: values?.proposerDetails?.commState,
            mobileNo: values?.proposerDetails?.mobileNo,
            emailID: values?.proposerDetails?.emailID,
            phoneNo: values?.proposerDetails?.phoneNo,
            altPhoneNo: values?.proposerDetails?.altPhoneNo,
            altMobileNo: values?.proposerDetails?.altMobileNo,
            faxNo: values?.proposerDetails?.faxNo,
            permCommAddressYN: values?.proposerDetails
              ?.permCommAddressYN
              ? true
              : false,
            panNumber : values?.proposerDetails?.panNumber,
          },
          premiumData: {
            idv1: submitRenewalData?.submitPCVRenewal?.premium?.idv1
              ? `${submitRenewalData?.submitPCVRenewal?.premium?.idv1}`
              : '',
            idv2: submitRenewalData?.submitPCVRenewal?.premium?.idv2
              ? `${submitRenewalData?.submitPCVRenewal?.premium?.idv2}`
              : '',
            idv3: submitRenewalData?.submitPCVRenewal?.premium?.idv3
              ? `${submitRenewalData?.submitPCVRenewal?.premium?.idv3}`
              : '',
            tenure:
              submitRenewalData?.submitPCVRenewal?.premium?.tenure ||
              viewRenewMotorPolicy?.premiumData?.tenure
                ? `${
                    submitRenewalData?.submitPCVRenewal?.premium
                      ?.tenure ||
                    viewRenewMotorPolicy?.premiumData?.tenure
                  }`
                : '',
            netODPremium:
              submitRenewalData?.submitPCVRenewal?.premium
                ?.netODPremium !== null &&
              submitRenewalData?.submitPCVRenewal?.premium
                ?.netODPremium !== undefined &&
              submitRenewalData?.submitPCVRenewal?.premium
                ?.netODPremium !== ''
                ? submitRenewalData?.submitPCVRenewal?.premium
                    ?.netODPremium
                : null,
            netTPPremium:
              submitRenewalData?.submitPCVRenewal?.premium
                ?.netTPPremium !== null &&
              submitRenewalData?.submitPCVRenewal?.premium
                ?.netTPPremium !== undefined &&
              submitRenewalData?.submitPCVRenewal?.premium
                ?.netTPPremium !== ''
                ? submitRenewalData?.submitPCVRenewal?.premium
                    ?.netTPPremium
                : null,
            loadingDiscount:
              submitRenewalData?.submitPCVRenewal?.premium
                ?.loadingDiscount !== null &&
              submitRenewalData?.submitPCVRenewal?.premium
                ?.loadingDiscount !== undefined &&
              submitRenewalData?.submitPCVRenewal?.premium
                ?.netTPPremium !== ''
                ? submitRenewalData?.submitPCVRenewal?.premium
                    ?.loadingDiscount
                : null,
            netPremium:
              submitRenewalData?.submitPCVRenewal?.premium
                ?.netPremium !== null &&
              submitRenewalData?.submitPCVRenewal?.premium
                ?.netPremium !== undefined &&
              submitRenewalData?.submitPCVRenewal?.premium
                ?.netPremium !== ''
                ? submitRenewalData?.submitPCVRenewal?.premium
                    ?.netPremium
                : null,
            gst:
              submitRenewalData?.submitPCVRenewal?.premium?.gst !==
                null &&
              submitRenewalData?.submitPCVRenewal?.premium?.gst !==
                undefined &&
              submitRenewalData?.submitPCVRenewal?.premium?.gst !== ''
                ? submitRenewalData?.submitPCVRenewal?.premium?.gst
                : null,
            stampDuty:
              submitRenewalData?.submitPCVRenewal?.premium
                ?.stampDuty !== null &&
              submitRenewalData?.submitPCVRenewal?.premium
                ?.stampDuty !== undefined &&
              submitRenewalData?.submitPCVRenewal?.premium
                ?.stampDuty !== ''
                ? submitRenewalData?.submitPCVRenewal?.premium
                    ?.stampDuty
                : null,
            totalPremium:
              submitRenewalData?.submitPCVRenewal?.premium
                ?.totalPremium !== null &&
              submitRenewalData?.submitPCVRenewal?.premium
                ?.totalPremium !== undefined &&
              submitRenewalData?.submitPCVRenewal?.premium
                ?.totalPremium !== ''
                ? submitRenewalData?.submitPCVRenewal?.premium
                    ?.totalPremium
                : null,
            loading:
              submitRenewalData?.submitPCVRenewal?.premium?.loading &&
              submitRenewalData?.submitPCVRenewal?.premium?.loading
                ?.length > 0
                ? submitRenewalData?.submitPCVRenewal?.premium?.loading
                : [],
            discount:
              submitRenewalData?.submitPCVRenewal?.premium?.discount &&
              submitRenewalData?.submitPCVRenewal?.premium?.discount
                ?.length > 0
                ? submitRenewalData?.submitPCVRenewal?.premium
                    ?.discount
                : [],
            vehicleAge: submitRenewalData?.submitPCVRenewal?.premium
              ?.vehicleAge
              ? `${submitRenewalData?.submitPCVRenewal?.premium?.vehicleAge}`
              : '',
            claimFreeYear: submitRenewalData?.submitPCVRenewal?.premium
              ?.claimFreeYear
              ? `${submitRenewalData?.submitPCVRenewal?.premium?.claimFreeYear}`
              : '',
            creditScore: submitRenewalData?.submitPCVRenewal?.premium
              ?.creditScore
              ? `${submitRenewalData?.submitPCVRenewal?.premium?.creditScore}`
              : '',
          },
          intermediaryDetails: {
            intermediaryName: getDomainData(
              myIntermediaries,
              values?.intermediaryData?.intermediary,
              'intermediaryCode',
              'intermediaryName',
            )
              ? getDomainData(
                  myIntermediaries,
                  values?.intermediaryData?.intermediary,
                  'intermediaryCode',
                  'intermediaryName',
                )
              : '',
            branchOfficeName: getDomainData(
              myIntermediaries?.find(
                (intermediary) =>
                  intermediary?.intermediaryCode
                    ?.toString()
                    ?.toLowerCase() ===
                  values?.intermediaryData?.intermediary
                    ?.toString()
                    ?.toLowerCase(),
              )?.businessLocations,
              values?.intermediaryData?.businessLocation,
              'code',
              'name',
            )
              ? getDomainData(
                  myIntermediaries?.find(
                    (intermediary) =>
                      intermediary?.intermediaryCode
                        ?.toString()
                        ?.toLowerCase() ===
                      values?.intermediaryData?.intermediary
                        ?.toString()
                        ?.toLowerCase(),
                  )?.businessLocations,
                  values?.intermediaryData?.businessLocation,
                  'code',
                  'name',
                )
              : '',
            code: values?.intermediaryData?.intermediary
              ? `${values?.intermediaryData?.intermediary}`
              : '',
            location: values?.intermediaryData?.businessLocation
              ? `${values?.intermediaryData?.businessLocation}`
              : '',
            fieldUserCode: values?.intermediaryData?.fieldUser
              ? `${values?.intermediaryData?.fieldUser}`
              : '',
            fieldUserName:
              values?.intermediaryData?.fieldUser &&
              getDomainData(
                values?.intermediaryData?.fieldUserList,
                values?.intermediaryData?.fieldUser,
                'fieldUserCode',
                'fieldUserName',
              )
                ? getDomainData(
                    values?.intermediaryData?.fieldUserList,
                    values?.intermediaryData?.fieldUser,
                    'fieldUserCode',
                    'fieldUserName',
                  )
                : '',
          },
        });
        sessionStorage?.setItem(
          'intermediaryName',
          getDomainData(
            myIntermediaries,
            values?.intermediaryData?.intermediary,
            'intermediaryCode',
            'intermediaryName',
          )
            ? getDomainData(
                myIntermediaries,
                values?.intermediaryData?.intermediary,
                'intermediaryCode',
                'intermediaryName',
              )
            : '',
        );
        sessionStorage?.setItem(
          'intermediaryCode',
          values?.intermediaryData?.intermediary
            ? `${values?.intermediaryData?.intermediary}`
            : '',
        );
        sessionStorage?.setItem(
          'branchOfficeCode',
          values?.intermediaryData?.businessLocation
            ? `${values?.intermediaryData?.businessLocation}`
            : '',
        );
        sessionStorage?.setItem(
          'branchOfficeName',
          getDomainData(
            myIntermediaries?.find(
              (intermediary) =>
                intermediary?.intermediaryCode
                  ?.toString()
                  ?.toLowerCase() ===
                values?.intermediaryData?.intermediary
                  ?.toString()
                  ?.toLowerCase(),
            )?.businessLocations,
            values?.intermediaryData?.businessLocation,
            'code',
            'name',
          )
            ? getDomainData(
                myIntermediaries?.find(
                  (intermediary) =>
                    intermediary?.intermediaryCode
                      ?.toString()
                      ?.toLowerCase() ===
                    values?.intermediaryData?.intermediary
                      ?.toString()
                      ?.toLowerCase(),
                )?.businessLocations,
                values?.intermediaryData?.businessLocation,
                'code',
                'name',
              )
            : '',
        );
        sessionStorage?.setItem(
          'fieldUserCode',
          values?.intermediaryData?.fieldUser
            ? `${values?.intermediaryData?.fieldUser}`
            : '',
        );
        sessionStorage?.setItem(
          'fieldUserName',
          values?.intermediaryData?.fieldUser &&
            getDomainData(
              values?.intermediaryData?.fieldUserList,
              values?.intermediaryData?.fieldUser,
              'fieldUserCode',
              'fieldUserName',
            )
            ? getDomainData(
                values?.intermediaryData?.fieldUserList,
                values?.intermediaryData?.fieldUser,
                'fieldUserCode',
                'fieldUserName',
              )
            : '',
        );
        updateAllIntermediaryFields({
          intermediaryName: getDomainData(
            myIntermediaries,
            values?.intermediaryData?.intermediary,
            'intermediaryCode',
            'intermediaryName',
          )
            ? getDomainData(
                myIntermediaries,
                values?.intermediaryData?.intermediary,
                'intermediaryCode',
                'intermediaryName',
              )
            : '',
          intermediaryCode: values?.intermediaryData?.intermediary
            ? `${values?.intermediaryData?.intermediary}`
            : '',
          branchOfficeCode: values?.intermediaryData?.businessLocation
            ? `${values?.intermediaryData?.businessLocation}`
            : '',
          branchOfficeName: getDomainData(
            myIntermediaries?.find(
              (intermediary) =>
                intermediary?.intermediaryCode
                  ?.toString()
                  ?.toLowerCase() ===
                values?.intermediaryData?.intermediary
                  ?.toString()
                  ?.toLowerCase(),
            )?.businessLocations,
            values?.intermediaryData?.businessLocation,
            'code',
            'name',
          )
            ? getDomainData(
                myIntermediaries?.find(
                  (intermediary) =>
                    intermediary?.intermediaryCode
                      ?.toString()
                      ?.toLowerCase() ===
                    values?.intermediaryData?.intermediary
                      ?.toString()
                      ?.toLowerCase(),
                )?.businessLocations,
                values?.intermediaryData?.businessLocation,
                'code',
                'name',
              )
            : '',
          fieldUserCode: values?.intermediaryData?.fieldUser
            ? `${values?.intermediaryData?.fieldUser}`
            : '',
          fieldUserName:
            values?.intermediaryData?.fieldUser &&
            getDomainData(
              values?.intermediaryData?.fieldUserList,
              values?.intermediaryData?.fieldUser,
              'fieldUserCode',
              'fieldUserName',
            )
              ? getDomainData(
                  values?.intermediaryData?.fieldUserList,
                  values?.intermediaryData?.fieldUser,
                  'fieldUserCode',
                  'fieldUserName',
                )
              : '',
        });
        return true;
      } catch (error) {
        if(error?.message){
          if(error?.message.includes("Unexpected token")){
            error.message='Please try again after sometime';
          }
        }
        setParentAlerts([
          {
            header: 'Error',
            id: Date.now(),
            content: (
              <div className="flex flex-row flex-wrap space-y-2 w-full h-full">
                {error?.message}
              </div>
            ),
            type: 'error',
            timeout: null,
            disableClose: false,
          },
        ]);
        setLoadingStep(false);
        if (
          props?.forwardedAlertsRef &&
          props?.forwardedAlertsRef?.current
        ) {
          props.forwardedAlertsRef.current = [];
        }
        updateViewRenewMotorPolicyVar({
          isProposalRenewing: false,
          vehicleTabDetails: values?.vehicleTabDetails,
          additionalTabDetails: values?.additionalTabDetails,
          reviewAndConfirmTabDetails: {
            proposalPaymentType: values?.reviewAndConfirmTabDetails
              ?.proposalPaymentType
              ? `${values?.reviewAndConfirmTabDetails?.proposalPaymentType}`
              : '',
            leadGenerator: values?.reviewAndConfirmTabDetails
              ?.leadGenerator
              ? `${values?.reviewAndConfirmTabDetails?.leadGenerator}`
              : '',
            isProposalCreated: true,
          },
          proposerDetails: {
            ...proposerDetails,
            permAddressLine1:
              values?.proposerDetails?.permAddressLine1,
            permAddressLine2:
              values?.proposerDetails?.permAddressLine2,
            permAddressLine3:
              values?.proposerDetails?.permAddressLine3,
            permLandmark: values?.proposerDetails?.permLandmark,
            permPincode: values?.proposerDetails?.permPincode,
            permCityTownVillage:
              values?.proposerDetails?.permCityTownVillage,
            permDistrict: values?.proposerDetails?.permDistrict,
            permState: values?.proposerDetails?.permState,
            commAddressLine1:
              values?.proposerDetails?.commAddressLine1,
            commAddressLine2:
              values?.proposerDetails?.commAddressLine2,
            commAddressLine3:
              values?.proposerDetails?.commAddressLine3,
            commLandmark: values?.proposerDetails?.commLandmark,
            commPincode: values?.proposerDetails?.commPincode,
            commCityTownVillage:
              values?.proposerDetails?.commCityTownVillage,
            commDistrict: values?.proposerDetails?.commDistrict,
            commState: values?.proposerDetails?.commState,
            mobileNo: values?.proposerDetails?.mobileNo,
            emailID: values?.proposerDetails?.emailID,
            phoneNo: values?.proposerDetails?.phoneNo,
            altPhoneNo: values?.proposerDetails?.altPhoneNo,
            altMobileNo: values?.proposerDetails?.altMobileNo,
            panNumber : values?.proposerDetails?.panNumber,
          },
          intermediaryDetails: {
            code: values?.intermediaryData?.intermediary
              ? `${values?.intermediaryData?.intermediary}`
              : '',
            location: values?.intermediaryData?.businessLocation
              ? `${values?.intermediaryData?.businessLocation}`
              : '',
            fieldUserCode: values?.intermediaryData?.fieldUser
              ? `${values?.intermediaryData?.fieldUser}`
              : '',
            fieldUserName:
              values?.intermediaryData?.fieldUser &&
              getDomainData(
                values?.intermediaryData?.fieldUserList,
                values?.intermediaryData?.fieldUser,
                'fieldUserCode',
                'fieldUserName',
              )
                ? getDomainData(
                    values?.intermediaryData?.fieldUserList,
                    values?.intermediaryData?.fieldUser,
                    'fieldUserCode',
                    'fieldUserName',
                  )
                : '',
          },
        });
        return false;
      }
      }
    } else {
      setParentAlerts([]);
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return true;
    }
  };

  const RenewReviewAndConfirmForm = ({ validate }) => {
    const { values, setFieldValue } = useQuantaFormikContext();
    const [valueChanges, setValueChanges] = useState(values);
    const [alerts, setAlerts] = useState([]);
    const [loadingPermCustAddr, setLoadingPermCustAddr] =
      useState(false);
    const [loadingCommCustAddr, setLoadingCommCustAddr] =
      useState(false);
    const [loadingFieldUserList, setLoadingFieldUserList] =
      useState(false);
    const [errorFieldUserList, setErrorFieldUserList] =
      useState(null);
      const [isCalculatingPremium, setCalculatingPremium] =
      useState(false);
      const [premiumData, setPremiumData] = useState(null);
      const [resultPremiumError, setResultPremiumError] = useState(null);
      const [warningMsg,setWarningMsg] = useState(null);
    const [
      intermediaryDetailsCardToggle,
      setIntermediaryDetailsCardToggle,
    ] = useState(true);
    const [proposerDetailsCardToggle, setProposerDetailsCardToggle] =
      useState(true);
    const [
      vehicleAndRegistrationDetailsCardToggle,
      setVehicleAndRegistrationDetailsCardToggle,
    ] = useState(
      validate(values)?.vehicleTabDetails?.vehicleRegistrationDetails
        ?.registrationNumber
        ? false
        : true,
    );
    const [financerDetailsCardToggle, setFinancerDetailsCardToggle] =
      useState(true);
    const [financierNameModalDisplay, showFinancierNameModal] =
      useState(false);
    const [financierNameOutput, setFinancierNameOutput] = useState(
      [],
    );
    const [errors, setErrors] = useState({ financierNameList: '' });
    const [onDataUpdate, setOnUpdate] = useState(null);
    const [loadingFinancierName, setLoadingFinancierName] =
      useState(false);
    const [searchStringFinancierName, setSearchStringFinancierName] =
      useState('');
    const MINOR_THRESHOLD_AGE = 18;
    const reformData = (val, returnType) => {
      return val && val.toString().trim() !== '' ? val : returnType;
    };

    useEffect(() => {
      let isMounted = true;
      if (
        values?.intermediaryData?.initFetchFieldUserListRequired &&
        isMounted
      ) {
        const fieldUserQuery = fetchQuery({
          query: GET_FIELDUSER_LIST,
          fetchPolicy: 'network-only',
          variables: {
            input: {
              intermediaryCode:
                values?.intermediaryData?.intermediary,
              officeId: values?.intermediaryData?.businessLocation,
            },
          },
        });
        if (
          isMounted &&
          values?.intermediaryData?.initFetchFieldUserListRequired
        ) {
          setLoadingFieldUserList(true);
        }

        fieldUserQuery
          .then((result) => {
            if (loadingFieldUserList) {
              setLoadingFieldUserList(false);
            }
            if (
              isMounted &&
              values?.intermediaryData?.initFetchFieldUserListRequired
            ) {
              setLoadingFieldUserList(false);
              setErrorFieldUserList(null);
              setFieldValue(
                `intermediaryData.fieldUserList`,
                result?.data?.getFiledUserByIMID,
              );
              setFieldValue(
                `intermediaryData.initFetchFieldUserListRequired`,
                false,
              );
              if (
                !values?.intermediaryData?.fieldUser &&
                viewRenewMotorPolicy?.intermediaryDetails
                  ?.fieldUserCode &&
                values?.intermediaryData?.intermediary
                  ?.toString()
                  ?.toLowerCase() ===
                  viewRenewMotorPolicy?.intermediaryDetails?.code
                    ?.toString()
                    ?.toLowerCase() &&
                values?.intermediaryData?.businessLocation
                  ?.toString()
                  ?.toLowerCase() ===
                  viewRenewMotorPolicy?.intermediaryDetails?.location
                    ?.toString()
                    ?.toLowerCase()
              ) {
                setFieldValue(
                  `intermediaryData.fieldUser`,
                  viewRenewMotorPolicy?.intermediaryDetails
                    ?.fieldUserCode,
                );
              }
            }
          })
          .catch((error) => {
            if (loadingFieldUserList) {
              setLoadingFieldUserList(false);
            }
            if (
              isMounted &&
              values?.intermediaryData?.initFetchFieldUserListRequired
            ) {
              setFieldValue(
                `intermediaryData.initFetchFieldUserListRequired`,
                false,
              );
              setLoadingFieldUserList(false);
              setErrorFieldUserList(error?.message);
            }
          });
      }
      return () => {
        isMounted = false;
      };
    }, [
      values?.intermediaryData?.intermediary,
      values?.intermediaryData?.businessLocation,
      values?.intermediaryData?.initFetchFieldUserListRequired,
    ]);

    useEffect(() => {
      setIntermediaryDetailsCardToggle(
        !expandedCard?.current?.find(
          (exp) => exp?.cardName === 'intermediaryDetails',
        )?.cardFlag,
      );
      setProposerDetailsCardToggle(
        !expandedCard?.current?.find(
          (exp) => exp?.cardName === 'proposerDetails',
        )?.cardFlag,
      );
      setFinancerDetailsCardToggle(
        !expandedCard?.current?.find(
          (exp) => exp?.cardName === 'financeDetails',
        )?.cardFlag,
      );
      setVehicleAndRegistrationDetailsCardToggle(
        !expandedCard?.current?.find(
          (exp) => exp?.cardName === 'vehicleAndRegistrationDetails',
        )?.cardFlag,
      );
    }, [
      expandedCard?.current?.find(
        (exp) => exp?.cardName === 'intermediaryDetails',
      )?.cardFlag,
      expandedCard?.current?.find(
        (exp) => exp?.cardName === 'proposerDetails',
      )?.cardFlag,
      expandedCard?.current?.find(
        (exp) => exp?.cardName === 'financeDetails',
      )?.cardFlag,
      expandedCard?.current?.find(
        (exp) => exp?.cardName === 'vehicleAndRegistrationDetails',
      )?.cardFlag,
    ]);

    const onPermAddrLookup = async (val, setFieldValue) => {
      if (
        !(
          val.toString().length !== 6 ||
          !val.toString().match(/^[0-9]+$/)
        )
      ) {
        let queryOutput = fetchQuery({
          query: PINCODE_LOOKUP,
          variables: {
            filter: {
            pincode: val,
            },
          },
        });
        try {
          setAlerts([]);
          setLoadingPermCustAddr(true);
          let { data } = await queryOutput;
          setLoadingPermCustAddr(false);
          setFieldValue(
            'proposerDetails.permCityTownVillage',
            data?.pincodeInfo?.city,
          );
          setFieldValue(
            'proposerDetails.permDistrict',
            data?.pincodeInfo?.district,
          );
          setFieldValue(
            'proposerDetails.permState',
            data?.pincodeInfo?.state,
          );
          if (values?.proposerDetails?.permCommAddressYN) {
            setFieldValue(
              'proposerDetails.commCityTownVillage',
              data?.pincodeInfo?.city,
            );
            setFieldValue(
              'proposerDetails.commDistrict',
              data?.pincodeInfo?.district,
            );
            setFieldValue(
              'proposerDetails.commState',
              data?.pincodeInfo?.state,
            );
          }
        } catch (error) {
          setAlerts([
            {
              header: 'Address fetch failed',
              id: alerts?.length + 1,
              content: (
                <div className="flex flex-row flex-wrap space-y-2 w-full h-full">
                  <span>{error?.message}</span>
                </div>
              ),
              type: 'error',
              timeout: null,
              disableClose: false,
            },
          ]);
          setLoadingPermCustAddr(false);
          setFieldValue('proposerDetails.permCityTownVillage', '');
          setFieldValue('proposerDetails.permDistrict', '');
          setFieldValue('proposerDetails.permState', '');
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }
      }
    };

    const onCommAddrLookup = async (val, setFieldValue) => {
      if (
        !(
          val.toString().length !== 6 ||
          !val.toString().match(/^[0-9]+$/)
        )
      ) {
        let queryOutput = fetchQuery({
          query: PINCODE_LOOKUP,
          variables: {
            filter: {
            pincode: val,
            },
          },
        });
        try {
          setAlerts([]);
          setLoadingCommCustAddr(true);
          let { data } = await queryOutput;
          setLoadingCommCustAddr(false);
          setFieldValue(
            'proposerDetails.commCityTownVillage',
            data?.pincodeInfo?.city,
          );
          setFieldValue(
            'proposerDetails.commDistrict',
            data?.pincodeInfo?.district,
          );
          setFieldValue(
            'proposerDetails.commState',
            data?.pincodeInfo?.state,
          );
        } catch (error) {
          setAlerts([
            {
              header: 'Address fetch failed',
              id: alerts?.length + 1,
              content: (
                <div className="flex flex-row flex-wrap space-y-2 w-full h-full">
                  <span>{error?.message}</span>
                </div>
              ),
              type: 'error',
              timeout: null,
              disableClose: false,
            },
          ]);
          setLoadingCommCustAddr(false);
          setFieldValue('proposerDetails.commCityTownVillage', '');
          setFieldValue('proposerDetails.commDistrict', '');
          setFieldValue('proposerDetails.commState', '');
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }
      }
    };

    const onFinancierNameSearch = async (val, _) => {
      if (val.length > 0) {
        try {
          setFinancierNameOutput([]);
          let queryOutput = fetchQuery({
            query: FINANCIER_NAME_LIST,
            variables: {
              value: val,
            },
          });
          setLoadingFinancierName(true);
          let { data } = await queryOutput;
          setLoadingFinancierName(false);
          setFinancierNameOutput(data.getFinancierNameList);
        } catch (error) {
          setErrors({
            ...errors,
            financierNameList: error?.message,
          });
          setLoadingFinancierName(false);
          setFinancierNameOutput([]);
        }
      }
    };
    const searchInput = {
      flow: 'cols',
      repeat: 5,
      data:
        changeInputType === 'text'
          ? [
              {
                type: 'text',
                name: 'searchString',
                size: 'full',
                colSpan: colSpanParams.searchString,
              },
              {
                type: 'submit',
                size: 'full',
                colSpan: colSpanParams.button,
                iconPre: <FontAwesomeIcon icon={faSearch} />,
                children: 'Search',
              },
            ]
          : [
              {
                type: 'input-lookup',
                name: 'searchString',
                size: 'full',
                colSpan: colSpanParams.searchString,
                onLookup: onFinancierNameSearch,
              },
            ],
      initialValues: {
        searchString: searchStringFinancierName,
      },
      validate: (values) => {
        const errors = {};
        if (!values.searchString) errors.searchString = '* Required';
        return errors;
      },
      onSearch: async (values) => {
        try {
          setFinancierNameOutput([]);
          let queryOutput = fetchQuery({
            query: FINANCIER_NAME_LIST,
            variables: {
              value: values.searchString,
            },
          });
          setLoadingFinancierName(true);
          let { data } = await queryOutput;
          setLoadingFinancierName(false);
          setFinancierNameOutput(data.getFinancierNameList);
        } catch (error) {
          setErrors({
            ...errors,
            financierNameList: error?.message,
          });
          setLoadingFinancierName(false);
          setFinancierNameOutput([]);
        }
      },
    };
    const icon_idle = (

      <img
  
        src={branding.illustration.no_data}
  
        alt="no data"
  
        className="lg:w-80 lg:h-80 w-64 h-64 opacity-50"
  
      />
  
    );
    const searchResults = {
      data: financierNameOutput,
      onIdle: () => {
        if (loadingFinancierName) {
          return <Loading />;
        } else if (searchStringFinancierName === '') {
          return <icon_idle />;
        }
        return undefined;
      },
      columns: [
        {
          Header: 'Financer Name',
          accessor: 'value',
        },
      ],
      list: financierNameOutput.map((data) => {
        return {
          title: `${data.value}`,
          onClick: () => {
            onDataUpdate(data);
            showFinancierNameModal(false);
            document.body.classList.remove('overflow-y-hidden');
          },
        };
      }),
      sortBy: { id: 'value', desc: false },
    };
    const onClose = () => {
      showFinancierNameModal(false);
    };
    const onNoResultsFound = () => {
      return errors.financierNameList;
    };
    const onMessage = () => {};
    const paginationInput = {
      offset: 0,
      PAGE_SIZE: 4,
    };
    const reviewAndConfirmData = [
      {
        // title: 'Review Proposal',
        grid_type: 'data',
        grid_data: [
          {
            label: 'Product Name',
            colSpan: repeat === repeatForMobile ? 2 : 1,
            text: productName,
          },
          {
            label: 'Business Type',
            text: viewRenewMotorPolicy?.quoteData?.businessTypeValue,
          },
          {
            label: 'Tenure',
            text:
              viewRenewMotorPolicy?.quoteData?.tenure ||
              viewRenewMotorPolicy?.quoteData?.premiumData?.tenure
                ? `${
                    viewRenewMotorPolicy?.quoteData?.tenure ||
                    viewRenewMotorPolicy?.quoteData?.premiumData
                      ?.tenure
                  } ${
                    (
                      viewRenewMotorPolicy?.quoteData?.tenure ||
                      viewRenewMotorPolicy?.quoteData?.premiumData
                        ?.tenure
                    )?.trim() === '1'
                      ? 'year'
                      : 'years'
                  }`
                : '',
          },
          {
            label: 'Policy Start Date',
            text: viewRenewMotorPolicy?.policy?.startDate
              ? viewRenewMotorPolicy?.policy?.startDate
              : datetimeValue?.date
              ? datetimeValue?.date
              : moment(new Date(), 'DD/MM/YYYY'),
          },
          {
            label: 'Policy End Date',
            text: viewRenewMotorPolicy?.policy?.endDate
              ? viewRenewMotorPolicy?.policy?.endDate
              : '',
          },
          viewRenewMotorPolicy?.quoteData
            ?.voluntaryDeductibleAmount !== null &&
          viewRenewMotorPolicy?.quoteData
            ?.voluntaryDeductibleAmount !== undefined &&
          viewRenewMotorPolicy?.quoteData
            ?.voluntaryDeductibleAmount !== ''
            ? {
                label: 'Voluntary Deductible Amount',
                text: CurrencyFormater(
                  viewRenewMotorPolicy?.quoteData
                    ?.voluntaryDeductibleAmount,
                  true,
                  false,
                  branding,
                  true,
                ),
              }
            : null,
          {
            label: 'Proposal Type',
            colSpan: repeatFormsReadOnly === 2 ? 2 : 1,
            text: (
              <QuantaRadioGroup
                name={
                  'reviewAndConfirmTabDetails.proposalPaymentType'
                }
                className={'mt-1'}
                disabledGlobal=
                {
                  // viewRenewMotorPolicy?.isProposalRenewed
                  true
                }
                data={
                  dataPaymentType?.ProposalPaymentTypeList &&
                  dataPaymentType?.ProposalPaymentTypeList?.length > 0
                    ? dataPaymentType?.ProposalPaymentTypeList?.map(
                        (proposalPaymentType) => {
                          return {
                            label: proposalPaymentType?.value
                              ? proposalPaymentType?.value
                              : '',
                            value: proposalPaymentType?.code
                              ? proposalPaymentType?.code
                              : '',
                          };
                        },
                      )
                    : []
                }
              />
            ),
          },
        ]?.filter((d) => d),
      },
    ];

    const intermediaryDetailsData = [
      {
        grid_type: 'input',
        title: (
          <Text
            severity={'info'}
            className={'font-semibold'}
            type={'normal'}
          >
            Intermediary
          </Text>
        ),
        clickToEdit: true,
        initDisplayEdit: viewRenewMotorPolicy?.isProposalRenewed
          ? false
          : expandedCard.current
              .find((exp) => exp?.cardName === 'intermediaryDetails')
              ?.subSections?.includes(
                'intermediaryCodeLocationFieldUserDetails',
              ),
        onValueChanges: (values) => {
          setValueChanges(values);
        },
        editDisplayDisabled:
          loadingFieldUserList ||
          // errorFieldUserList !== null ||
          viewRenewMotorPolicy?.isProposalRenewed ||
          typeName?.toString()?.trim()?.toLowerCase() ===
            'field user',
        onEdit: (_) => {
          setEnableRenew(false);
          setFieldValue(`countEditsOpen`, values?.countEditsOpen + 1);
          expandedCard.current = [
            ...expandedCard.current.filter(
              (exp) => exp?.cardName !== 'intermediaryDetails',
            ),
            {
              ...expandedCard.current.find(
                (exp) => exp?.cardName === 'intermediaryDetails',
              ),
              cardFlag: true,
              subSections: [
                ...expandedCard.current.find(
                  (exp) => exp?.cardName === 'intermediaryDetails',
                )?.subSections,
                'intermediaryCodeLocationFieldUserDetails',
              ],
            },
          ];
          if (
            props.forwardedAlertsRef &&
            props.forwardedAlertsRef.current
          ) {
            props.forwardedAlertsRef.current = [];
          }
          updateViewRenewMotorPolicyVar({
            isProposalReadyForRenewal: false,
          });
          setIntermediaryDetailsCardToggle(false);
        },
        onCancel: (_, valuesBeforeEdit) => {
          if (values?.countEditsOpen === 1) {
            updateViewRenewMotorPolicyVar({
              isProposalReadyForRenewal: true,
            });
            setEnableRenew(true);
          }
          setFieldValue(`countEditsOpen`, values?.countEditsOpen - 1);
          setFieldValue(
            'intermediaryData.intermediary',
            valuesBeforeEdit?.intermediaryData?.intermediary,
          );
          setFieldValue(
            'intermediaryData.businessLocation',
            valuesBeforeEdit?.intermediaryData?.businessLocation,
          );
          setFieldValue(
            'intermediaryData.fieldUser',
            valuesBeforeEdit?.intermediaryData?.fieldUser,
          );
          expandedCard.current = [
            ...expandedCard.current.filter(
              (exp) => exp?.cardName !== 'intermediaryDetails',
            ),
            {
              ...expandedCard.current.find(
                (exp) => exp?.cardName === 'intermediaryDetails',
              ),
              cardFlag: false,
              subSections: [
                ...expandedCard.current
                  .find(
                    (exp) => exp?.cardName === 'intermediaryDetails',
                  )
                  ?.subSections?.filter(
                    (subSection) =>
                      subSection !==
                      'intermediaryCodeLocationFieldUserDetails',
                  ),
              ],
            },
          ];
          if (
            props.forwardedAlertsRef &&
            props.forwardedAlertsRef.current
          ) {
            props.forwardedAlertsRef.current = [];
          }
          setIntermediaryDetailsCardToggle(true);
        },
        onSave: (_) => {
          if (values?.countEditsOpen === 1) {
            updateViewRenewMotorPolicyVar({
              isProposalReadyForRenewal: true,
            });
            setEnableRenew(true);
          }
          setFieldValue(`countEditsOpen`, values?.countEditsOpen - 1);
          expandedCard.current = [
            ...expandedCard.current.filter(
              (exp) => exp?.cardName !== 'intermediaryDetails',
            ),
            {
              ...expandedCard.current.find(
                (exp) => exp?.cardName === 'intermediaryDetails',
              ),
              cardFlag: false,
              subSections: [
                ...expandedCard.current
                  .find(
                    (exp) => exp?.cardName === 'intermediaryDetails',
                  )
                  ?.subSections?.filter(
                    (subSection) =>
                      subSection !==
                      'intermediaryCodeLocationFieldUserDetails',
                  ),
              ],
            },
          ];
          if (
            props.forwardedAlertsRef &&
            props.forwardedAlertsRef.current
          ) {
            props.forwardedAlertsRef.current = [];
          }
          setIntermediaryDetailsCardToggle(true);
        },
        disableSubmit:
          (validate(values)?.intermediaryData !== undefined &&
            Object.keys(validate(values)?.intermediaryData)?.length >
              0) ||
          loadingFieldUserList,
        resetOnCancel: false,
        isBorderRequired: true,
        borderClassName: 'border-b border-neutral pb-4',
        grid_data: [
          {
            type: 'select',
            name: 'intermediaryData.intermediary',
            // disabled: viewRenewMotorPolicy?.isProposalRenewed,
            disabled: true,
            label: (
              <div>
                Intermediary Name <Text severity={'error'}>*</Text>
              </div>
            ),
            labelReadOnly: 'Intermediary Name',
            readOnlyValue: getDomainData(
              myIntermediaries,
              values?.intermediaryData?.intermediary,
              'intermediaryCode',
              'intermediaryName',
            )
              ? getDomainData(
                  myIntermediaries,
                  values?.intermediaryData?.intermediary,
                  'intermediaryCode',
                  'intermediaryName',
                )
              : null,
            data:
              myIntermediaries && myIntermediaries?.length > 0
                ? myIntermediaries?.map((intermediary) => {
                    return {
                      label: intermediary?.intermediaryName
                        ? `${intermediary?.intermediaryName}`
                        : '',
                      value: intermediary?.intermediaryCode
                        ? `${intermediary?.intermediaryCode}`
                        : '',
                    };
                  })
                : [],
            onDataChange: async (val, _) => {
              try {
                setFieldValue(`intermediaryData.fieldUserList`, []);
                setErrorFieldUserList(null);
                setFieldValue(
                  `intermediaryData.businessLocation`,
                  myIntermediaries?.find(
                    (intermediary) =>
                      intermediary?.intermediaryCode
                        ?.toString()
                        ?.toLowerCase() ===
                      val?.toString()?.toLowerCase(),
                  )?.businessLocations[0]?.code,
                );
                setFieldValue(`intermediaryData.fieldUser`, '');
                const fieldUserQuery = fetchQuery({
                  query: GET_FIELDUSER_LIST,
                  variables: {
                    input: {
                      intermediaryCode: `${val}`,
                      officeId: myIntermediaries?.find(
                        (intermediary) =>
                          intermediary?.intermediaryCode
                            ?.toString()
                            ?.toLowerCase() ===
                          val?.toString()?.toLowerCase(),
                      )?.businessLocations[0]?.code,
                    },
                  },
                });
                setLoadingFieldUserList(true);
                const { data: fieldUserListData } =
                  await fieldUserQuery;
                setLoadingFieldUserList(false);
                setFieldValue(
                  `intermediaryData.fieldUserList`,
                  fieldUserListData?.getFiledUserByIMID,
                );
              } catch (error) {
                setLoadingFieldUserList(false);
                setErrorFieldUserList(error?.message);
                setFieldValue(`intermediaryData.fieldUserList`, []);
              }
            },
          },
          {
            type: 'select',
            name: 'intermediaryData.businessLocation',
            disabled: viewRenewMotorPolicy?.isProposalRenewed,
            label: (
              <div>
                Business Location <Text severity={'error'}>*</Text>
              </div>
            ),
            labelReadOnly: 'Business Location',
            readOnlyValue: !values?.intermediaryData?.businessLocation
              ? viewRenewMotorPolicy?.intermediaryDetails?.location
              : myIntermediaries?.find(
                  (intermediary) =>
                    intermediary?.intermediaryCode
                      ?.toString()
                      ?.toLowerCase() ===
                      values?.intermediaryData?.intermediary
                        ?.toString()
                        ?.toLowerCase() &&
                    intermediary?.businessLocations?.find(
                      (businessLocation) =>
                        businessLocation?.code
                          ?.toString()
                          ?.toLowerCase() ===
                        values?.intermediaryData?.businessLocation
                          ?.toString()
                          ?.toLowerCase(),
                    ),
                )
              ? myIntermediaries
                  ?.find(
                    (intermediary) =>
                      intermediary?.intermediaryCode
                        ?.toString()
                        ?.toLowerCase() ===
                        values?.intermediaryData?.intermediary
                          ?.toString()
                          ?.toLowerCase() &&
                      intermediary?.businessLocations?.find(
                        (businessLocation) =>
                          businessLocation?.code
                            ?.toString()
                            ?.toLowerCase() ===
                          values?.intermediaryData?.businessLocation
                            ?.toString()
                            ?.toLowerCase(),
                      ),
                  )
                  ?.businessLocations?.find(
                    (businessLocation) =>
                      businessLocation?.code
                        ?.toString()
                        ?.toLowerCase() ===
                      values?.intermediaryData?.businessLocation
                        ?.toString()
                        ?.toLowerCase(),
                  )?.name
              : '',
            data:
              myIntermediaries && myIntermediaries?.length > 0
                ? myIntermediaries
                    ?.find(
                      (intermediary) =>
                        intermediary?.intermediaryCode
                          ?.toString()
                          ?.toLowerCase() ===
                        values?.intermediaryData?.intermediary
                          ?.toString()
                          ?.toLowerCase(),
                    )
                    ?.businessLocations?.map((businessLocation) => {
                      return {
                        label: businessLocation?.name
                          ? `${businessLocation?.name}`
                          : businessLocation?.code
                          ? `${businessLocation?.code}`
                          : '',
                        value: businessLocation?.code
                          ? `${businessLocation?.code}`
                          : '',
                      };
                    })
                : [],
            onDataChange: async (val, _) => {
              try {
                setFieldValue(`intermediaryData.fieldUserList`, []);
                setFieldValue(`intermediaryData.fieldUser`, '');
                setErrorFieldUserList(null);
                const fieldUserQuery = fetchQuery({
                  query: GET_FIELDUSER_LIST,
                  variables: {
                    input: {
                      intermediaryCode: `${values?.intermediaryData?.intermediary}`,
                      officeId: `${val}`,
                    },
                  },
                });
                setLoadingFieldUserList(true);
                const { data: fieldUserListData } =
                  await fieldUserQuery;
                setLoadingFieldUserList(false);
                setFieldValue(
                  `intermediaryData.fieldUserList`,
                  fieldUserListData?.getFiledUserByIMID,
                );
              } catch (error) {
                setErrorFieldUserList(error?.message);
                setLoadingFieldUserList(false);
                setFieldValue(`intermediaryData.fieldUserList`, []);
              }
            },
          },
          loadingFieldUserList
            ? {
                type: 'render',
                component: () => {
                  return (
                    <Label
                      severity={'none'}
                      text={
                        <div>
                          Field User <Text severity={'error'}></Text>
                        </div>
                      }
                    >
                      <Loading
                        textSize="normal"
                        className="flex justify-start items-center space-x-2 text-opacity-50 text-primary w-full"
                      />
                    </Label>
                  );
                },
              }
            : // : errorFieldUserList
              // ? {
              //     type: 'render',
              //     component: () => {
              //       return (
              //         <Label
              //           severity={'none'}
              //           text={
              //             <div>
              //               Field User <Text severity={'error'}></Text>
              //             </div>
              //           }
              //         >
              //           <Error
              //             className="flex justify-start items-center space-x-2 text-base text-opacity-50 text-red-600 w-full"
              //             error={errorFieldUserList}
              //           />
              //         </Label>
              //       );
              //     },
              //   }
              {
                type: 'select',
                name: 'intermediaryData.fieldUser',
                disabled: viewRenewMotorPolicy?.isProposalRenewed,
                label: (
                  <div>
                    Field User <Text severity={'error'}></Text>
                  </div>
                ),
                labelReadOnly: 'Field User',
                readOnlyValue:
                  values?.intermediaryData?.fieldUserList &&
                  getDomainData(
                    values?.intermediaryData?.fieldUserList,
                    values?.intermediaryData?.fieldUser,
                    'fieldUserCode',
                    'fieldUserName',
                  )
                    ? getDomainData(
                        values?.intermediaryData?.fieldUserList,
                        values?.intermediaryData?.fieldUser,
                        'fieldUserCode',
                        'fieldUserName',
                      )
                    : '',
                data:
                  values?.intermediaryData?.fieldUserList &&
                  values?.intermediaryData?.fieldUserList?.length > 0
                    ? values?.intermediaryData?.fieldUserList?.map(
                        (fieldUser) => {
                          return {
                            label: fieldUser?.fieldUserName
                              ? `${fieldUser?.fieldUserName}`
                              : '',
                            value: fieldUser?.fieldUserCode
                              ? `${fieldUser?.fieldUserCode}`
                              : '',
                          };
                        },
                      )
                    : [],
              },
        ]?.filter((d) => d),
      },
    ];

    const vehicleDetailsData = [
      {
        grid_type: 'data',
        title: (
          <Text
            className={'font-semibold'}
            severity={'info'}
            type={'normal'}
          >
            Vehicle Details
          </Text>
        ),
        grid_data: [
          {
            label: 'Make',
            text: viewRenewMotorPolicy?.vehicleTabDetails
              ?.vehicleDetails?.make?.value,
          },
          {
            label: 'Model',
            text: viewRenewMotorPolicy?.vehicleTabDetails
              ?.vehicleDetails?.model?.value,
          },
          {
            label: 'Variant',
            text: viewRenewMotorPolicy?.vehicleTabDetails
              ?.vehicleDetails?.variant?.value,
          },
          {
            label: 'Seating Capacity',
            text: viewRenewMotorPolicy?.vehicleTabDetails
              ?.vehicleDetails?.seatingCapacity,
          },
          // {
          //   label: 'Vehicle Segment',
          //   text: viewRenewMotorPolicy?.vehicleTabDetails
          //     ?.vehicleDetails?.vehicleSegment,
          // },
          {
            label: 'Cubic Capacity',
            text: viewRenewMotorPolicy?.vehicleTabDetails
              ?.vehicleDetails?.cubeCapacity,
          },
          {
            label: 'Carrying Capacity',
            text: viewRenewMotorPolicy?.quoteData?.carryingCapacity
          },
          // {
          //   label: 'GVW',
          //   text: viewRenewMotorPolicy?.quoteData?.GVW
          // },
          {
            label: 'CarriageType',
            text: viewRenewMotorPolicy?.quoteData?.carriageType,
          },
          // {
          //   label: 'Permit Type',
          //   text: viewRenewMotorPolicy?.quoteData?.permitType,
          // },
          {
            label: 'Vehicle Use',
            text: viewRenewMotorPolicy?.quoteData?.vehicleUse,
          },
          {
            label: 'Vehicle Age',
            text: viewRenewMotorPolicy?.premiumData?.vehicleAge
              ? `${viewRenewMotorPolicy?.premiumData?.vehicleAge} year(s)`
              : '',
          },
          {
            label: 'Fuel Type',
            text: viewRenewMotorPolicy?.vehicleTabDetails
              ?.vehicleDetails?.fuelType,
          },
          {
            label: 'RTO Code (Location)',
            text: `${viewRenewMotorPolicy?.vehicleTabDetails?.vehicleDetails?.rtoDetails?.rtoAuthorityCode}-${viewRenewMotorPolicy?.vehicleTabDetails?.vehicleDetails?.rtoDetails?.rtoLocationDesc}`,
          },
          {
            label: 'Date of Registration/Invoice',
            text: viewRenewMotorPolicy?.vehicleTabDetails
              ?.vehicleDetails?.dateOfRegistration,
          },
          {
            label: 'Year of Manufacture',
            text: viewRenewMotorPolicy?.vehicleTabDetails
              ?.vehicleDetails?.yearOfManufacture,
          },
          {
            label: 'Pre-Inspection Number',
            text: viewRenewMotorPolicy?.vehicleTabDetails
              ?.vehicleDetails?.preInspectionNumber,
          },
        ].filter((d) => d),
      },
      {
        grid_type: 'input',
        title: (
          <Text
            severity={'info'}
            className={'font-semibold'}
            type={'normal'}
          >
            Vehicle Registration Details
          </Text>
        ),
        clickToEdit: true,
        initDisplayEdit: viewRenewMotorPolicy?.isProposalRenewed
          ? false
          : !values?.vehicleTabDetails?.vehicleRegistrationDetails
              ?.registrationNumber ||
            values?.vehicleTabDetails?.vehicleRegistrationDetails?.registrationNumber?.toLowerCase() ===
              'new' ||
            expandedCard.current
              .find(
                (exp) =>
                  exp?.cardName === 'vehicleAndRegistrationDetails',
              )
              ?.subSections?.includes('vehicleRegistrationDetails'),
        onValueChanges: (values) => {
          setValueChanges(values);
        },
        editDisplayDisabled:
          viewRenewMotorPolicy?.isProposalRenewed ||
          (viewRenewMotorPolicy?.vehicleTabDetails?.vehicleRegistrationDetails?.registrationNumber?.toLowerCase() !==
            'new' &&
            viewRenewMotorPolicy?.vehicleTabDetails
              ?.vehicleRegistrationDetails?.registrationNumber !==
              null &&
            viewRenewMotorPolicy?.vehicleTabDetails
              ?.vehicleRegistrationDetails?.registrationNumber !==
              undefined &&
            viewRenewMotorPolicy?.vehicleTabDetails
              ?.vehicleRegistrationDetails?.registrationNumber !==
              ''),
        onEdit: (_) => {
          setEnableRenew(false);
          if (!renderExpandedCards?.current[2]) {
            renderExpandedCards.current = [
              ...renderExpandedCards.current.slice(0, 2),
              true,
              ...renderExpandedCards.current.slice(3),
            ];
          }
          setFieldValue(`countEditsOpen`, values?.countEditsOpen + 1);
          expandedCard.current = [
            ...expandedCard.current.filter(
              (exp) =>
                exp?.cardName !== 'vehicleAndRegistrationDetails',
            ),
            {
              ...expandedCard.current.find(
                (exp) =>
                  exp?.cardName === 'vehicleAndRegistrationDetails',
              ),
              cardFlag: true,
              subSections: [
                ...expandedCard.current.find(
                  (exp) =>
                    exp?.cardName === 'vehicleAndRegistrationDetails',
                )?.subSections,
                'vehicleRegistrationDetails',
              ],
            },
          ];
          if (
            props.forwardedAlertsRef &&
            props.forwardedAlertsRef.current
          ) {
            props.forwardedAlertsRef.current = [];
          }
          updateViewRenewMotorPolicyVar({
            isProposalReadyForRenewal: false,
          });
          setVehicleAndRegistrationDetailsCardToggle(false);
        },
        onCancel: (_, valuesBeforeEdit) => {
          if (values?.countEditsOpen === 1) {
            updateViewRenewMotorPolicyVar({
              isProposalReadyForRenewal: true,
            });
            setEnableRenew(true);
          }
          if (!renderExpandedCards?.current[2]) {
            renderExpandedCards.current = [
              ...renderExpandedCards.current.slice(0, 2),
              true,
              ...renderExpandedCards.current.slice(3),
            ];
          }
          setFieldValue(`countEditsOpen`, values?.countEditsOpen - 1);
          setFieldValue(
            'vehicleTabDetails.vehicleRegistrationDetails.registrationNumber',
            valuesBeforeEdit?.vehicleTabDetails
              ?.vehicleRegistrationDetails?.registrationNumber,
          );
          setFieldValue(
            'vehicleTabDetails.vehicleRegistrationDetails.registrationNumberParts.part1',
            valuesBeforeEdit?.vehicleTabDetails
              ?.vehicleRegistrationDetails?.registrationNumberParts
              ?.part1,
          );
          setFieldValue(
            'vehicleTabDetails.vehicleRegistrationDetails.registrationNumberParts.part2',
            valuesBeforeEdit?.vehicleTabDetails
              ?.vehicleRegistrationDetails?.registrationNumberParts
              ?.part2,
          );
          setFieldValue(
            'vehicleTabDetails.vehicleRegistrationDetails.registrationNumberParts.part3',
            valuesBeforeEdit?.vehicleTabDetails
              ?.vehicleRegistrationDetails?.registrationNumberParts
              ?.part3,
          );
          setFieldValue(
            'vehicleTabDetails.vehicleRegistrationDetails.registrationNumberParts.part4',
            valuesBeforeEdit?.vehicleTabDetails
              ?.vehicleRegistrationDetails?.registrationNumberParts
              ?.part4,
          );
          setFieldValue(
            'vehicleTabDetails.vehicleRegistrationDetails.engineNumber',
            valuesBeforeEdit?.vehicleTabDetails
              ?.vehicleRegistrationDetails?.engineNumber,
          );
          setFieldValue(
            'vehicleTabDetails.vehicleRegistrationDetails.chasisNumber',
            valuesBeforeEdit?.vehicleTabDetails
              ?.vehicleRegistrationDetails?.chasisNumber,
          );
          expandedCard.current = [
            ...expandedCard.current.filter(
              (exp) =>
                exp?.cardName !== 'vehicleAndRegistrationDetails',
            ),
            {
              ...expandedCard.current.find(
                (exp) =>
                  exp?.cardName === 'vehicleAndRegistrationDetails',
              ),
              cardFlag: false,
              subSections: [
                ...expandedCard.current
                  .find(
                    (exp) =>
                      exp?.cardName ===
                      'vehicleAndRegistrationDetails',
                  )
                  ?.subSections?.filter(
                    (subSection) =>
                      subSection !== 'vehicleRegistrationDetails',
                  ),
              ],
            },
          ];
          if (
            props.forwardedAlertsRef &&
            props.forwardedAlertsRef.current
          ) {
            props.forwardedAlertsRef.current = [];
          }
          setVehicleAndRegistrationDetailsCardToggle(true);
        },
        onSave: (_) => {
          if (values?.countEditsOpen === 1) {
            updateViewRenewMotorPolicyVar({
              isProposalReadyForRenewal: true,
            });
            setEnableRenew(true);
          }
          if (!renderExpandedCards?.current[2]) {
            renderExpandedCards.current = [
              ...renderExpandedCards.current.slice(0, 2),
              true,
              ...renderExpandedCards.current.slice(3),
            ];
          }
          setFieldValue(`countEditsOpen`, values?.countEditsOpen - 1);
          setFieldValue(
            `vehicleTabDetails.vehicleRegistrationDetails.registrationNumber`,
            `${
              values?.vehicleTabDetails?.vehicleRegistrationDetails
                ?.registrationNumberParts?.part1
                ? `${values?.vehicleTabDetails?.vehicleRegistrationDetails?.registrationNumberParts?.part1}`
                : ''
            }${
              values?.vehicleTabDetails?.vehicleRegistrationDetails
                ?.registrationNumberParts?.part2
                ? `${values?.vehicleTabDetails?.vehicleRegistrationDetails?.registrationNumberParts?.part2}`
                : ''
            }${
              values?.vehicleTabDetails?.vehicleRegistrationDetails
                ?.registrationNumberParts?.part3
                ? `${values?.vehicleTabDetails?.vehicleRegistrationDetails?.registrationNumberParts?.part3}`
                : ''
            }${
              values?.vehicleTabDetails?.vehicleRegistrationDetails
                ?.registrationNumberParts?.part4
                ? `${values?.vehicleTabDetails?.vehicleRegistrationDetails?.registrationNumberParts?.part4}`
                : ''
            }`,
          );
          expandedCard.current = [
            ...expandedCard.current.filter(
              (exp) =>
                exp?.cardName !== 'vehicleAndRegistrationDetails',
            ),
            {
              ...expandedCard.current.find(
                (exp) =>
                  exp?.cardName === 'vehicleAndRegistrationDetails',
              ),
              cardFlag: false,
              subSections: [
                ...expandedCard.current
                  .find(
                    (exp) =>
                      exp?.cardName ===
                      'vehicleAndRegistrationDetails',
                  )
                  ?.subSections?.filter(
                    (subSection) =>
                      subSection !== 'vehicleRegistrationDetails',
                  ),
              ],
            },
          ];
          if (
            props.forwardedAlertsRef &&
            props.forwardedAlertsRef.current
          ) {
            props.forwardedAlertsRef.current = [];
          }
          setVehicleAndRegistrationDetailsCardToggle(true);
        },
        disableSubmit:
          validate(values)?.vehicleTabDetails
            ?.vehicleRegistrationDetails !== undefined,
        resetOnCancel: false,
        isBorderRequired: true,
        borderClassName: 'border-t-2 border-neutral pt-2',
        grid_data: [
          {
            type: 'input-wrapper',
            label: (
              <Text type={'label'}>
                Registration Number <Text severity={'error'}>*</Text>
              </Text>
            ),
            labelReadOnly: 'Registration Number',
            name: 'vehicleTabDetails.vehicleRegistrationDetails.registrationNumber',
            size: 'full',
            readOnlyValue:
              values?.vehicleTabDetails?.vehicleRegistrationDetails
                ?.registrationNumber,
            fields: [
              'vehicleTabDetails.vehicleRegistrationDetails.registrationNumberParts.part1',
              'vehicleTabDetails.vehicleRegistrationDetails.registrationNumberParts.part2',
              'vehicleTabDetails.vehicleRegistrationDetails.registrationNumberParts.part3',
              'vehicleTabDetails.vehicleRegistrationDetails.registrationNumberParts.part4',
            ],
            className: viewRenewMotorPolicy?.isProposalRenewed
              ? `border-neutral-dark`
              : ``,
            disabled:
              viewRenewMotorPolicy?.isProposalRenewed ||
              (viewRenewMotorPolicy?.vehicleTabDetails?.vehicleRegistrationDetails?.registrationNumber?.toLowerCase() !==
                'new' &&
                viewRenewMotorPolicy?.vehicleTabDetails
                  ?.vehicleRegistrationDetails?.registrationNumber),
            children: (
              <>
                <QuantaInput
                  name="vehicleTabDetails.vehicleRegistrationDetails.registrationNumberParts.part1"
                  maxLength="2"
                  size="full"
                  type="text"
                  placeholder="MH"
                  noerror
                  className="uppercase"
                  disabled={viewRenewMotorPolicy?.isProposalRenewed}
                  onKeyUp={(e) => {
                    if (e.target.value.length === 2) {
                      document
                        .getElementsByName(
                          'vehicleTabDetails.vehicleRegistrationDetails.registrationNumberParts.part2',
                        )
                        .forEach((e) => e.focus());
                    }
                  }}
                  onDataChange={(val, setFieldValue) => {
                    if (!renderExpandedCards?.current[2]) {
                      renderExpandedCards.current = [
                        ...renderExpandedCards.current.slice(0, 2),
                        true,
                        ...renderExpandedCards.current.slice(3),
                      ];
                    }
                    setFieldValue(
                      `vehicleTabDetails.vehicleRegistrationDetails.registrationNumberParts.part1`,
                      val?.toString()?.toUpperCase(),
                    );
                  }}
                />
                <span
                  className={`flex items-center font-bold ${
                    viewRenewMotorPolicy?.isProposalRenewed
                      ? 'bg-neutral-light opacity-50'
                      : ''
                  } h-12`}
                >
                  -
                </span>
                <QuantaInput
                  name="vehicleTabDetails.vehicleRegistrationDetails.registrationNumberParts.part2"
                  maxLength="2"
                  size="full"
                  type="text"
                  placeholder="01"
                  noerror
                  disabled={viewRenewMotorPolicy?.isProposalRenewed}
                  onDataChange={(val, _) => {
                    if (!renderExpandedCards?.current[2]) {
                      renderExpandedCards.current = [
                        ...renderExpandedCards.current.slice(0, 2),
                        true,
                        ...renderExpandedCards.current.slice(3),
                      ];
                    }
                  }}
                  onKeyUp={(e) => {
                    if (e.target.value.length === 2) {
                      document
                        .getElementsByName(
                          'vehicleTabDetails.vehicleRegistrationDetails.registrationNumberParts.part3',
                        )
                        .forEach((e) => e.focus());
                    }
                  }}
                />
                <span
                  className={`flex items-center font-bold ${
                    viewRenewMotorPolicy?.isProposalRenewed
                      ? 'bg-neutral-light opacity-50'
                      : ''
                  } h-12`}
                >
                  -
                </span>
                <QuantaInput
                  name="vehicleTabDetails.vehicleRegistrationDetails.registrationNumberParts.part3"
                  maxLength="3"
                  size="full"
                  type="text"
                  placeholder="CRS"
                  noerror
                  className="uppercase"
                  disabled={viewRenewMotorPolicy?.isProposalRenewed}
                  onKeyUp={(e) => {
                    if (e.target.value.length === 3) {
                      document
                        .getElementsByName(
                          'vehicleTabDetails.vehicleRegistrationDetails.registrationNumberParts.part4',
                        )
                        .forEach((e) => e.focus());
                    }
                  }}
                  onDataChange={(val, setFieldValue) => {
                    if (!renderExpandedCards?.current[2]) {
                      renderExpandedCards.current = [
                        ...renderExpandedCards.current.slice(0, 2),
                        true,
                        ...renderExpandedCards.current.slice(3),
                      ];
                    }
                    setFieldValue(
                      `vehicleTabDetails.vehicleRegistrationDetails.registrationNumberParts.part3`,
                      val?.toString()?.toUpperCase(),
                    );
                  }}
                />
                <span
                  className={`flex items-center font-bold ${
                    viewRenewMotorPolicy?.isProposalRenewed
                      ? 'bg-neutral-light opacity-50'
                      : ''
                  } h-12`}
                >
                  -
                </span>
                <QuantaInput
                  name="vehicleTabDetails.vehicleRegistrationDetails.registrationNumberParts.part4"
                  maxLength="4"
                  size="full"
                  type="text"
                  placeholder="2845"
                  disabled={viewRenewMotorPolicy?.isProposalRenewed}
                  noerror
                  onDataChange={(val, _) => {
                    if (!renderExpandedCards?.current[2]) {
                      renderExpandedCards.current = [
                        ...renderExpandedCards.current.slice(0, 2),
                        true,
                        ...renderExpandedCards.current.slice(3),
                      ];
                    }
                  }}
                />
              </>
            ),
          },
          {
            type: 'text',
            label: (
              <Text type={'label'}>
                Engine Number <Text severity={'error'}>*</Text>
              </Text>
            ),
            labelReadOnly: 'Engine Number',
            name: 'vehicleTabDetails.vehicleRegistrationDetails.engineNumber',
            disabled: true,
          },
          {
            type: 'text',
            label: (
              <Text type={'label'}>
                Chassis Number <Text severity={'error'}>*</Text>
              </Text>
            ),
            labelReadOnly: 'Chassis Number',
            name: 'vehicleTabDetails.vehicleRegistrationDetails.chasisNumber',
            disabled: true,
          },
        ],
      },
      {
        grid_type: 'input',
        title: (
          <Text
            className={'font-semibold'}
            severity={'info'}
            type={'normal'}
          >
            Insured Declared Details
          </Text>
        ),
        clickToEdit: true,
        initDisplayEdit: viewRenewMotorPolicy?.isProposalRenewed
          ? false
          : expandedCard.current
              .find(
                (exp) =>
                  exp?.cardName === 'vehicleAndRegistrationDetails',
              )
              ?.subSections?.includes('insuredDeclaredDetails'),
        onValueChanges: (values) => {
          setValueChanges(values);
        },
        editDisplayDisabled: viewRenewMotorPolicy?.isProposalRenewed||viewRenewMotorPolicy?.productType?.toLowerCase()?.search('liability')!==-1,
        onEdit: (_) => {
          setEnableRenew(false);
          setFieldValue(`countEditsOpen`, values?.countEditsOpen + 1);
          expandedCard.current = [
            ...expandedCard.current.filter(
              (exp) =>
                exp?.cardName !== 'vehicleAndRegistrationDetails',
            ),
            {
              ...expandedCard.current.find(
                (exp) =>
                  exp?.cardName === 'vehicleAndRegistrationDetails',
              ),
              cardFlag: true,
              subSections: [
                ...expandedCard.current.find(
                  (exp) =>
                    exp?.cardName === 'vehicleAndRegistrationDetails',
                )?.subSections,
                'insuredDeclaredDetails',
              ],
            },
          ];
          if (
            props.forwardedAlertsRef &&
            props.forwardedAlertsRef.current
          ) {
            props.forwardedAlertsRef.current = [];
          }
          updateViewRenewMotorPolicyVar({
            isProposalReadyForRenewal: false,
          });
          setVehicleAndRegistrationDetailsCardToggle(false);
        },
        onCancel: (_, valuesBeforeEdit) => {
          if (values?.countEditsOpen === 1) {
            updateViewRenewMotorPolicyVar({
              isProposalReadyForRenewal: true,
            });
            setEnableRenew(true);
          }
          setFieldValue(`countEditsOpen`, values?.countEditsOpen - 1);
          setFieldValue(
            'vehicleTabDetails.insuredDeclaredDetails.vehicleIDV',
            valuesBeforeEdit?.vehicleTabDetails
              ?.insuredDeclaredDetails?.vehicleIDV,
          );
          setFieldValue(
            'vehicleTabDetails.insuredDeclaredDetails.irfAdjustmentPercent',
            valuesBeforeEdit?.vehicleTabDetails
              ?.insuredDeclaredDetails?.irfAdjustmentPercent,
          );
          expandedCard.current = [
            ...expandedCard.current.filter(
              (exp) =>
                exp?.cardName !== 'vehicleAndRegistrationDetails',
            ),
            {
              ...expandedCard.current.find(
                (exp) =>
                  exp?.cardName === 'vehicleAndRegistrationDetails',
              ),
              cardFlag: false,
              subSections: [
                ...expandedCard.current
                  .find(
                    (exp) =>
                      exp?.cardName ===
                      'vehicleAndRegistrationDetails',
                  )
                  ?.subSections?.filter(
                    (subSection) =>
                      subSection !== 'insuredDeclaredDetails',
                  ),
              ],
            },
          ];
          if (
            props.forwardedAlertsRef &&
            props.forwardedAlertsRef.current
          ) {
            props.forwardedAlertsRef.current = [];
          }
          setVehicleAndRegistrationDetailsCardToggle(true);
        },
        onSave: (_) => {
          if (values?.countEditsOpen === 1) {
            updateViewRenewMotorPolicyVar({
              isProposalReadyForRenewal: true,
            });
            setEnableRenew(true);
          }
          setFieldValue(`countEditsOpen`, values?.countEditsOpen - 1);
          expandedCard.current = [
            ...expandedCard.current.filter(
              (exp) =>
                exp?.cardName !== 'vehicleAndRegistrationDetails',
            ),
            {
              ...expandedCard.current.find(
                (exp) =>
                  exp?.cardName === 'vehicleAndRegistrationDetails',
              ),
              cardFlag: false,
              subSections: [
                ...expandedCard.current
                  .find(
                    (exp) =>
                      exp?.cardName ===
                      'vehicleAndRegistrationDetails',
                  )
                  ?.subSections?.filter(
                    (subSection) =>
                      subSection !== 'insuredDeclaredDetails',
                  ),
              ],
            },
          ];
          if (
            props.forwardedAlertsRef &&
            props.forwardedAlertsRef.current
          ) {
            props.forwardedAlertsRef.current = [];
          }
          setVehicleAndRegistrationDetailsCardToggle(true);
        },
        disableSubmit:
          validate(values)?.vehicleTabDetails
            ?.insuredDeclaredDetails !== undefined,
        resetOnCancel: false,
        isBorderRequired: true,
        borderClassName: 'border-t-2 border-neutral pt-2',
        grid_data: [
          {
            type: 'number',
            enableSlider: !viewRenewMotorPolicy?.isProposalRenewed,
            label: (
              <Text type={'label'}>
                Chasis IDV <Text severity={'error'}>*</Text>
              </Text>
            ),
            labelReadOnly: 'Chasis IDV',
            name: 'vehicleTabDetails.insuredDeclaredDetails.vehicleIDV',
            className: viewRenewMotorPolicy?.isProposalRenewed
              ? 'border-neutral-dark'
              : '',
            readOnlyValue: viewRenewMotorPolicy?.productType?.toLowerCase()?.search('liability')!==-1
            ?'NA'
            :CurrencyFormater(
              values?.vehicleTabDetails?.insuredDeclaredDetails
                ?.vehicleIDV,
              true,
              false,
              branding,
              true,
            ),
            iconPre: (
              <Text
                severity={
                  viewRenewMotorPolicy?.isProposalRenewed
                    ? 'neutral'
                    : 'info'
                }
              >
                {branding.currency}
              </Text>
            ),
            noerror:
              values?.vehicleTabDetails?.insuredDeclaredDetails
                ?.vehicleIDV !== ''
                ? parseFloat(
                    values?.vehicleTabDetails?.insuredDeclaredDetails
                      ?.vehicleIDV,
                  ) >=
                    viewRenewMotorPolicy?.vehicleTabDetails
                      ?.insuredDeclaredDetails?.minChangedIDV &&
                  parseFloat(
                    values?.vehicleTabDetails?.insuredDeclaredDetails
                      ?.vehicleIDV,
                  ) <=
                    viewRenewMotorPolicy?.vehicleTabDetails
                      ?.insuredDeclaredDetails?.maxChangedIDV
                : false,
            sliderMin:
              Math.round(
                viewRenewMotorPolicy?.vehicleTabDetails
                  ?.insuredDeclaredDetails?.minChangedIDV * 100,
              ) / 100,
            sliderMax:
              Math.round(
                viewRenewMotorPolicy?.vehicleTabDetails
                  ?.insuredDeclaredDetails?.maxChangedIDV * 100,
              ) / 100,
            sliderStep: 1,
            descriptionForSlider: (
              <Text
                type={'normal'}
                severity={'info'}
                className={'flex space-x-2'}
              >
                <Text>
                  <FontAwesomeIcon icon={faInfoCircle} />
                </Text>
                <Text>
                  You can choose maximum{' '}
                  {
                    viewRenewMotorPolicy?.vehicleTabDetails
                      ?.insuredDeclaredDetails?.idvPct
                  }
                  % and minimum 10 %
                   deviation from the received IDV
                </Text>
              </Text>
            ),
            value: values?.vehicleTabDetails?.insuredDeclaredDetails
              ?.vehicleIDV
              ? parseFloat(
                  values?.vehicleTabDetails?.insuredDeclaredDetails
                    ?.vehicleIDV,
                )
              : '',
            initialValue: viewRenewMotorPolicy?.vehicleTabDetails
              ?.insuredDeclaredDetails?.vehicleIDV
              ? parseFloat(
                  viewRenewMotorPolicy?.vehicleTabDetails
                    ?.insuredDeclaredDetails?.vehicleIDV,
                )
              : null,
          },
          {
            type: 'text',
            label: (
              <Text type={'label'}>
                Body IDV  <Text severity={'error'}>*</Text>
              </Text>
            ),
            labelReadOnly: 'Body IDV',
            readOnlyValue:
            viewRenewMotorPolicy?.productType?.toLowerCase()?.search('liability')!==-1
            ?'NA'
            : `${values?.vehicleTabDetails.vehicleRegistrationDetails.bodyIDV}`,
            name: 'vehicleTabDetails.vehicleRegistrationDetails.bodyIDV',
            value: values?.vehicleTabDetails.vehicleRegistrationDetails.bodyIDV
              ? parseFloat(
                values?.vehicleTabDetails.vehicleRegistrationDetails.bodyIDV
                )
              : '',
              onSave: (_) => {
                if (values?.countEditsOpen === 1) {
                  updateViewRenewMotorPolicyVar({
                    isProposalReadyForRenewal: true,
                    vehicleTabDetails: {
                      vehicleRegistrationDetails:{
                    bodyIDV:values?.vehicleTabDetails.vehicleRegistrationDetails.bodyIDV
                      }
                    }                  });
                  setEnableRenew(true);
                }
                if (!renderExpandedCards?.current[2]) {
                  renderExpandedCards.current = [
                    ...renderExpandedCards.current.slice(0, 2),
                    true,
                    ...renderExpandedCards.current.slice(3),
                  ];
                }
                setFieldValue(`countEditsOpen`, values?.countEditsOpen - 1);
                setFieldValue(
                  `vehicleTabDetails.vehicleRegistrationDetails.bodyIDV`,
                  `${
                    values?.vehicleTabDetails.vehicleRegistrationDetails.bodyIDV
                      ? `${values?.vehicleTabDetails.vehicleRegistrationDetails.bodyIDV}`
                      : ''
                  }`,
                );
                expandedCard.current = [
                  ...expandedCard.current.filter(
                    (exp) =>
                      exp?.cardName !== 'vehicleAndRegistrationDetails',
                  ),
                  {
                    ...expandedCard.current.find(
                      (exp) =>
                        exp?.cardName === 'vehicleAndRegistrationDetails',
                    ),
                    cardFlag: false,
                    subSections: [
                      ...expandedCard.current
                        .find(
                          (exp) =>
                            exp?.cardName ===
                            'vehicleAndRegistrationDetails',
                        )
                        ?.subSections?.filter(
                          (subSection) =>
                            subSection !== 'insuredDeclaredDetails',
                        ),
                    ],
                  },
                ];
                if (
                  props.forwardedAlertsRef &&
                  props.forwardedAlertsRef.current
                ) {
                  props.forwardedAlertsRef.current = [];
                }
                setVehicleAndRegistrationDetailsCardToggle(true);
              },
              onCancel: (_, valuesBeforeEdit) => {
                if (values?.countEditsOpen === 1) {
                  updateViewRenewMotorPolicyVar({
                    isProposalReadyForRenewal: true,
                  });
                  setEnableRenew(true);
                }
                if (!renderExpandedCards?.current[2]) {
                  renderExpandedCards.current = [
                    ...renderExpandedCards.current.slice(0, 2),
                    true,
                    ...renderExpandedCards.current.slice(3),
                  ];
                }
                setFieldValue(`countEditsOpen`, values?.countEditsOpen - 1);
                setFieldValue(
                  'vehicleTabDetails.vehicleRegistrationDetails.bodyIDV',
                  valuesBeforeEdit?.vehicleTabDetails.vehicleRegistrationDetails.bodyIDV
                );
                expandedCard.current = [
                  ...expandedCard.current.filter(
                    (exp) =>
                      exp?.cardName !== 'vehicleAndRegistrationDetails',
                  ),
                  {
                    ...expandedCard.current.find(
                      (exp) =>
                        exp?.cardName === 'vehicleAndRegistrationDetails',
                    ),
                    cardFlag: false,
                    subSections: [
                      ...expandedCard.current
                        .find(
                          (exp) =>
                            exp?.cardName ===
                            'vehicleAndRegistrationDetails',
                        )
                        ?.subSections?.filter(
                          (subSection) =>
                            subSection !== 'insuredDeclaredDetails',
                        ),
                    ],
                  },
                ];
                if (
                  props.forwardedAlertsRef &&
                  props.forwardedAlertsRef.current
                ) {
                  props.forwardedAlertsRef.current = [];
                }
                setVehicleAndRegistrationDetailsCardToggle(true);
              },
            // disabled: true,
          },
          {
            type: 'text',
            label: (
              <Text type={'label'}>
                Total IDV  <Text severity={'error'}>*</Text>
              </Text>
            ),
            labelReadOnly: 'Total IDV',
           readOnlyValue: 
           viewRenewMotorPolicy?.productType?.toLowerCase()?.search('liability')!==-1
           ?'NA'
           :`${parseFloat(
            values?.vehicleTabDetails.vehicleRegistrationDetails.bodyIDV)
             +parseFloat(values?.vehicleTabDetails?.insuredDeclaredDetails
            ?.vehicleIDV
            )}`,
            name: 'vehicleTabDetails.vehicleRegistrationDetails.totalIDV',
            value: values?.vehicleTabDetails.vehicleRegistrationDetails.totalIDV
            ? parseFloat(
              values?.vehicleTabDetails.vehicleRegistrationDetails.bodyIDV)
               +parseFloat(values?.vehicleTabDetails?.insuredDeclaredDetails
              ?.vehicleIDV
              )
            : '',
            onSave: (_) => {
              if (values?.countEditsOpen === 1) {
                updateViewRenewMotorPolicyVar({
                  isProposalReadyForRenewal: true,
                  vehicleTabDetails: {
                    vehicleRegistrationDetails:{
                    totalIDV:parseFloat(
                      values?.vehicleTabDetails.vehicleRegistrationDetails.bodyIDV)
                       +parseFloat(values?.vehicleTabDetails?.insuredDeclaredDetails
                      ?.vehicleIDV)
                    }
                  }
                });
                setEnableRenew(true);
              }
              if (!renderExpandedCards?.current[2]) {
                renderExpandedCards.current = [
                  ...renderExpandedCards.current.slice(0, 2),
                  true,
                  ...renderExpandedCards.current.slice(3),
                ];
              }
              setFieldValue(`countEditsOpen`, values?.countEditsOpen - 1);
              setFieldValue(
                `vehicleTabDetails.vehicleRegistrationDetails.totalIDV`,               
                parseFloat(
                  values?.vehicleTabDetails.vehicleRegistrationDetails.bodyIDV)
                   +parseFloat(values?.vehicleTabDetails?.insuredDeclaredDetails
                  ?.vehicleIDV
                  )
              );
              expandedCard.current = [
                ...expandedCard.current.filter(
                  (exp) =>
                    exp?.cardName !== 'vehicleAndRegistrationDetails',
                ),
                {
                  ...expandedCard.current.find(
                    (exp) =>
                      exp?.cardName === 'vehicleAndRegistrationDetails',
                  ),
                  cardFlag: false,
                  subSections: [
                    ...expandedCard.current
                      .find(
                        (exp) =>
                          exp?.cardName ===
                          'vehicleAndRegistrationDetails',
                      )
                      ?.subSections?.filter(
                        (subSection) =>
                          subSection !== 'vehicleRegistrationDetails',
                      ),
                  ],
                },
              ];
              if (
                props.forwardedAlertsRef &&
                props.forwardedAlertsRef.current
              ) {
                props.forwardedAlertsRef.current = [];
              }
              setVehicleAndRegistrationDetailsCardToggle(true);
            },
             disabled: true,
          },
          {
            type: 'number',
            enableSlider: !viewRenewMotorPolicy?.isProposalRenewed,
            label: (
              <Text type={'label'}>
                IRF Adjustment <Text severity={'error'}>*</Text>
              </Text>
            ),
            labelReadOnly: 'IRF Adjustment',
            name: 'vehicleTabDetails.insuredDeclaredDetails.irfAdjustmentPercent',
            className: viewRenewMotorPolicy?.isProposalRenewed
              ? 'border-neutral-dark'
              : '',
            readOnlyValue: `${values?.vehicleTabDetails?.insuredDeclaredDetails?.irfAdjustmentPercent} %`,
            iconPre: (
              <Text
                severity={
                  viewRenewMotorPolicy?.isProposalRenewed
                    ? 'neutral'
                    : 'info'
                }
              >
                {`%`}
              </Text>
            ),
            noerror:
              values?.vehicleTabDetails?.insuredDeclaredDetails
                ?.irfAdjustmentPercent !== ''
                ? parseFloat(
                    values?.vehicleTabDetails?.insuredDeclaredDetails
                      ?.irfAdjustmentPercent,
                  ) >=
                    viewRenewMotorPolicy?.vehicleTabDetails
                      ?.insuredDeclaredDetails
                      ?.irfAdjustmentPercent &&
                  parseFloat(
                    values?.vehicleTabDetails?.insuredDeclaredDetails
                      ?.irfAdjustmentPercent,
                  ) <=
                    viewRenewMotorPolicy?.vehicleTabDetails
                      ?.insuredDeclaredDetails?.irfPct
                : false,
            sliderMin: -parseFloat(
              '15'
            ),
            sliderMax: parseFloat(
              viewRenewMotorPolicy?.vehicleTabDetails
                ?.insuredDeclaredDetails?.irfPct,
            ),
            descriptionForSlider: (
              <Text
                type={'normal'}
                severity={'info'}
                className={'flex space-x-2'}
              >
                <Text>
                  <FontAwesomeIcon icon={faInfoCircle} />
                </Text>
                <Text>
                  You can choose up to maximum {' '}
                  {
                    viewRenewMotorPolicy?.vehicleTabDetails
                      ?.insuredDeclaredDetails?.irfPct
                  }
                  % and minimum - 15 %
                </Text>
              </Text>
            ),
            sliderStep: 1,
            value: values?.vehicleTabDetails?.insuredDeclaredDetails
              ?.irfAdjustmentPercent
              ? parseFloat(
                  values?.vehicleTabDetails?.insuredDeclaredDetails
                    ?.irfAdjustmentPercent,
                )
              : '',
            initialValue: viewRenewMotorPolicy?.vehicleTabDetails
              ?.insuredDeclaredDetails?.irfAdjustmentPercent
              ? parseFloat(
                  viewRenewMotorPolicy?.vehicleTabDetails
                    ?.insuredDeclaredDetails?.irfAdjustmentPercent,
                )
              : null,
          },
          viewRenewMotorPolicy?.vehicleTabDetails
            ?.insuredDeclaredDetails?.sideCarValue
            ? {
                type: 'number',
                enableSlider:
                  !viewRenewMotorPolicy?.isProposalRenewed,
                label: (
                  <Text type={'label'}>
                    Side Car Value <Text severity={'error'}>*</Text>
                  </Text>
                ),
                labelReadOnly: 'Side Car Value',
                name: 'vehicleTabDetails.insuredDeclaredDetails.sideCarValue',
                className: viewRenewMotorPolicy?.isProposalRenewed
                  ? 'border-neutral-dark'
                  : '',
                readOnlyValue: CurrencyFormater(
                  values?.vehicleTabDetails?.insuredDeclaredDetails
                    ?.sideCarValue,
                  true,
                  false,
                  branding,
                  true,
                ),
                iconPre: (
                  <Text
                    severity={
                      viewRenewMotorPolicy?.isProposalRenewed
                        ? 'neutral'
                        : 'info'
                    }
                  >
                    {branding.currency}
                  </Text>
                ),
                noerror:
                  values?.vehicleTabDetails?.insuredDeclaredDetails
                    ?.sideCarValue !== ''
                    ? parseFloat(
                        values?.vehicleTabDetails
                          ?.insuredDeclaredDetails?.sideCarValue,
                      ) >=
                        viewRenewMotorPolicy?.vehicleTabDetails
                          ?.insuredDeclaredDetails?.minSideCarValue &&
                      parseFloat(
                        values?.vehicleTabDetails
                          ?.insuredDeclaredDetails?.sideCarValue,
                      ) <=
                        viewRenewMotorPolicy?.vehicleTabDetails
                          ?.insuredDeclaredDetails?.maxSideCarValue
                    : false,
                sliderMin:
                  Math.round(
                    viewRenewMotorPolicy?.vehicleTabDetails
                      ?.insuredDeclaredDetails?.minSideCarValue * 100,
                  ) / 100,
                sliderMax:
                  Math.round(
                    viewRenewMotorPolicy?.vehicleTabDetails
                      ?.insuredDeclaredDetails?.maxSideCarValue * 100,
                  ) / 100,
                sliderStep: 1,
                descriptionForSlider: (
                  <Text
                    type={'normal'}
                    severity={'info'}
                    className={'flex space-x-2'}
                  >
                    <Text>
                      <FontAwesomeIcon icon={faInfoCircle} />
                    </Text>
                    <Text>
                      You can choose maximum{' '}
                      {
                        viewRenewMotorPolicy?.vehicleTabDetails
                          ?.insuredDeclaredDetails?.sideCarPct
                      }
                      % deviation from the received Side Car Value
                    </Text>
                  </Text>
                ),
                value: values?.vehicleTabDetails
                  ?.insuredDeclaredDetails?.sideCarValue
                  ? parseFloat(
                      values?.vehicleTabDetails
                        ?.insuredDeclaredDetails?.sideCarValue,
                    )
                  : '',
                initialValue: viewRenewMotorPolicy?.vehicleTabDetails
                  ?.insuredDeclaredDetails?.sideCarValue
                  ? parseFloat(
                      viewRenewMotorPolicy?.vehicleTabDetails
                        ?.insuredDeclaredDetails?.sideCarValue,
                    )
                  : null,
              }
            : null,
        ]?.filter((d) => d),
      },
      {
        grid_type: 'input',
        title: (
          <Text
            className={'font-semibold'}
            severity={'info'}
            type={'normal'}
          >
           Other Discounts
          </Text>
        ),
        clickToEdit: true,
        initDisplayEdit: viewRenewMotorPolicy?.isProposalRenewed
          ? false
          : expandedCard.current
              .find(
                (exp) =>
                  exp?.cardName === 'vehicleAndRegistrationDetails',
              )
              ?.subSections?.includes('otherDiscounts'),
        onValueChanges: (values) => {
          setValueChanges(values);
        },
        editDisplayDisabled: viewRenewMotorPolicy?.isProposalRenewed,
        onEdit: (_) => {
          setEnableRenew(false);
          setFieldValue(`countEditsOpen`, values?.countEditsOpen + 1);
          expandedCard.current = [
            ...expandedCard.current.filter(
              (exp) =>
                exp?.cardName !== 'vehicleAndRegistrationDetails',
            ),
            {
              ...expandedCard.current.find(
                (exp) =>
                  exp?.cardName === 'vehicleAndRegistrationDetails',
              ),
              cardFlag: true,
              subSections: [
                ...expandedCard.current.find(
                  (exp) =>
                    exp?.cardName === 'vehicleAndRegistrationDetails',
                )?.subSections,
                'otherDiscounts',
              ],
            },
          ];
          if (
            props.forwardedAlertsRef &&
            props.forwardedAlertsRef.current
          ) {
            props.forwardedAlertsRef.current = [];
          }
          updateViewRenewMotorPolicyVar({
            isProposalReadyForRenewal: false,
          });
          setVehicleAndRegistrationDetailsCardToggle(false);
        },
        onCancel: (_, valuesBeforeEdit) => {
          if (values?.countEditsOpen === 1) {
            updateViewRenewMotorPolicyVar({
              isProposalReadyForRenewal: true,
            });
            setEnableRenew(true);
          }
          setFieldValue(`countEditsOpen`, values?.countEditsOpen - 1);
          setFieldValue(
            'vehicleTabDetails.otherDiscounts.otherDiscounts.creditScore',
            valuesBeforeEdit?.vehicleTabDetails
              ?.otherDiscounts?.creditScore,
          );
          setFieldValue(
            'vehicleTabDetails.insuredDeclaredDetails.idproof',
            valuesBeforeEdit?.vehicleTabDetails
              ?.insuredDeclaredDetails?.idproof,
          );
          setFieldValue(
            'vehicleTabDetails.insuredDeclaredDetails.idproofNo',
            valuesBeforeEdit?.vehicleTabDetails
              ?.insuredDeclaredDetails?.idproofNo,
          );
          expandedCard.current = [
            ...expandedCard.current.filter(
              (exp) =>
                exp?.cardName !== 'vehicleAndRegistrationDetails',
            ),
            {
              ...expandedCard.current.find(
                (exp) =>
                  exp?.cardName === 'vehicleAndRegistrationDetails',
              ),
              cardFlag: false,
              subSections: [
                ...expandedCard.current
                  .find(
                    (exp) =>
                      exp?.cardName ===
                      'vehicleAndRegistrationDetails',
                  )
                  ?.subSections?.filter(
                    (subSection) =>
                      subSection !== 'otherDiscounts',
                  ),
              ],
            },
          ];
          if (
            props.forwardedAlertsRef &&
            props.forwardedAlertsRef.current
          ) {
            props.forwardedAlertsRef.current = [];
          }
          setVehicleAndRegistrationDetailsCardToggle(true);
        },
        onSave: (_) => {
          if (values?.countEditsOpen === 1) {
            updateViewRenewMotorPolicyVar({
              isProposalReadyForRenewal: true,
            });
            setEnableRenew(true);
          }
          setFieldValue(`countEditsOpen`, values?.countEditsOpen - 1);
          expandedCard.current = [
            ...expandedCard.current.filter(
              (exp) =>
                exp?.cardName !== 'vehicleAndRegistrationDetails',
            ),
            {
              ...expandedCard.current.find(
                (exp) =>
                  exp?.cardName === 'vehicleAndRegistrationDetails',
              ),
              cardFlag: false,
              subSections: [
                ...expandedCard.current
                  .find(
                    (exp) =>
                      exp?.cardName ===
                      'vehicleAndRegistrationDetails',
                  )
                  ?.subSections?.filter(
                    (subSection) =>
                      subSection !== 'otherDiscounts',
                  ),
              ],
            },
          ];
          if (
            props.forwardedAlertsRef &&
            props.forwardedAlertsRef.current
          ) {
            props.forwardedAlertsRef.current = [];
          }
          setVehicleAndRegistrationDetailsCardToggle(true);
        },
        disableSubmit:
          validate(values)?.vehicleTabDetails
            ?.otherDiscounts !== undefined,
        resetOnCancel: false,
        isBorderRequired: true,
        borderClassName: 'border-t-2 border-neutral pt-2',
        grid_data: [
          {
            type: 'radiogroup',
            // enableSlider: !viewRenewMotorPolicy?.isProposalRenewed,
            label: (
              <Text type={'label'}>
                 Do you want to get additional discounts based on credit
              score? <Text severity={'error'}>*</Text>
              </Text>
            ),
            labelReadOnly: ' Do you want to get additional discounts based on credit score?',
            name: 'vehicleTabDetails.otherDiscounts.creditScore',
            className: viewRenewMotorPolicy?.isProposalRenewed
              ? 'border-neutral-dark'
              : '',
              data: [
                {
                  label: 'Yes',
                  value: 'Yes',
                },
                {
                  label: 'No',
                  value: 'No',
                },
              ],
            readOnlyValue: 
              values?.vehicleTabDetails?.otherDiscounts?.creditScore ,
            value: values?.vehicleTabDetails?.otherDiscounts?.creditScore
              ? values?.vehicleTabDetails?.otherDiscounts?.creditScore
              :''
          },
          values?.vehicleTabDetails
          ?.otherDiscounts?.creditScore==='Yes'
          ?{
            type: 'select',
            // enableSlider: !viewRenewMotorPolicy?.isProposalRenewed,
            label: (
              <Text type={'label'}>
                 ID Proof Type <Text severity={'error'}>*</Text>
              </Text>
            ),
            labelReadOnly: 'ID Proof Type',
            name: 'vehicleTabDetails.otherDiscounts.idproof',
            className: viewRenewMotorPolicy?.isProposalRenewed
              ? 'border-neutral-dark'
              : '',
              data: PRD_IDProofTypeForCreditScoreList
              ? [
                  ...PRD_IDProofTypeForCreditScoreList.map(
                    (idProofType) => {
                      return {
                        label: idProofType.value
                          ? idProofType.value
                          : '',
                        value: idProofType.code ? idProofType.code : '',
                      };
                    },
                  ),
                ]
              : [],
            readOnlyValue: 
              values?.vehicleTabDetails?.otherDiscounts?.idproof ,
            value: values?.vehicleTabDetails?.otherDiscounts?.idproof
              ? values?.vehicleTabDetails?.otherDiscounts?.idproof
              : '',
          }
          :'',
          values?.vehicleTabDetails
          ?.otherDiscounts?.creditScore==='Yes'
          ?{
            type: 'text',
            // enableSlider: !viewRenewMotorPolicy?.isProposalRenewed,
            label: (
              <Text type={'label'}>
                 ID Proof Number <Text severity={'error'}>*</Text>
              </Text>
            ),
            labelReadOnly: 'ID Proof Number ',
            name: 'vehicleTabDetails.otherDiscounts.idproofNo',
            className: viewRenewMotorPolicy?.isProposalRenewed
              ? 'border-neutral-dark'
              : '',
            readOnlyValue: 
              values?.vehicleTabDetails?.otherDiscounts?.idproofNo ,
            value: values?.vehicleTabDetails?.otherDiscounts?.idproofNo
              ? values?.vehicleTabDetails?.otherDiscounts?.idproofNo
              : '',
          }
          :''
        ]?.filter((d) => d),
      },
    ];

    const prevInsuranceAndClaimsData = [
      {
        grid_type: 'data',
        title: (
          <Text
            className={'font-semibold'}
            severity={'info'}
            type={'normal'}
          >
            Previous Policy
          </Text>
        ),
        grid_data: [
          {
            label: 'Previous Insurer Name',
            text: viewRenewMotorPolicy?.additionalTabDetails
              ?.previousInsuranceAndClaims?.previousPolicyDetails
              ?.previousInsurerName,
          },
          {
            label: 'Expiring Policy Number',
            text: viewRenewMotorPolicy?.additionalTabDetails
              ?.previousInsuranceAndClaims?.previousPolicyDetails
              ?.expiringPolicyNumber,
          },
          {
            label: 'Policy/Cover Type',
            text: viewRenewMotorPolicy?.additionalTabDetails
              ?.previousInsuranceAndClaims?.previousPolicyDetails
              ?.policyCoverType,
          },
          {
            label: 'Policy Start Date',
            text: viewRenewMotorPolicy?.additionalTabDetails
              ?.previousInsuranceAndClaims?.previousPolicyDetails
              ?.policyStartDate,
          },
          {
            label: 'Policy Expiry Date',
            text: viewRenewMotorPolicy?.additionalTabDetails
              ?.previousInsuranceAndClaims?.previousPolicyDetails
              ?.policyExpiryDate,
          },
          {
            label: 'Policy Tenure',
            text: viewRenewMotorPolicy?.additionalTabDetails
              ?.previousInsuranceAndClaims?.previousPolicyDetails
              ?.policyTenureValue,
          },
        ],
      },
      {
        grid_type: 'data',
        title: (
          <Text
            className={'font-semibold'}
            severity={'info'}
            type={'normal'}
          >
            Previous Claims
          </Text>
        ),
        borderClassName: 'border-t-2 border-neutral pt-4',
        isBorderRequired: true,
        grid_data: [
          viewRenewMotorPolicy?.additionalTabDetails?.previousInsuranceAndClaims?.previousPolicyDetails?.policyTenureValue?.toLowerCase() ===
          'annual'
            ? {
                label: 'Total Claim Count',
                text: viewRenewMotorPolicy?.additionalTabDetails
                  ?.previousInsuranceAndClaims?.previousClaims
                  ?.totalClaimCountValue,
              }
            : null,
          viewRenewMotorPolicy?.additionalTabDetails?.previousInsuranceAndClaims?.previousPolicyDetails?.policyTenureValue?.toLowerCase() ===
            'long term' &&
          viewRenewMotorPolicy?.additionalTabDetails
            ?.previousInsuranceAndClaims?.previousClaims
            ?.noOfClaimsYear1
            ? {
                label: 'No of Claims in Year 1',
                text: viewRenewMotorPolicy?.additionalTabDetails
                  ?.previousInsuranceAndClaims?.previousClaims
                  ?.noOfClaimsYear1,
              }
            : null,
          viewRenewMotorPolicy?.additionalTabDetails?.previousInsuranceAndClaims?.previousPolicyDetails?.policyTenureValue?.toLowerCase() ===
            'long term' &&
          viewRenewMotorPolicy?.additionalTabDetails
            ?.previousInsuranceAndClaims?.previousClaims
            ?.noOfClaimsYear2
            ? {
                label: 'No of Claims in Year 2',
                text: viewRenewMotorPolicy?.additionalTabDetails
                  ?.previousInsuranceAndClaims?.previousClaims
                  ?.noOfClaimsYear2,
              }
            : null,
          viewRenewMotorPolicy?.additionalTabDetails?.previousInsuranceAndClaims?.previousPolicyDetails?.policyTenureValue?.toLowerCase() ===
            'long term' &&
          viewRenewMotorPolicy?.additionalTabDetails
            ?.previousInsuranceAndClaims?.previousClaims
            ?.noOfClaimsYear3
            ? {
                label: 'No of Claims in Year 3',
                text: viewRenewMotorPolicy?.additionalTabDetails
                  ?.previousInsuranceAndClaims?.previousClaims
                  ?.noOfClaimsYear3,
              }
            : null,
          {
            label: 'Total Claim Amount',
            text: viewRenewMotorPolicy?.additionalTabDetails
              ?.previousInsuranceAndClaims?.previousClaims
              ?.totalClaimAmount
              ? CurrencyFormater(
                  `${viewRenewMotorPolicy?.additionalTabDetails?.previousInsuranceAndClaims?.previousClaims?.totalClaimAmount}`,
                  true,
                  false,
                  branding,
                )
              : '',
          },
          viewRenewMotorPolicy?.additionalTabDetails?.previousInsuranceAndClaims?.previousPolicyDetails?.policyTenureValue?.toLowerCase() ===
          'annual'
            ? {
                label: 'Previous Year NCB Slab',
                text: viewRenewMotorPolicy?.additionalTabDetails
                  ?.previousInsuranceAndClaims?.previousClaims
                  ?.previousYearNCBSlab
                  ? `${viewRenewMotorPolicy?.additionalTabDetails?.previousInsuranceAndClaims?.previousClaims?.previousYearNCBSlab} %`
                  : '',
              }
            : null,
        ].filter((d) => d),
      },
    ];

    const financerDetailsData = [
      {
        title: (
          <Text type="normal" className={'font-semibold'}>
            Vehicle Owned / Financer Details
          </Text>
        ),
        grid_type: 'input',
        clickToEdit: true,
        initDisplayEdit: viewRenewMotorPolicy?.isProposalRenewed
          ? false
          : expandedCard.current
              .find((exp) => exp?.cardName === 'financeDetails')
              ?.subSections?.includes('vehicleOwned'),
        onValueChanges: (values) => {
          setValueChanges(values);
        },
        onEdit: (_) => {
          setEnableRenew(false);
          setFieldValue(`countEditsOpen`, values?.countEditsOpen + 1);
          expandedCard.current = [
            ...expandedCard.current.filter(
              (exp) => exp?.cardName !== 'financeDetails',
            ),
            {
              ...expandedCard.current.find(
                (exp) => exp?.cardName === 'financeDetails',
              ),
              cardFlag: true,
              subSections: [
                ...expandedCard?.current?.find(
                  (exp) => exp?.cardName === 'financeDetails',
                )?.subSections,
                'vehicleOwned',
              ],
            },
          ];
          if (
            props.forwardedAlertsRef &&
            props.forwardedAlertsRef.current
          ) {
            props.forwardedAlertsRef.current = [];
          }
          updateViewRenewMotorPolicyVar({
            isProposalReadyForRenewal: false,
          });
          setFinancerDetailsCardToggle(false);
        },
        onCancel: (_, valuesBeforeEdit) => {
          if (values?.countEditsOpen === 1) {
            updateViewRenewMotorPolicyVar({
              isProposalReadyForRenewal: true,
            });
            setEnableRenew(true);
          }
          setFieldValue(`countEditsOpen`, values?.countEditsOpen - 1);
          setFieldValue(
            `additionalTabDetails.financeDetails.vehicleOwned`,
            valuesBeforeEdit?.additionalTabDetails?.financeDetails
              ?.vehicleOwned,
          );
          setFieldValue(
            `additionalTabDetails.financeDetails.financerDetails.financerName`,
            valuesBeforeEdit?.additionalTabDetails?.financeDetails
              ?.financerDetails?.financerName,
          );
          setFieldValue(
            `additionalTabDetails.financeDetails.financerDetails.financerAddress`,
            valuesBeforeEdit?.additionalTabDetails?.financeDetails
              ?.financerDetails?.financerAddress,
          );
          setFieldValue(
            `additionalTabDetails.financeDetails.financerDetails.financerAgreementType`,
            valuesBeforeEdit?.additionalTabDetails?.financeDetails
              ?.financerDetails?.financerAgreementType,
          );
          setFieldValue(
            `additionalTabDetails.financeDetails.financerDetails.loanAccountNumber`,
            valuesBeforeEdit?.additionalTabDetails?.financeDetails
              ?.financerDetails?.loanAccountNumber,
          );
          setFieldValue(
            `additionalTabDetails.financeDetails.financerDetails.fileNumber`,
            valuesBeforeEdit?.additionalTabDetails?.financeDetails
              ?.financerDetails?.fileNumber,
          );
          expandedCard.current = [
            ...expandedCard.current.filter(
              (exp) => exp?.cardName !== 'financeDetails',
            ),
            {
              ...expandedCard.current.find(
                (exp) => exp?.cardName === 'financeDetails',
              ),
              cardFlag: false,
              subSections: [
                ...expandedCard.current
                  .find((exp) => exp?.cardName === 'financeDetails')
                  ?.subSections?.filter(
                    (subSection) => subSection !== 'vehicleOwned',
                  ),
              ],
            },
          ];
          if (
            props.forwardedAlertsRef &&
            props.forwardedAlertsRef.current
          ) {
            props.forwardedAlertsRef.current = [];
          }
          setFinancerDetailsCardToggle(true);
        },
        onSave: (_) => {
          if (values?.countEditsOpen === 1) {
            updateViewRenewMotorPolicyVar({
              isProposalReadyForRenewal: true,
            });
            setEnableRenew(true);
          }
          setFieldValue(`countEditsOpen`, values?.countEditsOpen - 1);
          expandedCard.current = [
            ...expandedCard.current.filter(
              (exp) => exp?.cardName !== 'financeDetails',
            ),
            {
              ...expandedCard.current.find(
                (exp) => exp?.cardName === 'financeDetails',
              ),
              cardFlag: false,
              subSections: [
                ...expandedCard?.current
                  ?.find((exp) => exp?.cardName === 'financeDetails')
                  ?.subSections?.filter(
                    (subSection) => subSection !== 'vehicleOwned',
                  ),
              ],
            },
          ];
          if (
            props.forwardedAlertsRef &&
            props.forwardedAlertsRef.current
          ) {
            props.forwardedAlertsRef.current = [];
          }
          setFinancerDetailsCardToggle(true);
        },
        resetOnCancel: false,
        isBorderRequired: false,
        editDisplayDisabled: viewRenewMotorPolicy?.isProposalRenewed,
        grid_data_on_edit: [
          {
            type: 'radiogroup',
            label: <>Is the Vehicle</>,
            colSpan: repeat,
            name: 'additionalTabDetails.financeDetails.vehicleOwned',
            disabledGlobal: viewRenewMotorPolicy?.isProposalRenewed,
            data:
              PRD_IsYourVehicle && PRD_IsYourVehicle?.length > 0
                ? PRD_IsYourVehicle?.map((isYourVehicle) => {
                    return {
                      label: isYourVehicle?.value
                        ? isYourVehicle?.value
                        : '',
                      value: isYourVehicle?.code
                        ? isYourVehicle?.code
                        : '',
                    };
                  })
                : [],
            onRadioChange: (val, _) => {
              if (
                getDomainData(PRD_IsYourVehicle, val, 'code', 'value')
                  ?.toString()
                  ?.toLowerCase() === 'self owned'
              ) {
                setFieldValue(
                  `additionalTabDetails.financeDetails.financerDetails.financerName`,
                  '',
                );
                setFieldValue(
                  `additionalTabDetails.financeDetails.financerDetails.financerAddress`,
                  '',
                );
                setFieldValue(
                  `additionalTabDetails.financeDetails.financerDetails.financerAgreementType`,
                  '',
                );
                setFieldValue(
                  `additionalTabDetails.financeDetails.financerDetails.loanAccountNumber`,
                  '',
                );
                setFieldValue(
                  `additionalTabDetails.financeDetails.financerDetails.fileNumber`,
                  '',
                );
              }
            },
          },
          values?.additionalTabDetails?.financeDetails?.vehicleOwned?.toLowerCase() ===
          'financed'
            ? {
                type: 'input-lookup',
                colSpan: repeat === repeatForMobile ? 2 : 1,
                size: 'full',
                onLookup: async (val, setFieldValue) => {
                  if (val.toString().length > 0) {
                    setOnUpdate((_) => {
                      const newFunc = (data) => {
                        setFieldValue(
                          `additionalTabDetails.financeDetails.financerDetails.financerName`,
                          reformData(data.value, ''),
                        );
                      };
                      return newFunc;
                    });
                    setSearchStringFinancierName(val);
                    try {
                      let queryOutput = fetchQuery({
                        query: FINANCIER_NAME_LIST,
                        variables: {
                          value: val,
                        },
                      });
                      setFinancierNameOutput([]);
                      showFinancierNameModal(true);
                      setLoadingFinancierName(true);
                      let { data } = await queryOutput;
                      setLoadingFinancierName(false);
                      setFinancierNameOutput(
                        data.getFinancierNameList,
                      );
                    } catch (error) {
                      setErrors({
                        ...errors,
                        financierNameList: error?.message,
                      });
                      setLoadingFinancierName(false);
                      setFinancierNameOutput([]);
                    }
                  }
                },
                label: <>Financer Name</>,
                name: 'additionalTabDetails.financeDetails.financerDetails.financerName',
                disabled: viewRenewMotorPolicy?.isProposalRenewed,
              }
            : null,
          values?.additionalTabDetails?.financeDetails?.vehicleOwned?.toLowerCase() ===
          'financed'
            ? {
                type: 'text',
                colSpan: 2,
                label: <>Financer Address</>,
                name: 'additionalTabDetails.financeDetails.financerDetails.financerAddress',
                disabled: viewRenewMotorPolicy?.isProposalRenewed,
                colSpan: 2,
              }
            : null,
          values?.additionalTabDetails?.financeDetails?.vehicleOwned?.toLowerCase() ===
          'financed'
            ? {
                type: 'select',
                size: 'large',
                colSpan: repeat === repeatForMobile ? 2 : 1,
                label: <>Financer Agreement Type </>,
                name: 'additionalTabDetails.financeDetails.financerDetails.financerAgreementType',
                disabled: viewRenewMotorPolicy?.isProposalRenewed,
                data:
                  PRD_FinancerAgreementType &&
                  PRD_FinancerAgreementType?.length > 0
                    ? PRD_FinancerAgreementType?.map(
                        (financerAgreementType) => {
                          return {
                            label: financerAgreementType?.value
                              ? `${financerAgreementType?.value}`
                              : '',
                            value: financerAgreementType?.code
                              ? `${financerAgreementType?.code}`
                              : '',
                          };
                        },
                      )
                    : [],
              }
            : null,
          values?.additionalTabDetails?.financeDetails?.vehicleOwned?.toLowerCase() ===
          'financed'
            ? {
                type: 'text',
                colSpan: repeat === repeatForMobile ? 2 : 1,
                label: <>Loan Account Number </>,
                name: 'additionalTabDetails.financeDetails.financerDetails.loanAccountNumber',
                disabled: viewRenewMotorPolicy?.isProposalRenewed,
              }
            : null,
          values?.additionalTabDetails?.financeDetails?.vehicleOwned?.toLowerCase() ===
          'financed'
            ? {
                type: 'text',
                colSpan: repeat === repeatForMobile ? 2 : 1,
                label: <>File Number</>,
                name: 'additionalTabDetails.financeDetails.financerDetails.fileNumber',
                disabled: viewRenewMotorPolicy?.isProposalRenewed,
              }
            : null,
        ].filter((d) => d),
        grid_data: [
          {
            label: 'Vehicle Owned',
            type: 'text',
            name: 'additionalTabDetails.financeDetails.vehicleOwned',
            readOnlyValue: `${values?.additionalTabDetails?.financeDetails?.vehicleOwned}`,
          },
          getDomainData(
            PRD_IsYourVehicle,
            values?.additionalTabDetails?.financeDetails
              ?.vehicleOwned,
            'code',
            'value',
          )
            ?.toLowerCase()
            ?.search('financed') !== -1
            ? {
                label: 'Financer Name',
                type: 'text',
                name: 'additionalTabDetails.financeDetails.financerDetails.financerName',
                readOnlyValue: `${values?.additionalTabDetails?.financeDetails?.financerDetails?.financerName}`,
              }
            : null,
          getDomainData(
            PRD_IsYourVehicle,
            values?.additionalTabDetails?.financeDetails
              ?.vehicleOwned,
            'code',
            'value',
          )
            ?.toLowerCase()
            ?.search('financed') !== -1
            ? {
                label: 'Financer Address',
                type: 'text',
                name: 'additionalTabDetails.financeDetails.financerDetails.financerAddress',
                readOnlyValue: `${values?.additionalTabDetails?.financeDetails?.financerDetails?.financerAddress}`,
              }
            : null,
          getDomainData(
            PRD_IsYourVehicle,
            values?.additionalTabDetails?.financeDetails
              ?.vehicleOwned,
            'code',
            'value',
          )
            ?.toLowerCase()
            ?.search('financed') !== -1
            ? {
                label: 'Financer Agreement Type',
                type: 'text',
                name: 'additionalTabDetails.financeDetails.financerDetails.financerAgreementType',
                readOnlyValue: `${values?.additionalTabDetails?.financeDetails?.financerDetails?.financerAgreementType}`,
              }
            : null,
          getDomainData(
            PRD_IsYourVehicle,
            values?.additionalTabDetails?.financeDetails
              ?.vehicleOwned,
            'code',
            'value',
          )
            ?.toLowerCase()
            ?.search('financed') !== -1
            ? {
                label: 'Loan Account Number',
                type: 'text',
                name: 'additionalTabDetails.financeDetails.financerDetails.loanAccountNumber',
                readOnlyValue: `${values?.additionalTabDetails?.financeDetails?.financerDetails?.loanAccountNumber}`,
              }
            : null,
          getDomainData(
            PRD_IsYourVehicle,
            values?.additionalTabDetails?.financeDetails
              ?.vehicleOwned,
            'code',
            'value',
          )
            ?.toLowerCase()
            ?.search('financed') !== -1
            ? {
                label: 'File Number',
                type: 'text',
                name: 'additionalTabDetails.financeDetails.financerDetails.fileNumber',
                readOnlyValue: `${values?.additionalTabDetails?.financeDetails?.financerDetails?.fileNumber}`,
              }
            : null,
        ].filter((d) => d),
      },
      viewRenewMotorPolicy?.proposerDetails?.customerType=='Individual'
      ?
      {
        grid_type: 'input',
        title: (
          <Text
            className={'font-semibold'}
            severity={'info'}
            type={'normal'}
          >
            Nominee Details
          </Text>
        ),
      clickToEdit:true,
      initDisplayEdit: viewRenewMotorPolicy?.isProposalRenewed
            ? false
            : 
            // viewRenewMotorPolicy?.coverData?.addOnCovers?.[`Owner Driver`]?.selected ||
             expandedCard.current
            .find((exp) => exp?.cardName === 'financeDetails')
            ?.subSections?.includes('nomineeDetails'),
      onValueChanges: (values) => {
        setValueChanges(values);
      },
      editDisplayDisabled:
        viewRenewMotorPolicy?.isProposalRenewed
        ||viewRenewMotorPolicy?.coverData?.addOnCovers?.[`Owner Driver`]?.selected!==true ,
      onEdit: (_) => {
        setEnableRenew(false);
        if (
          props.forwardedAlertsRef &&
          props.forwardedAlertsRef.current
        ) {
          props.forwardedAlertsRef.current = [];
        }
        setFieldValue(`countEditsOpen`, values?.countEditsOpen + 1);
        expandedCard.current = [
          ...expandedCard.current.filter(
            (exp) =>
              exp?.cardName !== 'financeDetails',
          ),
          {
            ...expandedCard.current.find(
              (exp) =>
                exp?.cardName === 'financeDetails',
            ),
            cardFlag: true,
            subSections: [
              ...expandedCard.current.find(
                (exp) =>
                  exp?.cardName === 'financeDetails',
              )?.subSections,
              'nomineeDetails',
            ],
          },
        ];
        if (
          props.forwardedAlertsRef &&
          props.forwardedAlertsRef.current
        ) {
          props.forwardedAlertsRef.current = [];
        }
        updateViewRenewMotorPolicyVar({
          isProposalReadyForRenewal: false,
        });
        setFinancerDetailsCardToggle(false);
      },
      onCancel: (_, valuesBeforeEdit) => {
        if (values?.countEditsOpen === 1) {
          updateViewRenewMotorPolicyVar({
            isProposalReadyForRenewal: true,
          });
          setEnableRenew(true);
        }
        if (
          props.forwardedAlertsRef &&
          props.forwardedAlertsRef.current
        ) {
          props.forwardedAlertsRef.current = [];
        }
        setFieldValue(`countEditsOpen`, values?.countEditsOpen - 1);
        setFieldValue(
          `additionalTabDetails.nomineeDetails.nameOfAppointee`,
          valuesBeforeEdit?.additionalTabDetails.nomineeDetails.nameOfAppointee,
        );
        setFieldValue(
          `additionalTabDetails.nomineeDetails.nomineeDob`,
          valuesBeforeEdit?.additionalTabDetails.nomineeDetails.nomineeDob,
        );
        setFieldValue(
          `additionalTabDetails.nomineeDetails.nomineeName`,
          valuesBeforeEdit?.additionalTabDetails.nomineeDetails.nomineeName,
        );
        setFieldValue(
          `additionalTabDetails.nomineeDetails.relationshipWithAppointee`,
          valuesBeforeEdit?.additionalTabDetails.nomineeDetails.relationshipWithAppointee,
        );
        setFieldValue(
          `additionalTabDetails.nomineeDetails.relationshipWithNominee`,
          valuesBeforeEdit?.additionalTabDetails.nomineeDetails.relationshipWithNominee,
        );
        expandedCard.current = [
          ...expandedCard.current.filter(
            (exp) =>
              exp?.cardName !== 'financeDetails',
          ),
          {
            ...expandedCard.current.find(
              (exp) =>
                exp?.cardName === 'financeDetails',
            ),
            cardFlag: false,
            subSections: [
              ...expandedCard.current
                .find(
                  (exp) =>
                    exp?.cardName ===
                    'financeDetails',
                )
                ?.subSections?.filter(
                  (subSection) =>
                    subSection !== 'nomineeDetails',
                ),
            ],
          },
        ];
        if (
          props.forwardedAlertsRef &&
          props.forwardedAlertsRef.current
        ) {
          props.forwardedAlertsRef.current = [];
        }
        setFinancerDetailsCardToggle(true);
      },
      onSave: (_) => {
        if (values?.countEditsOpen === 1) {
          updateViewRenewMotorPolicyVar({
            isProposalReadyForRenewal: true,
          });
          setEnableRenew(true);
        }
        if (
          props.forwardedAlertsRef &&
          props.forwardedAlertsRef.current
        ) {
          props.forwardedAlertsRef.current = [];
        }
        setFieldValue(`countEditsOpen`, values?.countEditsOpen - 1);
        setFieldValue(
          `additionalTabDetails.nomineeDetails.nameOfAppointee`,
          values?.additionalTabDetails.nomineeDetails.nameOfAppointee,
        );
        setFieldValue(
          `additionalTabDetails.nomineeDetails.nomineeDob`,
          values?.additionalTabDetails.nomineeDetails.nomineeDob,
        );
        setFieldValue(
          `additionalTabDetails.nomineeDetails.nomineeName`,
          values?.additionalTabDetails.nomineeDetails.nomineeName,
        );
        setFieldValue(
          `additionalTabDetails.nomineeDetails.relationshipWithAppointee`,
          values?.additionalTabDetails.nomineeDetails.relationshipWithAppointee,
        );
        setFieldValue(
          `additionalTabDetails.nomineeDetails.relationshipWithNominee`,
          values?.additionalTabDetails.nomineeDetails.relationshipWithNominee,
        );
        expandedCard.current = [
          ...expandedCard.current.filter(
            (exp) =>
              exp?.cardName !== 'financeDetails',
          ),
          {
            ...expandedCard.current.find(
              (exp) =>
                exp?.cardName === 'financeDetails',
            ),
            cardFlag: false,
            subSections: [
              ...expandedCard.current
                .find(
                  (exp) =>
                    exp?.cardName ===
                    'financeDetails',
                )
                ?.subSections?.filter(
                  (subSection) =>
                    subSection !== 'nomineeDetails',
                ),
            ],
          },
        ];
        if (
          props.forwardedAlertsRef &&
          props.forwardedAlertsRef.current
        ) {
          props.forwardedAlertsRef.current = [];
        }
        setFinancerDetailsCardToggle(true);
      },
      disableSubmit:
        validate(values)?.additionalTabDetails
          ?.nomineeDetails !== undefined,
      resetOnCancel: false,
      isBorderRequired: true,
      borderClassName: 'border-t-2 border-neutral pt-2',
        grid_data: [
          {
            type: 'text',
            label: (
              <Text type={'label'}>
                Nominee Name <Text severity={'error'}>*</Text>
              </Text>
            ),
            type: 'text',
            text: viewRenewMotorPolicy?.additionalTabDetails
              ?.nomineeDetails?.nomineeName
              ?viewRenewMotorPolicy?.additionalTabDetails
              ?.nomineeDetails?.nomineeName
              :'Not Captured',
            labelReadOnly: 'Nominee Name',
            name: 'additionalTabDetails.nomineeDetails.nomineeName',
            readOnlyValue: `${values?.additionalTabDetails?.nomineeDetails?.nomineeName}`,
            // disabled: true,
          },
          {
            type: 'text',
            label: (
              <Text type={'label'}>
                Nominee Date of Birth <Text severity={'error'}>*</Text>
              </Text>
            ),
            type: 'date',
             text: viewRenewMotorPolicy?.additionalTabDetails
            ?.nomineeDetails?.nomineeDob
            ?viewRenewMotorPolicy?.additionalTabDetails
            ?.nomineeDetails?.nomineeDob
            :'Not Captured',
            labelReadOnly: 'Nominee Date of Birth',
            name: 'additionalTabDetails.nomineeDetails.nomineeDob',
            readOnlyValue: `${values?.additionalTabDetails?.nomineeDetails?.nomineeDob}`,
            // disabled: true,
          },
          {
            type: 'text',
            label: (
              <Text type={'label'}>
                Relationship <Text severity={'error'}>*</Text>
              </Text>
            ),
            type: 'select',
            data:
            (PRD_NomiRelationWithMemb && PRD_NomiRelationWithMemb?.length > 0) ? PRD_NomiRelationWithMemb?.map((relationship) => {
              return {
                label: relationship?.value ? relationship?.value : '',
                value: relationship?.code ? relationship?.code : ''
              }
            }) : [],
            labelReadOnly: 'Relationship',
            name: 'additionalTabDetails.nomineeDetails.relationshipWithNominee',
            readOnlyValue: `${values?.additionalTabDetails?.nomineeDetails?.relationshipWithNominee}`,
            // disabled: true,
          },
          {
            type: 'text',
           label: (
              <>
                Name of Appointee{' '}
                <Text severity="error"> {`${
                  // (getDomainData(customerTypeList,buyMotorPolicy?.proposerDetails?.customerType,'code','value')?.toLowerCase() === 'individual'
                  (moment(new Date(), 'DD/MM/YYYY').diff(
                    moment(values?.nomineeDetails?.nomineeDob, 'DD/MM/YYYY'),
                    'years',
                  ) < MINOR_THRESHOLD_AGE) ? '*' : ''}`}</Text>
              </>
            ),
            type: 'text',
             text: viewRenewMotorPolicy?.additionalTabDetails
            ?.nomineeDetails?.nameOfAppointee
            ?viewRenewMotorPolicy?.additionalTabDetails
            ?.nomineeDetails?.nameOfAppointee
            :'Not Captured',
            labelReadOnly: 'Name of Appointee',
            name: 'additionalTabDetails.nomineeDetails.nameOfAppointee',
            readOnlyValue: `${values?.additionalTabDetails?.nomineeDetails?.nameOfAppointee}`,
            disabled: (moment(new Date(), 'DD/MM/YYYY').diff(
              moment(values?.additionalTabDetails?.nomineeDetails?.nomineeDob, 'DD/MM/YYYY'),
              'years',
            ) >= MINOR_THRESHOLD_AGE),
          },
          {
            type: 'text',
            label: (
              <>
                Relationship with Appointee{' '}
                <Text severity="error"> {`${
                  (moment(new Date(), 'DD/MM/YYYY').diff(
                    moment(values?.nomineeDetails?.nomineeDob, 'DD/MM/YYYY'),
                    'years',
                  ) < MINOR_THRESHOLD_AGE) ? '*' : ''}`}</Text>
              </>
            ),
            type: 'select',
            data: (PRD_ApointRelationWithMinNomi && PRD_ApointRelationWithMinNomi?.length > 0) ? PRD_ApointRelationWithMinNomi?.map((relationship) => {
              return {
                label: relationship?.value ? relationship?.value : '',
                value: relationship?.code ? relationship?.code : ''
              }
            }) : [],
            labelReadOnly: 'Relationship with Appointee',
            name: 'additionalTabDetails.nomineeDetails.relationshipWithAppointee',
            readOnlyValue: `${values?.additionalTabDetails?.nomineeDetails?.relationshipWithAppointee}`,
           disabled: (moment(new Date(), 'DD/MM/YYYY').diff(
            moment(values?.additionalTabDetails?.nomineeDetails?.nomineeDob, 'DD/MM/YYYY'),
            'years',
          ) >= MINOR_THRESHOLD_AGE),
          },
        ].filter((d) => d),
      }
      :null,
    ].filter((d) => d)

    const otherCoverDetailsData = [
      {
        grid_type: 'data',
        grid_data: [
          {
            colSpan: repeatFormsReadOnly,
            text: (
              <Text className={'flex space-x-2 items-center mt-4'}>
                <Text
                  severity={
                    otherCoverDetails?.isGlassFuelTank
                      ? 'success'
                      : 'error'
                  }
                >
                  {otherCoverDetails?.isGlassFuelTank ? (
                    <FontAwesomeIcon icon={faCheck} />
                  ) : (
                    <FontAwesomeIcon icon={faTimesCircle} />
                  )}
                </Text>
                <Text>
                  {'Vehicle fitted With Fibre Glass Fuel Tank'}
                </Text>
              </Text>
            ),
          },
          {
            colSpan: repeatFormsReadOnly,
            text: (
              <Text className={'flex space-x-2 my-2 items-start'}>
                <Text
                  severity={
                    otherCoverDetails?.isVehicleForHandicapped
                      ? 'success'
                      : 'error'
                  }
                >
                  {otherCoverDetails?.isVehicleForHandicapped ? (
                    <FontAwesomeIcon icon={faCheck} />
                  ) : (
                    <FontAwesomeIcon icon={faTimesCircle} />
                  )}
                </Text>
                <Text>
                  {
                    'Is the Vehicle used for blind and handicapped persons duly endorsed by RTA?'
                  }
                </Text>
              </Text>
            ),
          },
          {
            colSpan: repeatFormsReadOnly,
            text: (
              <Text className={'flex flex-col'}>
                <Text className={'flex space-x-2 items-center'}>
                  <Text
                    severity={
                      otherCoverDetails?.isGeoAreaExtension
                        ? 'success'
                        : 'error'
                    }
                  >
                    {otherCoverDetails?.isGeoAreaExtension ? (
                      <FontAwesomeIcon icon={faCheck} />
                    ) : (
                      <FontAwesomeIcon icon={faTimesCircle} />
                    )}
                  </Text>
                  <Text>{'Geographical Area Extensions'}</Text>
                </Text>
                {otherCoverDetails?.isGeoAreaExtension && (
                  <Grid
                    repeat={repeatFormsReadOnly}
                    className={'ml-5 mt-2'}
                  >
                    <GridItem
                      className={'flex space-x-2 items-center'}
                    >
                      <Text
                        severity={
                          otherCoverDetails?.isBangladeshCovered
                            ? 'success'
                            : 'error'
                        }
                      >
                        {otherCoverDetails?.isBangladeshCovered ? (
                          <FontAwesomeIcon icon={faCircle} />
                        ) : (
                          <FontAwesomeIcon icon={faCircleRegular} />
                        )}
                      </Text>
                      <Text>{'Bangladesh'}</Text>
                    </GridItem>
                    <GridItem
                      className={'flex space-x-2 items-center'}
                    >
                      <Text
                        severity={
                          otherCoverDetails?.isBhutanCovered
                            ? 'success'
                            : 'error'
                        }
                      >
                        {otherCoverDetails?.isBhutanCovered ? (
                          <FontAwesomeIcon icon={faCircle} />
                        ) : (
                          <FontAwesomeIcon icon={faCircleRegular} />
                        )}
                      </Text>
                      <Text>{'Bhutan'}</Text>
                    </GridItem>
                    <GridItem
                      className={'flex space-x-2 items-center'}
                    >
                      <Text
                        severity={
                          otherCoverDetails?.isNepalCovered
                            ? 'success'
                            : 'error'
                        }
                      >
                        {otherCoverDetails?.isNepalCovered ? (
                          <FontAwesomeIcon icon={faCircle} />
                        ) : (
                          <FontAwesomeIcon icon={faCircleRegular} />
                        )}
                      </Text>
                      <Text>{'Nepal'}</Text>
                    </GridItem>
                    <GridItem
                      className={'flex space-x-2 items-center'}
                    >
                      <Text
                        severity={
                          otherCoverDetails?.isMaldivesCovered
                            ? 'success'
                            : 'error'
                        }
                      >
                        {otherCoverDetails?.isMaldivesCovered ? (
                          <FontAwesomeIcon icon={faCircle} />
                        ) : (
                          <FontAwesomeIcon icon={faCircleRegular} />
                        )}
                      </Text>
                      <Text>{'Maldives'}</Text>
                    </GridItem>
                    <GridItem
                      className={'flex space-x-2 items-center'}
                    >
                      <Text
                        severity={
                          otherCoverDetails?.isPakistanCovered
                            ? 'success'
                            : 'error'
                        }
                      >
                        {otherCoverDetails?.isPakistanCovered ? (
                          <FontAwesomeIcon icon={faCircle} />
                        ) : (
                          <FontAwesomeIcon icon={faCircleRegular} />
                        )}
                      </Text>
                      <Text>{'Pakistan'}</Text>
                    </GridItem>
                    <GridItem
                      className={'flex space-x-2 items-center'}
                    >
                      <Text
                        severity={
                          otherCoverDetails?.isSriLankaCovered
                            ? 'success'
                            : 'error'
                        }
                      >
                        {otherCoverDetails?.isSriLankaCovered ? (
                          <FontAwesomeIcon icon={faCircle} />
                        ) : (
                          <FontAwesomeIcon icon={faCircleRegular} />
                        )}
                      </Text>
                      <Text>{'Sri Lanka'}</Text>
                    </GridItem>
                  </Grid>
                )}
              </Text>
            ),
          },
        ],
      },
    ];

    const otherPropsTopSection = {
      flow: 'cols',
      repeat,
      gapX: 6,
      gapY: 0,
      spaceY: 2,
      size: 'full',
      titleSeverity: 'info',
      textType: 'normal',
      nullData: () => <Text severity="neutral">Not Captured</Text>,
    };

    const other_props = {
      flow: 'cols',
      textType: 'normal',
      repeat: repeatFormsReadOnly,
      repeatOnEdit: repeatFormsonEdit,
      gapX: 6,
      gapY: 0,
      spaceY: 2,
      size: 'full',
      titleSeverity: 'info',
      useExpandablePaper: false,
      useGlobalExpandablePaper: true,
      globalTitleSeverity: 'info',
      globalTitleType: 'large',
      nullData: () => <Text severity="neutral">Not Captured</Text>,
    };
    return (
      <>
      <QuantaForm className="space-y-4">
        <Text severity={'info'} type={'title'}>
          Review Proposal
        </Text>
        <MixedGridGroup
          {...{
            data: intermediaryDetailsData,
            ...{ ...other_props, useGlobalExpandablePaper: false },
            globalTitle: 'Intermediary Details',
            isToggleEnabled:
              !expandedCard.current.find(
                (exp) => exp?.cardName === 'intermediaryDetails',
              )?.cardFlag || intermediaryDetailsCardToggle,
            expanded: renderExpandedCards?.current[0],
            setExpandedCards: (expanded) => {
              renderExpandedCards.current = [
                expanded,
                ...renderExpandedCards?.current?.slice(1),
              ];
            },
          }}
        />
        <MixedGridGroup
            {...{
              data: reviewAndConfirmData,
              ...otherPropsTopSection,
            }}
        />
        <MixedGridGroup
          {...{
            data: ProposerCustomerEditable({
              setValueChanges,
              repeat,
              repeatFormsReadOnly,
              customerTypeList,
              expandedCard,
              genderList,
              getDomainData,
              idProofTypeList,
              loadingPermCustAddr,
              loadingCommCustAddr,
              maritalStatusList,
              nationalityList,
              onCommAddrLookup,
              onPermAddrLookup,
              organisationList,
              proposerDetails,
              proposerDetailsMeta,
              salutationList,
              setFieldValue,
              setProposerDetailsCardToggle,
              updateViewRenewPolicyData:
                updateViewRenewMotorPolicyVar,
              validate,
              values,
              viewRenewPolicyData: viewRenewMotorPolicy,
              setEnableRenew,
              productCode,
              ...props,
            }),
            ...other_props,
            globalTitle: 'Proposer Customer',
            isToggleEnabled:
              !expandedCard.current.find(
                (exp) => exp?.cardName === 'proposerDetails',
              )?.cardFlag || proposerDetailsCardToggle,
            expanded: renderExpandedCards?.current[1],
            setExpandedCards: (expanded) => {
              renderExpandedCards.current = [
                ...renderExpandedCards?.current?.slice(0, 1),
                expanded,
                ...renderExpandedCards?.current?.slice(2),
              ];
            },
          }}
        />
        <MixedGridGroup
          {...{
            data: vehicleDetailsData,
            ...other_props,
            globalTitle: 'Vehicle And Registration Details',
            isToggleEnabled: validate(values)?.vehicleTabDetails
              ?.vehicleRegistrationDetails?.registrationNumber
              ? false
              : !expandedCard.current.find(
                  (exp) =>
                      exp?.cardName ===
                      'vehicleAndRegistrationDetails',
                )?.cardFlag ||
                vehicleAndRegistrationDetailsCardToggle,
            expanded:
              renderExpandedCards?.current[2] ||
              validate(values)?.vehicleTabDetails
                ?.vehicleRegistrationDetails?.registrationNumber !==
                undefined,
            setExpandedCards: (expanded) => {
              renderExpandedCards.current = [
                ...renderExpandedCards?.current?.slice(0, 2),
                expanded,
                ...renderExpandedCards?.current?.slice(3),
              ];
            },
          }}
        />
        {viewRenewMotorPolicy?.additionalTabDetails
          ?.previousInsuranceAndClaims?.previousPolicyDetails
          ?.previousInsurerName &&
          viewRenewMotorPolicy?.additionalTabDetails
            ?.previousInsuranceAndClaims?.previousPolicyDetails
            ?.policyTenureValue && (
            <MixedGridGroup
              {...{
                data: prevInsuranceAndClaimsData,
                ...other_props,
                globalTitle: 'Previous Insurance & Claims Details',
                expanded: renderExpandedCards?.current[3],
                setExpandedCards: (expanded) => {
                  renderExpandedCards.current = [
                    ...renderExpandedCards?.current?.slice(0, 3),
                    expanded,
                    ...renderExpandedCards?.current?.slice(4),
                  ];
                },
              }}
            />
          )}
        <MixedGridGroup
          {...{
            data: financerDetailsData,
            ...other_props,
            globalTitle: 'Finance Details',
            isToggleEnabled:
              !expandedCard.current.find(
                (exp) => exp?.cardName === 'financeDetails',
              )?.cardFlag || financerDetailsCardToggle,
            expanded:
              viewRenewMotorPolicy?.additionalTabDetails
                ?.previousInsuranceAndClaims?.previousPolicyDetails
                ?.previousInsurerName &&
              viewRenewMotorPolicy?.additionalTabDetails
                ?.previousInsuranceAndClaims?.previousPolicyDetails
                ?.policyTenureValue
                ? renderExpandedCards?.current[4]
                : renderExpandedCards?.current[3],
            setExpandedCards: (expanded) => {
              if (
                viewRenewMotorPolicy?.additionalTabDetails
                    ?.previousInsuranceAndClaims
                    ?.previousPolicyDetails?.previousInsurerName &&
                viewRenewMotorPolicy?.additionalTabDetails
                    ?.previousInsuranceAndClaims
                    ?.previousPolicyDetails?.policyTenureValue
              ) {
                renderExpandedCards.current = [
                  ...renderExpandedCards?.current?.slice(0, 4),
                  expanded,
                  ...renderExpandedCards?.current?.slice(5),
                ];
              } else {
                renderExpandedCards.current = [
                  ...renderExpandedCards?.current?.slice(0, 3),
                  expanded,
                  ...renderExpandedCards?.current?.slice(4),
                ];
              }
            },
          }}
        />
        <MixedGridGroup
          {...{
            data: otherCoverDetailsData,
            ...other_props,
            globalTitle: 'Other Cover Details',
            expanded:
              viewRenewMotorPolicy?.additionalTabDetails
                ?.previousInsuranceAndClaims?.previousPolicyDetails
                ?.previousInsurerName &&
              viewRenewMotorPolicy?.additionalTabDetails
                ?.previousInsuranceAndClaims?.previousPolicyDetails
                ?.policyTenureValue
                ? renderExpandedCards?.current[5]
                : renderExpandedCards?.current[4],
            setExpandedCards: (expanded) => {
              if (
                viewRenewMotorPolicy?.additionalTabDetails
                    ?.previousInsuranceAndClaims
                    ?.previousPolicyDetails?.previousInsurerName &&
                viewRenewMotorPolicy?.additionalTabDetails
                    ?.previousInsuranceAndClaims
                    ?.previousPolicyDetails?.policyTenureValue
              ) {
                renderExpandedCards.current = [
                  ...renderExpandedCards?.current?.slice(0, 5),
                  expanded,
                  ...renderExpandedCards?.current?.slice(6),
                ];
              } else {
                renderExpandedCards.current = [
                  ...renderExpandedCards?.current?.slice(0, 4),
                  expanded,
                  ...renderExpandedCards?.current?.slice(5),
                ];
              }
            },
          }}
        />
        <div className="flex justify-end items-baseline w-full space-x-2 pb-2">
          <span>
        
            <Button
              type={'button'}
              size={'large'}
              
              flat={false}
              className={'w-40'}
              disabled={UWCompleted&&viewRenewMotorPolicy?.proposalStatus==='RCCN'
              &&modify=='false'
              }
              iconPre={
                isCalculatingPremium
                ?
                <FontAwesomeIcon icon={faSpinner} className={'w-40'}spin={true} />
                : <FontAwesomeIcon icon={faCalculator} className={'w-40'} />
              }
              onClick={async (_) => {
                 if(viewRenewMotorPolicy?.coverData?.addOnCovers?.[`Owner Driver`]?.selected==true&&
                 values?.additionalTabDetails?.nomineeDetails?.nomineeName==''){
                  setResultPremiumError('Please fill the nominee Details before proceeding');
                  
                 }
                 else{
                try {
                   setResultPremiumError(null);
                   setWarningMsg(null);
                 
                  const getCalculatePremiumQuery = fetchQuery({
                    query: CALCULATE_PREMIUM_FOR_PROPOSAL_TW,
                    fetchPolicy: 'network-only',
                    variables:
                    getCalculatePremiumForProposalVariables(
                      values,
                      props?.forwardedPremiumFormRef?.current?.values,
                    ),
                  });
                   setCalculatingPremium(true);
                  const { data } = await getCalculatePremiumQuery;
                  setParentAlerts([
                    {
                      header: '',
                      id: Date.now(),
                      content: (
                        <div className="flex flex-row flex-wrap space-y-2 w-full h-full">
                         Premium Calculated successfully
                        </div>
                      ),
                      type: 'info',
                      timeout: null,
                      disableClose: false,
                    },
                  ]);
                   updateViewRenewMotorPolicyVar({
                    premiumData: {
                      ...(data?.pcvcalculatePremiumProposal ||
                        values?.premiumData),
                      tenure:
                        viewRenewMotorPolicy?.premiumData?.tenure ||
                        viewRenewMotorPolicy?.quoteData?.premiumData
                          ?.tenure ||
                        viewRenewMotorPolicy?.quoteData?.tenure,
                      creditScore:
                        viewRenewMotorPolicy?.premiumData?.creditScore,
                    },
                    // additionalTabDetails:{
                    //   ...viewRenewMotorPolicy?.additionalTabDetails,
                    // nomineeDetails: {
                    //   nomineeName: values?.addOnCovers?.[`Owner Driver`]?.selected!==true
                    //   ?'':viewRenewMotorPolicy?.additionalTabDetails
                    //   ?.nomineeDetails?.nomineeName,
                    //   nomineeDob:values?.addOnCovers?.[`Owner Driver`]?.selected!==true
                    //   ?'':viewRenewMotorPolicy?.additionalTabDetails
                    //   ?.nomineeDetails?.nomineeDob,
                    //   relationshipWithNominee: values?.addOnCovers?.[`Owner Driver`]?.selected!==true
                    //   ?'':viewRenewMotorPolicy?.additionalTabDetails
                    //   ?.nomineeDetails?.relationshipWithNominee,
                    //   nameOfAppointee: values?.addOnCovers?.[`Owner Driver`]?.selected!==true
                    //   ?'':viewRenewMotorPolicy?.additionalTabDetails
                    //   ?.nomineeDetails?.nameOfAppointee,
                    //   relationshipWithAppointee: values?.addOnCovers?.[`Owner Driver`]?.selected!==true
                    //   ?'':viewRenewMotorPolicy?.additionalTabDetails
                    //   ?.nomineeDetails?.relationshipWithAppointee,
                    // },},
                    quoteData: {
                      ...viewRenewMotorPolicy?.quoteData,
                      premiumData:
                        premiumData?.pcvcalculatePremiumProposal ||
                        values?.premiumData,
                       
                    },
                    enablecalcrenew:false,
                  });
                  if (
                    data?.pcvcalculatePremiumProposal?.warningMsg
                  ) {
                    setWarningMsg(
                      data?.pcvcalculatePremiumProposal?.warningMsg,
                    );
                  }
                   setCalculatingPremium(false);
                   setParentAlerts([
                    {
                      header: '',
                      id: Date.now(),
                      content: (
                        <div className="flex flex-row flex-wrap space-y-2 w-full h-full">
                          Premium Calculated successfully
                        </div>
                      ),
                      type: 'success',
                      timeout: 9000,
                      disableClose: false,
                    },
                  ]);
                } catch (error) {
                   setCalculatingPremium(false);
                   
                  if(error?.message?.includes("Unexpected token")){
                     setResultPremiumError('Please try again after sometime');
                  }
                  else{
                   setResultPremiumError(error?.message);
                  }
                   setWarningMsg(null);
                }
              }
              }
            }
            >
            {isCalculatingPremium ? (
               <>
                 <Text>Calculating Premium</Text>
               </>
             ) :(
               <>
               <Text>Recalculate
               </Text>
             </>
          )}
            </Button>
           
            <Text
              severity="info"
              className="flex space-x-2 items-center"
            >
            { resultPremiumError ? (
                setParentAlerts([
                  {
                    header: 'Error Calculating Premium',
                    id: Date.now(),
                    content: (
                      <div className="flex flex-row flex-wrap space-y-2 w-full h-full">
                        {resultPremiumError}
                      </div>
                    ),
                    type: 'error',
                    timeout: null,
                    disableClose: false,
                  },
                ]),
                <>
                  <Text type="normal" severity="error">
                    <FontAwesomeIcon icon={faExclamationCircle} />
                  </Text>
                  <Text severity="error">
                    Error Calculating Premium
                  </Text>
                </>
              ) 
              // :  resultPremiumError
              // ? {
              //     type: 'render',
              //     colSpan: repeat,
              //     component: () => (
              //       <Text severity={'error'} className={'flex space-x-2'}>
              //         <Text>
              //           <FontAwesomeIcon icon={faExclamationCircle} />
              //         </Text>
              //         <Text>{resultPremiumError}</Text>
              //       </Text>
              //     ),
              //   }
              : null}
            </Text>
          </span>
          <span>
          </span>
        </div>
      </QuantaForm>
        <div>
          <SearchResultsModal
            {...{
              modalSizeExternal,
              modalDisplay: financierNameModalDisplay,
              isFormWrapFlag: true,
              searchInput,
              searchResults,
              paginationInput,
              title: 'Search Financer Name',
              onClose,
              onDataUpdate,
              onNoResultsFound,
              onMessage,
              selectOnRowClick: true,
              firstRowClickRequired: false,
            }}
          />
        </div>
      </>
    );
  };

  if (
    loading ||
    loadingPaymentType ||
    dateTimeLoading ||
    loadingCustTypeDomain ||
    loadingDropDownDetails ||
    loadingFinancerDropDownDetails ||
    loadingMyIntermediaries ||
    loadingProfileData ||
    loadingMobileNumberLength ||
    loadingdrop||
    (data && !data?.viewRenewMotorPolicy?.proposalNumber)
  ) {
    return (
      <div className="min-h-screen">
        <Loading />
      </div>
    );
  }
  if (
    error ||
    errorPaymentType ||
    errorTimeLoading ||
    errorCustTypeDomain ||
    errorDropDownDetails ||
    errorFinancerDropdownDetails ||
    errorMyIntermediaries ||
    errorProfileData ||
    errorMobileNumberLength
  ) {
    return (
      <div className="min-h-screen">
        <Error
          error={
            error ||
            errorPaymentType ||
            errorTimeLoading ||
            errorCustTypeDomain ||
            errorDropDownDetails ||
            errorFinancerDropdownDetails ||
            errorMyIntermediaries ||
            errorProfileData ||
            errorMobileNumberLength
          }
        />
      </div>
    );
  }
  const { datetimeValue } = dateTimeData;
  const viewRenewMotorPolicy = data
    ? data?.viewRenewMotorPolicy
    : previousData
    ? previousData?.viewRenewMotorPolicy
    : null;
  const selectedIntermediary = data
    ? data?.selectedIntermediary
    : previousData
    ? previousData?.selectedIntermediary
    : null;
  const proposerDetails = viewRenewMotorPolicy
    ? viewRenewMotorPolicy?.proposerDetails
    : null;
  const proposerDetailsMeta = viewRenewMotorPolicy
    ? viewRenewMotorPolicy?.proposerDetailsMeta
    : null;
  const { otherCoverDetails } = viewRenewMotorPolicy;
  const { customerTypeList } = dataCustTypeDomain;
  const {
    idProofTypeList,
    salutationList,
    genderList,
    maritalStatusList,
    nationalityList,
    organisationList,
  } = dataDropDownDetails;
  const { PRD_FinancerAgreementType, PRD_IsYourVehicle,PRD_IDProofTypeForCreditScoreList } =
    dataFinancerDropdownDetails;
    const { PRD_NomiRelationWithMemb, PRD_ApointRelationWithMinNomi } =
    dropDownDetails;
  
  const { myIntermediaries } = dataMyIntermediaries;
  const { userMyDetail } = profileData;
  const { userType } = userMyDetail;
  const { typeName } = userType;
  const { mobileNumberStartingWith } = dataMobileNumberLength;

  const initialValues = {
    intermediaryData: {
      intermediary:
        viewRenewMotorPolicy?.intermediaryDetails?.code &&
        myIntermediaries?.find(
          (myIntermediary) =>
            myIntermediary?.intermediaryCode
              ?.toString()
              ?.trim()
              ?.toLowerCase() ===
            viewRenewMotorPolicy?.intermediaryDetails?.code
              ?.toString()
              ?.toLowerCase(),
        ) &&
        myIntermediaries
          ?.find(
            (myIntermediary) =>
              myIntermediary?.intermediaryCode
                ?.toString()
                ?.trim()
                ?.toLowerCase() ===
              viewRenewMotorPolicy?.intermediaryDetails?.code
                ?.toString()
                ?.toLowerCase(),
          )
          // ?.businessLocations?.find(
          //   (businessLocation) =>
          //     businessLocation?.code?.toString()?.toLowerCase() ===
          //     viewRenewMotorPolicy?.intermediaryDetails?.location
          //       ?.toString()
          //       ?.toLowerCase(),
          // )
          ? `${viewRenewMotorPolicy?.intermediaryDetails?.code}`
          : selectedIntermediary?.intermediaryCode &&
            myIntermediaries?.find(
              (myIntermediary) =>
                myIntermediary?.intermediaryCode
                  ?.toString()
                  ?.trim()
                  ?.toLowerCase() ===
                selectedIntermediary?.intermediaryCode
                  ?.toString()
                  ?.toLowerCase(),
            ) &&
            myIntermediaries
              ?.find(
                (myIntermediary) =>
                  myIntermediary?.intermediaryCode
                    ?.toString()
                    ?.trim()
                    ?.toLowerCase() ===
                  selectedIntermediary?.intermediaryCode
                    ?.toString()
                    ?.toLowerCase(),
              )
              ?.businessLocations?.find(
                (businessLocation) =>
                  businessLocation?.code
                    ?.toString()
                    ?.toLowerCase() ===
                  selectedIntermediary?.branchOfficeCode
                    ?.toString()
                    ?.toLowerCase(),
              )
          ? `${selectedIntermediary?.intermediaryCode}`
          : myIntermediaries &&
            myIntermediaries?.length > 0 &&
            myIntermediaries[0]?.intermediaryCode
          ? `${myIntermediaries[0]?.intermediaryCode}`
          : '',
      businessLocation:
        viewRenewMotorPolicy?.intermediaryDetails?.code &&
        myIntermediaries?.find(
          (myIntermediary) =>
            myIntermediary?.intermediaryCode
              ?.toString()
              ?.trim()
              ?.toLowerCase() ===
            viewRenewMotorPolicy?.intermediaryDetails?.code
              ?.toString()
              ?.toLowerCase(),
        ) &&
        myIntermediaries
          ?.find(
            (myIntermediary) =>
              myIntermediary?.intermediaryCode
                ?.toString()
                ?.trim()
                ?.toLowerCase() ===
              viewRenewMotorPolicy?.intermediaryDetails?.code
                ?.toString()
                ?.toLowerCase(),
          )
          ?.businessLocations?.find(
            (businessLocation) =>
              businessLocation?.code?.toString()?.toLowerCase() ===
              viewRenewMotorPolicy?.intermediaryDetails?.location
                ?.toString()
                ?.toLowerCase(),
          )
          ? `${viewRenewMotorPolicy?.intermediaryDetails?.location}`
          : '',
      // businessLocation:
      //   viewRenewMotorPolicy?.intermediaryDetails?.code &&
      //   myIntermediaries?.find(
      //     (myIntermediary) =>
      //       myIntermediary?.intermediaryCode
      //         ?.toString()
      //         ?.trim()
      //         ?.toLowerCase() ===
      //       viewRenewMotorPolicy?.intermediaryDetails?.code
      //         ?.toString()
      //         ?.toLowerCase(),
      //   ) &&
      //   myIntermediaries
      //     ?.find(
      //       (myIntermediary) =>
      //         myIntermediary?.intermediaryCode
      //           ?.toString()
      //           ?.trim()
      //           ?.toLowerCase() ===
      //         viewRenewMotorPolicy?.intermediaryDetails?.code
      //           ?.toString()
      //           ?.toLowerCase(),
      //     )
      //     ?.businessLocations?.find(
      //       (businessLocation) =>
      //         businessLocation?.code?.toString()?.toLowerCase() ===
      //         viewRenewMotorPolicy?.intermediaryDetails?.location
      //           ?.toString()
      //           ?.toLowerCase(),
      //     )
      //     ? `${viewRenewMotorPolicy?.intermediaryDetails?.location}`
      //     : selectedIntermediary?.intermediaryCode &&
      //       myIntermediaries?.find(
      //         (myIntermediary) =>
      //           myIntermediary?.intermediaryCode
      //             ?.toString()
      //             ?.trim()
      //             ?.toLowerCase() ===
      //           selectedIntermediary?.intermediaryCode
      //             ?.toString()
      //             ?.toLowerCase(),
      //       ) &&
      //       myIntermediaries
      //         ?.find(
      //           (myIntermediary) =>
      //             myIntermediary?.intermediaryCode
      //               ?.toString()
      //               ?.trim()
      //               ?.toLowerCase() ===
      //             selectedIntermediary?.intermediaryCode
      //               ?.toString()
      //               ?.toLowerCase(),
      //         )
      //         ?.businessLocations?.find(
      //           (businessLocation) =>
      //             businessLocation?.code
      //               ?.toString()
      //               ?.toLowerCase() ===
      //             selectedIntermediary?.branchOfficeCode
      //               ?.toString()
      //               ?.toLowerCase(),
      //         )
      //     ? `${selectedIntermediary?.branchOfficeCode}`
      //     : myIntermediaries &&
      //       myIntermediaries?.length > 0 &&
      //       myIntermediaries[0]?.businessLocations &&
      //       myIntermediaries[0]?.businessLocations?.length > 0 &&
      //       myIntermediaries[0]?.businessLocations[0]?.code
      //     ? `${myIntermediaries[0]?.businessLocations[0]?.code}`
      //     : '',
      fieldUser: '',
      fieldUserList: [],
      initFetchFieldUserListRequired: true,
    },
    countEditsOpen:
      !viewRenewMotorPolicy?.vehicleTabDetails
        ?.vehicleRegistrationDetails?.registrationNumber ||
      viewRenewMotorPolicy?.vehicleTabDetails?.vehicleRegistrationDetails?.registrationNumber?.toLowerCase() ===
        'new' ||
      expandedCard.current
        .find(
          (exp) => exp?.cardName === 'vehicleAndRegistrationDetails',
        )
        ?.subSections?.includes('vehicleRegistrationDetails')
        ? 1
        : 0,
    proposerDetails,
    reviewAndConfirmTabDetails: {
      proposalPaymentType:
      //  viewRenewMotorPolicy
      //   ?.reviewAndConfirmTabDetails?.proposalPaymentType
      //   ? `${viewRenewMotorPolicy?.reviewAndConfirmTabDetails?.proposalPaymentType}`
      //   : 
        `${dataPaymentType?.ProposalPaymentTypeList[0]?.code}`,
      leadGenerator: viewRenewMotorPolicy?.reviewAndConfirmTabDetails
        ?.leadGenerator
        ? `${viewRenewMotorPolicy?.reviewAndConfirmTabDetails?.leadGenerator}`
        : '',
    },
    vehicleTabDetails: {
      ...viewRenewMotorPolicy?.vehicleTabDetails,
      vehicleRegistrationDetails: {
        registrationNumber: viewRenewMotorPolicy?.vehicleTabDetails
          ?.vehicleRegistrationDetails?.registrationNumber
          ? `${viewRenewMotorPolicy?.vehicleTabDetails?.vehicleRegistrationDetails?.registrationNumber}`
          : viewRenewMotorPolicy?.vehicleTabDetails?.vehicleDetails
              ?.rtoDetails?.rtoAuthorityCode
          ? `${viewRenewMotorPolicy?.vehicleTabDetails?.vehicleDetails?.rtoDetails?.rtoAuthorityCode}`
          : '',
        registrationNumberParts: {
          part1: viewRenewMotorPolicy?.vehicleTabDetails
            ?.vehicleRegistrationDetails?.registrationNumberParts
            ?.part1
            ? `${viewRenewMotorPolicy?.vehicleTabDetails?.vehicleRegistrationDetails?.registrationNumberParts?.part1}`
            : viewRenewMotorPolicy?.vehicleTabDetails?.vehicleDetails
                ?.rtoDetails?.rtoAuthorityCode
            ? `${viewRenewMotorPolicy?.vehicleTabDetails?.vehicleDetails?.rtoDetails?.rtoAuthorityCode?.slice(
                0,
                2,
              )}`
            : '',
          part2: viewRenewMotorPolicy?.vehicleTabDetails
            ?.vehicleRegistrationDetails?.registrationNumberParts
            ?.part2
            ? `${viewRenewMotorPolicy?.vehicleTabDetails?.vehicleRegistrationDetails?.registrationNumberParts?.part2}`
            : viewRenewMotorPolicy?.vehicleTabDetails?.vehicleDetails
                ?.rtoDetails?.rtoAuthorityCode
            ? `${viewRenewMotorPolicy?.vehicleTabDetails?.vehicleDetails?.rtoDetails?.rtoAuthorityCode?.slice(
                2,
              )}`
            : '',
          part3: viewRenewMotorPolicy?.vehicleTabDetails
            ?.vehicleRegistrationDetails?.registrationNumberParts
            ?.part3
            ? `${viewRenewMotorPolicy?.vehicleTabDetails?.vehicleRegistrationDetails?.registrationNumberParts?.part3}`
            : '',
          part4: viewRenewMotorPolicy?.vehicleTabDetails
            ?.vehicleRegistrationDetails?.registrationNumberParts
            ?.part4
            ? `${viewRenewMotorPolicy?.vehicleTabDetails?.vehicleRegistrationDetails?.registrationNumberParts?.part4}`
            : '',
        },
        isNewVehicle:
          viewRenewMotorPolicy?.vehicleTabDetails?.vehicleRegistrationDetails?.registrationNumber?.toLowerCase() ===
            'new' ||
          !viewRenewMotorPolicy?.vehicleTabDetails
            ?.vehicleRegistrationDetails?.registrationNumber
            ? true
            : false,
        engineNumber: viewRenewMotorPolicy?.vehicleTabDetails
          ?.vehicleRegistrationDetails?.engineNumber
          ? `${viewRenewMotorPolicy?.vehicleTabDetails?.vehicleRegistrationDetails?.engineNumber}`
          : '',
        chasisNumber: viewRenewMotorPolicy?.vehicleTabDetails
          ?.vehicleRegistrationDetails?.chasisNumber
          ? `${viewRenewMotorPolicy?.vehicleTabDetails?.vehicleRegistrationDetails?.chasisNumber}`
          : '',
        bodyIDV:viewRenewMotorPolicy?.quoteData?.bodyIDV,
        totalIDV:viewRenewMotorPolicy?.quoteData?.totalIDV
      },
      otherDiscounts:{
        creditScore:'No',
        idproof:'',
        idproofNo:'',
      }
    },
    additionalTabDetails: viewRenewMotorPolicy?.additionalTabDetails,
  };

  return (
    <>
      {viewRenewMotorPolicy && viewRenewMotorPolicy?.proposalNumber && (
        <QuantaFormik
          innerRef={props?.forwardedRenewFormRef}
          enableReinitialize={true}
          {...{
            initialValues,
            validate,
            onSubmit,
            validator: () => ({}),
          }}
        >
          <RenewReviewAndConfirmForm {...{ validate }} />
        </QuantaFormik>
      )}
    </>
  );
}
